(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kk-aari-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-aari-film')) {
    customElements.define('kk-aari-film', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-kk-aari-toggle]');
        if (!this.video || !this.toggle) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.visible = false;
        this.manualPlay = false;
        this.userPaused = false;
        this.blocked = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.video.muted = true;
        this.video.controls = false;
        this.toggle.hidden = false;
        this.updateToggle();
        const togglePlayback = () => {
          if (this.video.controls) return;
          if (this.video.paused) {
            this.manualPlay = true;
            this.userPaused = false;
            this.blocked = false;
            this.visible = true;
          } else {
            this.manualPlay = false;
            this.userPaused = true;
          }
          this.syncPlayback();
        };
        this.toggle.addEventListener('click', togglePlayback, options);
        this.video.addEventListener('click', togglePlayback, options);
        this.video.addEventListener('play', () => {
          this.toggle.dataset.started = 'true';
          this.updateToggle();
        }, options);
        this.video.addEventListener('pause', () => this.updateToggle(), options);
        this.video.addEventListener('error', () => {
          this.blocked = true;
          this.video.controls = true;
          this.toggle.hidden = true;
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.reducedMotion.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, options);
        this.connection?.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35;
            this.syncPlayback();
          }, { threshold: [0, .35] });
          this.observer.observe(this.video);
        }
      }

      canPlay() {
        return this.isConnected && this.visible && !document.hidden && !this.userPaused && !this.blocked &&
          (this.manualPlay || (this.dataset.autoplay === 'true' && !this.reducedMotion.matches && !this.connection?.saveData));
      }

      syncPlayback() {
        if (!this.canPlay()) {
          this.video.pause();
          return;
        }
        if (!this.video.paused || this.playPending) return;
        this.playPending = true;
        this.video.play().then(() => {
          if (!this.canPlay()) this.video.pause();
        }).catch(error => {
          if (error.name !== 'AbortError') this.blocked = true;
        }).finally(() => {
          this.playPending = false;
          this.updateToggle();
        });
      }

      updateToggle() {
        const playing = !this.video.paused;
        this.toggle.dataset.playing = String(playing);
        this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.abort?.abort();
        this.abort = null;
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-aari-scarf-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-aari-scarf-film')) {
    customElements.define('kk-aari-scarf-film', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-kk-aari-scarf-toggle]');
        if (!this.video || !this.toggle) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.visible = false;
        this.manualPlay = false;
        this.userPaused = false;
        this.blocked = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.video.muted = true;
        this.video.controls = false;
        this.toggle.hidden = false;
        this.updateToggle();
        const togglePlayback = () => {
          if (this.video.controls) return;
          if (this.video.paused) {
            this.manualPlay = true;
            this.userPaused = false;
            this.blocked = false;
            this.visible = true;
          } else {
            this.manualPlay = false;
            this.userPaused = true;
          }
          this.syncPlayback();
        };
        this.toggle.addEventListener('click', togglePlayback, options);
        this.video.addEventListener('click', togglePlayback, options);
        this.video.addEventListener('play', () => {
          this.toggle.dataset.started = 'true';
          this.updateToggle();
        }, options);
        this.video.addEventListener('pause', () => this.updateToggle(), options);
        this.video.addEventListener('error', () => {
          this.blocked = true;
          this.video.controls = true;
          this.toggle.hidden = true;
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.reducedMotion.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, options);
        this.connection?.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35;
            this.syncPlayback();
          }, { threshold: [0, .35] });
          this.observer.observe(this.video);
        }
      }

      canPlay() {
        return this.isConnected && this.visible && !document.hidden && !this.userPaused && !this.blocked &&
          (this.manualPlay || (this.dataset.autoplay === 'true' && !this.reducedMotion.matches && !this.connection?.saveData));
      }

      syncPlayback() {
        if (!this.canPlay()) {
          this.video.pause();
          return;
        }
        if (!this.video.paused || this.playPending) return;
        this.playPending = true;
        this.video.play().then(() => {
          if (!this.canPlay()) this.video.pause();
        }).catch(error => {
          if (error.name !== 'AbortError') this.blocked = true;
        }).finally(() => {
          this.playPending = false;
          this.updateToggle();
        });
      }

      updateToggle() {
        const playing = !this.video.paused;
        this.toggle.dataset.playing = String(playing);
        this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.abort?.abort();
        this.abort = null;
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-aari-scarf-making"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-aari-scarf')) {
    customElements.define('kk-aari-scarf', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.tabs = [...this.querySelectorAll('[data-stage]')];
        if (!this.panels.length) return;
        this.playButton = this.querySelector('[data-play]');
        this.playText = this.querySelector('[data-play-text]');
        this.progress = this.querySelector('[data-progress]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.duration = Math.max(5000, Number(this.dataset.duration) || 8000);
        this.index = 0;
        this.elapsed = 0;
        this.visible = false;
        this.playing = this.dataset.autoplay === 'true' && !this.motion.matches && !window.Shopify?.designMode;
        this.autoAdvance = true;
        this.still = !this.playing;
        this.panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[index].id);
          panel.tabIndex = 0;
        });
        this.querySelector('[data-controls]').hidden = false;
        this.querySelector('[data-navigation]').hidden = false;
        this.classList.add('is-enhanced');
        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-stage]');
          if (tab) {
            this.playing = !this.motion.matches;
            this.autoAdvance = false;
            this.still = !this.playing;
            this.select(Number(tab.dataset.stage));
          } else if (event.target.closest('[data-play]')) {
            this.playing = !this.playing && !this.motion.matches;
            if (this.playing) this.still = false;
            if (this.playing && this.elapsed >= this.duration) this.select(this.index === this.panels.length - 1 && this.autoAdvance ? 0 : this.index);
            this.sync();
          } else if (event.target.closest('[data-replay]')) {
            this.playing = !this.motion.matches;
            this.autoAdvance = true;
            this.still = !this.playing;
            this.select(0);
          }
        }, { signal });
        this.querySelector('[data-navigation]').addEventListener('keydown', event => {
          const current = this.tabs.indexOf(event.target.closest('[data-stage]'));
          if (current < 0) return;
          let next;
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          if (event.key === 'ArrowRight') next = (current + direction + this.tabs.length) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (current - direction + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.playing = false;
          this.still = true;
          this.select(next);
          this.tabs[next].focus();
        }, { signal });
        this.addEventListener('focusin', event => {
          if (!this.contains(event.relatedTarget) && !event.target.closest('[data-play], [data-replay]')) {
            this.playing = false;
            this.sync();
          }
        }, { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) { this.playing = false; this.still = true; }
          this.sync();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const selected = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
          if (selected < 0) return;
          this.playing = false;
          this.still = true;
          this.select(selected);
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: .15 });
        this.observer.observe(this);
        this.select(0);
      }
      select(index) {
        this.index = Math.max(0, Math.min(index, this.panels.length - 1));
        this.elapsed = 0;
        this.stamp = 0;
        this.panels[this.index].classList.remove('is-active');
        void this.panels[this.index].offsetWidth;
        this.panels.forEach((panel, position) => {
          const active = position === this.index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          this.tabs[position].setAttribute('aria-selected', String(active));
          this.tabs[position].tabIndex = active ? 0 : -1;
        });
        this.progress.style.transform = 'scaleX(0)';
        this.sync();
      }
      sync() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.stamp = 0;
        const running = this.playing && this.visible && !document.hidden && !this.motion.matches;
        this.classList.toggle('is-running', running);
        this.classList.toggle('is-paused', !this.playing);
        this.classList.toggle('is-still', this.still);
        this.playText.textContent = this.playing ? this.playButton.dataset.pauseLabel : this.playButton.dataset.playLabel;
        if (running) this.frame = requestAnimationFrame(time => this.tick(time));
      }
      tick(time) {
        if (this.stamp) this.elapsed += Math.min(time - this.stamp, 100);
        this.stamp = time;
        this.progress.style.transform = 'scaleX(' + Math.min(1, this.elapsed / this.duration) + ')';
        if (this.elapsed >= this.duration) {
          if (this.autoAdvance && this.index < this.panels.length - 1) this.select(this.index + 1);
          else { this.playing = false; this.sync(); }
          return;
        }
        this.frame = requestAnimationFrame(next => this.tick(next));
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-aari-shawl-making"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('kk-aari-shawl-journey')) {
    customElements.define('kk-aari-shawl-journey', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-journey-track]');
        this.viewport = this.querySelector('[data-journey-viewport]');
        this.needle = this.querySelector('[data-journey-needle]');
        this.stages = Array.from(this.querySelectorAll('[data-journey-stage]'));
        this.nodes = Array.from(this.querySelectorAll('[data-journey-choose]'));
        this.paths = Array.from(this.querySelectorAll('[data-journey-guide]'));
        this.flourish = this.querySelector('[data-journey-final-guide]');
        this.activePointers = new Set();
        this.loopButton = this.querySelector('[data-journey-loop]');
        this.jamaCompleted = Array.from(this.querySelectorAll('[data-jama-completed-clip]'));
        this.jamaMotion = Array.from(this.querySelectorAll('[data-jama-motion-clip]'));
        this.jamaLayers = Array.from(this.querySelectorAll('[data-jama-motion-layer]'));
        this.stitchDetails = this.jamaLayers.map(layer => Array.from(layer.querySelectorAll('[data-stitch-detail]'), element => ({
          element, end: Number(element.dataset.stitchEnd), duration: Number(element.dataset.stitchDuration), delay: Number(element.dataset.stitchDelay), parent: Number(element.dataset.stitchParent), began: null, progress: -1
        })));
        this.stitchTime = -1;
        this.loopElapsed = 0;
        this.loopVisible = false;
        this.loopFocus = false;
        this.previous = this.querySelector('[data-journey-previous]');
        this.next = this.querySelector('[data-journey-next]');
        this.counter = this.querySelector('[data-journey-counter]');
        this.status = this.querySelector('[data-journey-status]');
        this.progress = this.querySelector('[data-journey-progress]');
        if (!this.track || !this.stages.length || !this.needle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.lengths = this.paths.map(path => path.getTotalLength());
        this.flourishLength = this.flourish?.getTotalLength() || 0;
        this.position = 0;
        this.target = 0;
        this.maxReached = this.maxReached || 0;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.nodes.forEach((node, index) => {
          node.disabled = false;
          node.addEventListener('click', () => this.select(index), options);
        });
        this.track.addEventListener('scroll', () => {
          if (this.animating || performance.now() < (this.ignoreScrollUntil || 0)) return;
          this.stopLoop(true);
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.scheduleSettle();
        }, { ...options, passive: true });
        const interrupt = () => {
          this.stopLoop(true);
          this.stopMotion();
          this.ignoreScrollUntil = 0;
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.queueLoop(4000);
        };
        this.track.addEventListener('pointerdown', event => {
          this.activePointers.add(event.pointerId);
          this.loopFocus = false;
          interrupt();
        }, { ...options, passive: true });
        const release = event => {
          if (this.activePointers.delete(event.pointerId)) this.scheduleSettle();
        };
        document.addEventListener('pointerup', release, { ...options, passive: true });
        document.addEventListener('pointercancel', release, { ...options, passive: true });
        this.track.addEventListener('wheel', interrupt, { ...options, passive: true });
        this.track.addEventListener('keydown', event => this.onKey(event), options);
        this.reduceMotion.addEventListener('change', () => {
          this.select(this.target, false);
          this.loopButton.hidden = this.reduceMotion.matches;
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopLoop();
            if (this.animating) this.select(this.target, false);
          } else this.queueLoop();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.stages.findIndex(stage => stage.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.controller) this.select(this.target, false);
          });
        });
        this.resizeObserver.observe(this.track);
        this.stages.forEach(stage => this.resizeObserver.observe(stage));
        this.querySelector('[data-journey-controls]').hidden = false;
        this.querySelector('[data-journey-reading]').hidden = false;
        this.loopButton.hidden = this.reduceMotion.matches;
        this.loopButton.addEventListener('click', () => {
          this.loopPaused = !this.loopPaused;
          this.loopButton.setAttribute('aria-label', this.loopPaused ? this.loopButton.dataset.playLabel : this.loopButton.dataset.pauseLabel);
          this.loopButton.querySelector('[data-loop-pause]').hidden = this.loopPaused;
          this.loopButton.querySelector('[data-loop-play]').hidden = !this.loopPaused;
          if (this.loopPaused) this.stopLoop();
          else this.queueLoop(0);
        }, options);
        this.track.addEventListener('focusin', event => {
          this.loopFocus = event.target.matches(':focus-visible');
          if (this.loopFocus) this.stopLoop();
          else this.queueLoop();
        }, options);
        this.track.addEventListener('focusout', event => {
          if (!this.track.contains(event.relatedTarget)) { this.loopFocus = false; this.queueLoop(); }
        }, options);
        this.loopObserver = new IntersectionObserver(entries => {
          this.loopVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          if (this.loopVisible) this.queueLoop();
          else this.stopLoop();
        }, { threshold: [0, .3] });
        this.loopObserver.observe(this.viewport);
        this.classList.add('is-ready');
        this.select(Math.round(this.indexFromScroll()), false);
      }

      scheduleSettle() {
        clearTimeout(this.settleTimer);
        if (!this.activePointers.size) {
          this.settleTimer = setTimeout(() => {
            if (!this.activePointers.size) this.select(this.target);
          }, 170);
        }
      }

      geometry() {
        const bounds = this.track.getBoundingClientRect();
        const left = bounds.left + this.track.clientLeft;
        const right = left + this.track.clientWidth;
        const rects = this.stages.map(stage => stage.getBoundingClientRect());
        const first = rects[0];
        const last = rects[rects.length - 1];
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        return {
          left, right, rects, rtl,
          leftRoom: Math.max(0, left - Math.min(first.left, last.left)),
          rightRoom: Math.max(0, Math.max(first.right, last.right) - right)
        };
      }

      indexFromScroll() {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        return maximum > 1 ? (g.rtl ? g.rightRoom : g.leftRoom) / maximum * (this.stages.length - 1) : this.target || 0;
      }

      setScrollFraction(fraction) {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        const current = g.rtl ? g.rightRoom : g.leftRoom;
        const desired = Math.max(0, Math.min(1, fraction)) * maximum;
        this.track.scrollBy({ left: (desired - current) * (g.rtl ? -1 : 1), behavior: 'instant' });
      }

      move(direction) {
        this.select(this.target + direction);
      }

      select(index, animate = true) {
        this.stopLoop(true);
        this.stopMotion();
        const last = this.stages.length - 1;
        const next = Math.max(0, Math.min(last, index));
        const start = this.position;
        const scrollStart = last ? this.indexFromScroll() / last : 0;
        this.target = next;
        this.previous.disabled = next === 0;
        this.next.disabled = next === last;
        if (!animate || this.reduceMotion.matches || Math.abs(next - start) < .008) {
          this.position = next;
          this.ignoreScrollUntil = performance.now() + 100;
          this.setScrollFraction(last ? next / last : 0);
          this.update();
          this.arrive(next);
          return;
        }
        this.animating = true;
        const began = performance.now();
        const duration = Math.min(1100, 650 + Math.abs(next - start) * 70);
        const ease = value => value < .5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
        const frame = now => {
          if (!this.isConnected || !this.controller) return;
          const t = Math.min(1, (now - began) / duration);
          this.position = start + (next - start) * ease(t);
          const scrollEase = ease(t);
          this.setScrollFraction(scrollStart + ((last ? next / last : 0) - scrollStart) * scrollEase);
          this.update();
          if (t < 1) this.motionFrame = requestAnimationFrame(frame);
          else {
            this.animating = false;
            this.motionFrame = null;
            this.ignoreScrollUntil = performance.now() + 100;
            this.arrive(next);
          }
        };
        this.motionFrame = requestAnimationFrame(frame);
      }

      arrive(index) {
        this.stages.forEach((stage, i) => {
          stage.classList.toggle('is-current', i === index);
          if (i === index) this.nodes[i].setAttribute('aria-current', 'step');
          else this.nodes[i].removeAttribute('aria-current');
        });
        this.stages[index].classList.add('is-stitched');
        this.queueLoop(3000);
      }

      onKey(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target !== this.track && !this.nodes.includes(event.target)) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.loopFocus = true;
        if (event.key === 'Home') this.select(0);
        else if (event.key === 'End') this.select(this.stages.length - 1);
        else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.geometry().rtl ? -1 : 1));
      }

      needlePoint(position) {
        const last = this.stages.length - 1;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const viewport = this.viewport.getBoundingClientRect();
        if (!this.paths.length) {
          const node = this.nodes[0].getBoundingClientRect();
          return { x: node.left - viewport.left + node.width / 2 + (rtl ? -24 : 24), y: node.top - viewport.top + node.height / 2, angle: rtl ? 180 : 0 };
        }
        const visual = position + .085;
        if (visual > last && this.flourish) {
          const bounds = this.flourish.ownerSVGElement.getBoundingClientRect();
          const distance = Math.min(1, (visual - last) / .085) * this.flourishLength;
          const project = value => {
            const p = this.flourish.getPointAtLength(Math.max(0, Math.min(this.flourishLength, value)));
            return { x: (rtl ? bounds.right - p.x / 80 * bounds.width : bounds.left + p.x / 80 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
          };
          const point = project(distance);
          const before = project(distance - 1);
          const after = project(distance + 1);
          return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
        }
        const segment = Math.min(last - 1, Math.max(0, Math.floor(visual)));
        const progress = Math.min(1, visual - segment);
        const path = this.paths[segment];
        const length = this.lengths[segment];
        const bounds = path.ownerSVGElement.getBoundingClientRect();
        const project = distance => {
          const p = path.getPointAtLength(Math.max(0, Math.min(length, distance)));
          return { x: (rtl ? bounds.right - p.x / 240 * bounds.width : bounds.left + p.x / 240 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
        };
        const distance = progress * length;
        const point = project(distance);
        const before = project(distance - 1);
        const after = project(distance + 1);
        return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
      }

      stageFrontX(index, fraction) {
        const final = index === this.stages.length - 1;
        const width = final ? 80 : 240;
        const progress = Math.max(0, Math.min(1, fraction));
        if (progress === 0 || (!final && progress === 1)) return progress * width;
        const guide = final ? this.flourish : this.paths[index];
        const length = final ? this.flourishLength : this.lengths[index];
        return guide ? guide.getPointAtLength(progress * length).x : progress * width;
      }

      resetStitchDetails() {
        this.stitchTime = -1;
        this.stitchDetails?.forEach(strokes => strokes.forEach(stroke => {
          stroke.began = null;
          stroke.progress = -1;
          stroke.element.style.strokeDashoffset = '1';
          stroke.element.style.opacity = '0';
        }));
      }

      drawStitchDetails(index, front, from, time) {
        const scale = index === this.stages.length - 1 ? 1 : 2 / 3;
        const head = front / scale;
        const start = from / scale;
        const strokes = this.stitchDetails[index];
        strokes.forEach(stroke => {
          if (stroke.end <= start) return;
          const parent = strokes[stroke.parent];
          const outlineReady = !parent || parent.end <= start || parent.progress >= .8;
          if (stroke.began === null && head >= stroke.end + .35 && outlineReady) stroke.began = time + stroke.delay;
          const progress = stroke.began === null ? 0 : Math.max(0, Math.min(1, (time - stroke.began) / stroke.duration));
          if (Math.abs(progress - stroke.progress) < .0001) return;
          stroke.progress = progress;
          stroke.element.style.strokeDashoffset = String(1 - progress);
          stroke.element.style.opacity = progress > 0 ? '1' : '0';
        });
      }

      update() {
        const { left, right, rects } = this.geometry();
        if (!this.track.clientWidth) return;
        this.previous.disabled = this.target === 0;
        this.next.disabled = this.target === this.stages.length - 1;
        let visible = rects.reduce((indices, rect, index) => {
          const overlap = Math.max(0, Math.min(rect.right, right) - Math.max(rect.left, left));
          if (overlap >= Math.min(rect.width, right - left) * .5) indices.push(index);
          return indices;
        }, []);
        if (!visible.length) visible = [this.target];
        const start = String(visible[0] + 1).padStart(2, '0');
        const end = String(visible[visible.length - 1] + 1).padStart(2, '0');
        const count = String(this.stages.length).padStart(2, '0');
        const compact = start + '–' + end + ' / ' + count;
        if (this.counter.textContent !== compact) {
          this.counter.textContent = compact;
          this.status.textContent = this.dataset.visibleStages.replaceAll('[start]', start).replaceAll('[end]', end).replaceAll('[count]', count);
        }
        this.maxReached = Math.max(this.maxReached, this.position + .085);
        this.jamaCompleted.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const progress = Math.max(0, Math.min(1, (this.maxReached - index) / (final ? .085 : 1)));
          clip.setAttribute('width', String(this.stageFrontX(index, progress)));
        });
        this.progress.style.setProperty('--kk-sj-progress', String(Math.min(1, (this.maxReached + 1) / this.stages.length)));
        this.stages.forEach((stage, index) => {
          stage.style.setProperty('--kk-sj-stage-progress', String(Math.max(0, Math.min(1, this.maxReached - index))));
          if (this.maxReached >= index + .085) stage.classList.add('is-stitched');
        });
        this.renderNeedle(this.position, this.position >= this.stages.length - 1 ? 0 : 1);
      }

      renderNeedle(position, opacity = 1, time = 0) {
        if (this.reduceMotion.matches || opacity <= 0) {
          this.needle.hidden = true;
          return;
        }
        const point = this.needlePoint(position);
        this.needle.hidden = false;
        this.needle.style.opacity = String(opacity);
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const oscillation = Math.sin(time * Math.PI * 2 / 680) * 3;
        const tilt = direction * (18 + oscillation);
        this.needle.style.transform = 'translate(' + point.x + 'px,' + point.y + 'px) rotate(' + (point.angle + tilt) + 'deg)';
      }

      canLoop() {
        return this.loopButton && this.isConnected && this.controller && this.loopVisible && !this.loopPaused && !this.loopFocus && !this.reduceMotion.matches && !document.hidden && !this.animating && !this.activePointers.size && this.paths.length;
      }

      queueLoop(delay = 1200) {
        clearTimeout(this.loopTimer);
        if (!this.canLoop() || this.loopFrame) return;
        this.loopTimer = setTimeout(() => {
          if (!this.canLoop()) return;
          if (!this.loopRangeCache) this.loopRangeCache = this.makeLoopPlan(this.visibleLoopRange());
          if (this.loopRangeCache.end - this.loopRangeCache.start < .03) return;
          this.loopStamp = 0;
          this.loopFrame = requestAnimationFrame(now => this.drawLoop(now));
        }, delay);
      }

      visibleLoopRange() {
        const bounds = this.viewport.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const last = this.stages.length - 1;
        const margin = Math.min(46, bounds.width / 5);
        let start = null, end = null;
        this.paths.forEach((path, index) => {
          const rect = path.ownerSVGElement.getBoundingClientRect();
          if (rect.right < bounds.left || rect.left > bounds.right) return;
          const length = this.lengths[index];
          for (let sample = 0; sample <= 120; sample++) {
            const progress = sample / 120;
            const point = path.getPointAtLength(length * progress);
            const x = (rtl ? rect.right - point.x / 240 * rect.width : rect.left + point.x / 240 * rect.width) - bounds.left;
            const position = Math.max(0, Math.min(last, index + progress - .085));
            if (x >= margin && x <= bounds.width - margin) {
              if (start === null) start = position;
              end = position;
            }
          }
        });
        if (this.flourish) {
          const final = this.needlePoint(last);
          if (final.x >= margin && final.x <= bounds.width - margin) end = last;
        }
        return { start: start ?? 0, end: end ?? start ?? 0, duration: Math.max(7200, Math.min(16500, (bounds.width - 92) / .075)) };
      }

      makeLoopPlan(range) {
        const boundaries = this.nodes.map((node, index) => index - .085).filter(position => position > range.start && position < range.end);
        const positions = [range.start, ...boundaries, range.end];
        const points = positions.map(position => this.needlePoint(position));
        const total = Math.abs(points[points.length - 1].x - points[0].x) || 1;
        let elapsed = 0;
        const segments = positions.slice(1).map((position, index) => {
          const duration = range.duration * Math.abs(points[index + 1].x - points[index].x) / total;
          const segment = { from: positions[index], to: position, at: elapsed, duration };
          elapsed += duration;
          return segment;
        }).filter(segment => segment.duration > 0);
        return { ...range, duration: elapsed, segments };
      }

      loopPose(time, plan) {
        const segment = plan.segments.find(item => time < item.at + item.duration);
        if (!segment) return plan.end;
        const progress = Math.max(0, Math.min(1, (time - segment.at) / segment.duration));
        return segment.from + (segment.to - segment.from) * progress;
      }

      drawLoop(now) {
        this.loopFrame = null;
        if (!this.canLoop()) { this.loopStamp = 0; return; }
        if (this.loopStamp) this.loopElapsed += Math.min(64, now - this.loopStamp);
        this.loopStamp = now;
        const { start, duration } = this.loopRangeCache;
        const time = this.loopElapsed % (duration + 4200);
        if (time < this.stitchTime) this.resetStitchDetails();
        this.stitchTime = time;
        const position = this.loopPose(time, this.loopRangeCache);
        const opacity = Math.max(0, Math.min(1, time / 400, (duration + 4000 - time) / 1000));
        const needleOpacity = Math.max(0, Math.min(opacity, (duration - time) / 240));
        this.renderNeedle(position, needleOpacity, time);
        const visual = position + .085;
        const tail = start + .085;
        this.jamaMotion.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const span = final ? .085 : 1;
          const width = final ? 80 : 240;
          const from = Math.max(0, Math.min(1, (tail - index) / span));
          const rawFront = this.stageFrontX(index, (visual - index) / span);
          const fromX = this.stageFrontX(index, from);
          const completed = Math.max(0, Math.min(from, (this.maxReached - index) / span));
          this.jamaCompleted[index].setAttribute('width', String(this.stageFrontX(index, completed)));
          const front = Math.max(fromX, Math.min(width, rawFront));
          const edge = 'M' + fromX + ' 0H' + front + 'V48H' + fromX + 'Z';
          clip.setAttribute('d', edge);
          this.drawStitchDetails(index, rawFront, fromX, time);
          this.jamaLayers[index].style.opacity = String(rawFront > fromX ? opacity : 0);
        });
        this.loopFrame = requestAnimationFrame(next => this.drawLoop(next));
      }

      stopLoop(reset = false) {
        cancelAnimationFrame(this.loopFrame);
        clearTimeout(this.loopTimer);
        this.loopFrame = null;
        this.loopStamp = 0;
        if (reset) {
          this.resetStitchDetails();
          this.loopElapsed = 0;
          this.loopRangeCache = null;
          this.jamaLayers?.forEach(layer => { layer.style.opacity = '0'; });
          this.jamaMotion?.forEach(clip => { clip.setAttribute('d', 'M0 0'); });
        }
      }

      stopMotion() {
        cancelAnimationFrame(this.motionFrame);
        clearTimeout(this.settleTimer);
        this.motionFrame = null;
        this.animating = false;
      }

      disconnectedCallback() {
        this.stopLoop();
        this.loopObserver?.disconnect();
        this.stopMotion();
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-bedcover-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-bedcover-film')) {
    customElements.define('kk-bedcover-film', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.video.muted = true;
        this.video.controls = false;
        this.button.hidden = false;
        const sync = () => {
          this.toggleAttribute('data-paused', this.video.paused);
          this.button.querySelector('span').textContent = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        };
        this.video.addEventListener('play', sync, options);
        this.video.addEventListener('pause', sync, options);
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (this.userPaused) this.video.pause();
          else this.video.play().catch(sync);
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const visible = entries[0].isIntersecting;
            if (visible && !this.userPaused) this.video.play().catch(sync);
            else this.video.pause();
          }, { threshold: 0.15 });
          this.observer.observe(this.video);
        } else if (this.userPaused) this.video.pause();
        sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-carpet-certificate"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-carpet-certificate')) {
    customElements.define('kk-carpet-certificate', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const dialog = this.querySelector('dialog');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        this.dialog = dialog;
        const options = { signal: this.controller.signal };
        this.querySelectorAll('[data-certificate-open]').forEach(link => {
          link.setAttribute('aria-haspopup', 'dialog');
          link.setAttribute('aria-controls', dialog.id);
          link.addEventListener('click', event => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || dialog.open) return;
            event.preventDefault();
            this.opener = link;
            this.previousOverflow = document.body.style.getPropertyValue('overflow');
            this.previousOverflowPriority = document.body.style.getPropertyPriority('overflow');
            dialog.showModal();
            this.suspendedFilms = Array.from(document.querySelectorAll('kk-carpet-film')).filter(film => typeof film.suspendPlayback === 'function' && typeof film.resumePlayback === 'function' && !film.suspended);
            this.suspendedFilms.forEach(film => film.suspendPlayback());
            document.body.style.setProperty('overflow', 'hidden');
            this.loadFullDocument();
          }, options);
        });
        dialog.querySelector('.kk-carpet-auth__close').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          this.restoreScrolling();
          this.restoreFilmPlayback();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
      }
      loadFullDocument() {
        const documentImage = this.dialog.querySelector('[data-full-src]');
        const fullSource = documentImage?.dataset.fullSrc;
        if (!fullSource || this.fullImageLoader) return;
        const loader = new Image();
        this.fullImageLoader = loader;
        const options = { once: true, signal: this.controller.signal };
        loader.addEventListener('load', async () => {
          try { await loader.decode(); } catch (_) {}
          if (!this.isConnected || this.fullImageLoader !== loader) return;
          documentImage.src = fullSource;
          documentImage.removeAttribute('data-full-src');
          this.fullImageLoader = null;
        }, options);
        loader.addEventListener('error', () => {
          if (this.fullImageLoader === loader) this.fullImageLoader = null;
        }, options);
        loader.src = fullSource;
      }
      restoreFilmPlayback() {
        if (!this.suspendedFilms) return;
        const films = this.suspendedFilms;
        this.suspendedFilms = null;
        films.forEach(film => { if (film.isConnected) film.resumePlayback(); });
      }
      restoreScrolling() {
        if (this.previousOverflow === undefined) return;
        if (this.previousOverflow) document.body.style.setProperty('overflow', this.previousOverflow, this.previousOverflowPriority || '');
        else document.body.style.removeProperty('overflow');
        this.previousOverflow = undefined;
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.restoreFilmPlayback();
        this.restoreScrolling();
        this.controller?.abort();
        this.controller = null;
        this.fullImageLoader = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-carpet-making"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('kk-carpet-journey')) {
    customElements.define('kk-carpet-journey', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-journey-track]');
        this.viewport = this.querySelector('[data-journey-viewport]');
        this.shuttle = this.querySelector('[data-journey-shuttle]');
        this.stages = Array.from(this.querySelectorAll('[data-journey-stage]'));
        this.nodes = Array.from(this.querySelectorAll('[data-journey-choose]'));
        this.paths = Array.from(this.querySelectorAll('[data-journey-guide]'));
        this.flourish = this.querySelector('[data-journey-final-guide]');
        this.activePointers = new Set();
        this.loopButton = this.querySelector('[data-journey-loop]');
        this.weaveCompleted = Array.from(this.querySelectorAll('[data-weave-completed-clip]'));
        this.weaveMotion = Array.from(this.querySelectorAll('[data-weave-motion-clip]'));
        this.weaveLayers = Array.from(this.querySelectorAll('[data-weave-motion-layer]'));
        this.stitchDetails = this.weaveLayers.map(layer => Array.from(layer.querySelectorAll('[data-stitch-detail]'), element => ({
          element, end: Number(element.dataset.stitchEnd), duration: Number(element.dataset.stitchDuration), delay: Number(element.dataset.stitchDelay), parent: Number(element.dataset.stitchParent), began: null, progress: -1
        })));
        this.stitchTime = -1;
        this.loopElapsed = 0;
        this.loopVisible = false;
        this.loopFocus = false;
        this.previous = this.querySelector('[data-journey-previous]');
        this.next = this.querySelector('[data-journey-next]');
        this.counter = this.querySelector('[data-journey-counter]');
        this.status = this.querySelector('[data-journey-status]');
        this.progress = this.querySelector('[data-journey-progress]');
        if (!this.track || !this.stages.length || !this.shuttle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.lengths = this.paths.map(path => path.getTotalLength());
        this.flourishLength = this.flourish?.getTotalLength() || 0;
        this.position = 0;
        this.target = 0;
        this.maxReached = this.maxReached || 0;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.nodes.forEach((node, index) => {
          node.disabled = false;
          node.addEventListener('click', () => this.select(index), options);
        });
        this.track.addEventListener('scroll', () => {
          if (this.animating || performance.now() < (this.ignoreScrollUntil || 0)) return;
          this.stopLoop(true);
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.scheduleSettle();
        }, { ...options, passive: true });
        const interrupt = () => {
          this.stopLoop(true);
          this.stopMotion();
          this.ignoreScrollUntil = 0;
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.queueLoop(4000);
        };
        this.track.addEventListener('pointerdown', event => {
          this.activePointers.add(event.pointerId);
          this.loopFocus = false;
          interrupt();
        }, { ...options, passive: true });
        const release = event => {
          if (this.activePointers.delete(event.pointerId)) this.scheduleSettle();
        };
        document.addEventListener('pointerup', release, { ...options, passive: true });
        document.addEventListener('pointercancel', release, { ...options, passive: true });
        this.track.addEventListener('wheel', interrupt, { ...options, passive: true });
        this.track.addEventListener('keydown', event => this.onKey(event), options);
        this.reduceMotion.addEventListener('change', () => {
          this.select(this.target, false);
          this.loopButton.hidden = this.reduceMotion.matches;
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopLoop();
            if (this.animating) this.select(this.target, false);
          } else this.queueLoop();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.stages.findIndex(stage => stage.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.controller) this.select(this.target, false);
          });
        });
        this.resizeObserver.observe(this.track);
        this.stages.forEach(stage => this.resizeObserver.observe(stage));
        this.querySelector('[data-journey-controls]').hidden = false;
        this.querySelector('[data-journey-reading]').hidden = false;
        this.loopButton.hidden = this.reduceMotion.matches;
        this.loopButton.addEventListener('click', () => {
          this.loopPaused = !this.loopPaused;
          this.loopButton.setAttribute('aria-label', this.loopPaused ? this.loopButton.dataset.playLabel : this.loopButton.dataset.pauseLabel);
          this.loopButton.querySelector('[data-loop-pause]').hidden = this.loopPaused;
          this.loopButton.querySelector('[data-loop-play]').hidden = !this.loopPaused;
          if (this.loopPaused) this.stopLoop();
          else this.queueLoop(0);
        }, options);
        this.track.addEventListener('focusin', event => {
          this.loopFocus = event.target.matches(':focus-visible');
          if (this.loopFocus) this.stopLoop();
          else this.queueLoop();
        }, options);
        this.track.addEventListener('focusout', event => {
          if (!this.track.contains(event.relatedTarget)) { this.loopFocus = false; this.queueLoop(); }
        }, options);
        this.loopObserver = new IntersectionObserver(entries => {
          this.loopVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          if (this.loopVisible) this.queueLoop();
          else this.stopLoop();
        }, { threshold: [0, .3] });
        this.loopObserver.observe(this.viewport);
        this.classList.add('is-ready');
        this.select(Math.round(this.indexFromScroll()), false);
      }

      scheduleSettle() {
        clearTimeout(this.settleTimer);
        if (!this.activePointers.size) {
          this.settleTimer = setTimeout(() => {
            if (!this.activePointers.size) this.select(this.target);
          }, 170);
        }
      }

      geometry() {
        const bounds = this.track.getBoundingClientRect();
        const left = bounds.left + this.track.clientLeft;
        const right = left + this.track.clientWidth;
        const rects = this.stages.map(stage => stage.getBoundingClientRect());
        const first = rects[0];
        const last = rects[rects.length - 1];
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        return {
          left, right, rects, rtl,
          leftRoom: Math.max(0, left - Math.min(first.left, last.left)),
          rightRoom: Math.max(0, Math.max(first.right, last.right) - right)
        };
      }

      indexFromScroll() {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        return maximum > 1 ? (g.rtl ? g.rightRoom : g.leftRoom) / maximum * (this.stages.length - 1) : this.target || 0;
      }

      setScrollFraction(fraction) {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        const current = g.rtl ? g.rightRoom : g.leftRoom;
        const desired = Math.max(0, Math.min(1, fraction)) * maximum;
        this.track.scrollBy({ left: (desired - current) * (g.rtl ? -1 : 1), behavior: 'instant' });
      }

      move(direction) {
        this.select(this.target + direction);
      }

      select(index, animate = true) {
        this.stopLoop(true);
        this.stopMotion();
        const last = this.stages.length - 1;
        const next = Math.max(0, Math.min(last, index));
        const start = this.position;
        const scrollStart = last ? this.indexFromScroll() / last : 0;
        this.target = next;
        this.previous.disabled = next === 0;
        this.next.disabled = next === last;
        if (!animate || this.reduceMotion.matches || Math.abs(next - start) < .008) {
          this.position = next;
          this.ignoreScrollUntil = performance.now() + 100;
          this.setScrollFraction(last ? next / last : 0);
          this.update();
          this.arrive(next);
          return;
        }
        this.animating = true;
        const began = performance.now();
        const duration = Math.min(1100, 650 + Math.abs(next - start) * 70);
        const ease = value => value < .5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
        const frame = now => {
          if (!this.isConnected || !this.controller) return;
          const t = Math.min(1, (now - began) / duration);
          this.position = start + (next - start) * ease(t);
          const scrollEase = ease(t);
          this.setScrollFraction(scrollStart + ((last ? next / last : 0) - scrollStart) * scrollEase);
          this.update();
          if (t < 1) this.motionFrame = requestAnimationFrame(frame);
          else {
            this.animating = false;
            this.motionFrame = null;
            this.ignoreScrollUntil = performance.now() + 100;
            this.arrive(next);
          }
        };
        this.motionFrame = requestAnimationFrame(frame);
      }

      arrive(index) {
        this.stages.forEach((stage, i) => {
          stage.classList.toggle('is-current', i === index);
          if (i === index) this.nodes[i].setAttribute('aria-current', 'step');
          else this.nodes[i].removeAttribute('aria-current');
        });
        this.stages[index].classList.add('is-stitched');
        this.queueLoop(3000);
      }

      onKey(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target !== this.track && !this.nodes.includes(event.target)) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.loopFocus = true;
        if (event.key === 'Home') this.select(0);
        else if (event.key === 'End') this.select(this.stages.length - 1);
        else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.geometry().rtl ? -1 : 1));
      }

      shuttlePoint(position) {
        const last = this.stages.length - 1;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const viewport = this.viewport.getBoundingClientRect();
        if (!this.paths.length) {
          const node = this.nodes[0].getBoundingClientRect();
          return { x: node.left - viewport.left + node.width / 2 + (rtl ? -24 : 24), y: node.top - viewport.top + node.height / 2, angle: rtl ? 180 : 0 };
        }
        const visual = position + .085;
        if (visual > last && this.flourish) {
          const bounds = this.flourish.ownerSVGElement.getBoundingClientRect();
          const distance = Math.min(1, (visual - last) / .085) * this.flourishLength;
          const project = value => {
            const p = this.flourish.getPointAtLength(Math.max(0, Math.min(this.flourishLength, value)));
            return { x: (rtl ? bounds.right - p.x / 80 * bounds.width : bounds.left + p.x / 80 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
          };
          const point = project(distance);
          const before = project(distance - 1);
          const after = project(distance + 1);
          return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
        }
        const segment = Math.min(last - 1, Math.max(0, Math.floor(visual)));
        const progress = Math.min(1, visual - segment);
        const path = this.paths[segment];
        const length = this.lengths[segment];
        const bounds = path.ownerSVGElement.getBoundingClientRect();
        const project = distance => {
          const p = path.getPointAtLength(Math.max(0, Math.min(length, distance)));
          return { x: (rtl ? bounds.right - p.x / 240 * bounds.width : bounds.left + p.x / 240 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
        };
        const distance = progress * length;
        const point = project(distance);
        const before = project(distance - 1);
        const after = project(distance + 1);
        return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
      }

      stageFrontX(index, fraction) {
        const final = index === this.stages.length - 1;
        const width = final ? 80 : 240;
        const progress = Math.max(0, Math.min(1, fraction));
        if (progress === 0 || (!final && progress === 1)) return progress * width;
        const guide = final ? this.flourish : this.paths[index];
        const length = final ? this.flourishLength : this.lengths[index];
        return guide ? guide.getPointAtLength(progress * length).x : progress * width;
      }

      resetStitchDetails() {
        this.stitchTime = -1;
        this.stitchDetails?.forEach(strokes => strokes.forEach(stroke => {
          stroke.began = null;
          stroke.progress = -1;
          stroke.element.style.strokeDashoffset = '1';
          stroke.element.style.opacity = '0';
        }));
      }

      drawStitchDetails(index, front, from, time) {
        const scale = index === this.stages.length - 1 ? 1 : 2 / 3;
        const head = front / scale;
        const start = from / scale;
        const strokes = this.stitchDetails[index];
        strokes.forEach(stroke => {
          if (stroke.end <= start) return;
          const parent = strokes[stroke.parent];
          const outlineReady = !parent || parent.end <= start || parent.progress >= .8;
          if (stroke.began === null && head >= stroke.end + .35 && outlineReady) stroke.began = time + stroke.delay;
          const progress = stroke.began === null ? 0 : Math.max(0, Math.min(1, (time - stroke.began) / stroke.duration));
          if (Math.abs(progress - stroke.progress) < .0001) return;
          stroke.progress = progress;
          stroke.element.style.strokeDashoffset = String(1 - progress);
          stroke.element.style.opacity = progress > 0 ? '1' : '0';
        });
      }

      update() {
        const { left, right, rects } = this.geometry();
        if (!this.track.clientWidth) return;
        this.previous.disabled = this.target === 0;
        this.next.disabled = this.target === this.stages.length - 1;
        let visible = rects.reduce((indices, rect, index) => {
          const overlap = Math.max(0, Math.min(rect.right, right) - Math.max(rect.left, left));
          if (overlap >= Math.min(rect.width, right - left) * .5) indices.push(index);
          return indices;
        }, []);
        if (!visible.length) visible = [this.target];
        const start = String(visible[0] + 1).padStart(2, '0');
        const end = String(visible[visible.length - 1] + 1).padStart(2, '0');
        const count = String(this.stages.length).padStart(2, '0');
        const compact = start + '–' + end + ' / ' + count;
        if (this.counter.textContent !== compact) {
          this.counter.textContent = compact;
          this.status.textContent = this.dataset.visibleStages.replaceAll('[start]', start).replaceAll('[end]', end).replaceAll('[count]', count);
        }
        this.maxReached = Math.max(this.maxReached, this.position + .085);
        this.weaveCompleted.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const progress = Math.max(0, Math.min(1, (this.maxReached - index) / (final ? .085 : 1)));
          clip.setAttribute('width', String(this.stageFrontX(index, progress)));
        });
        this.progress.style.setProperty('--kk-cj-progress', String(Math.min(1, (this.maxReached + 1) / this.stages.length)));
        this.stages.forEach((stage, index) => {
          stage.style.setProperty('--kk-cj-stage-progress', String(Math.max(0, Math.min(1, this.maxReached - index))));
          if (this.maxReached >= index + .085) stage.classList.add('is-stitched');
        });
        this.renderShuttle(this.position, this.position >= this.stages.length - 1 ? 0 : 1);
      }

      renderShuttle(position, opacity = 1, time = 0) {
        if (this.reduceMotion.matches || opacity <= 0) {
          this.shuttle.hidden = true;
          return;
        }
        const point = this.shuttlePoint(position);
        this.shuttle.hidden = false;
        this.shuttle.style.opacity = String(opacity);
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const oscillation = Math.sin(time * Math.PI * 2 / 680) * 3;
        const tilt = direction * (18 + oscillation);
        this.shuttle.style.transform = 'translate(' + point.x + 'px,' + point.y + 'px) rotate(' + (point.angle + tilt) + 'deg)';
      }

      canLoop() {
        return this.loopButton && this.isConnected && this.controller && this.loopVisible && !this.loopPaused && !this.loopFocus && !this.reduceMotion.matches && !document.hidden && !this.animating && !this.activePointers.size && this.paths.length;
      }

      queueLoop(delay = 1200) {
        clearTimeout(this.loopTimer);
        if (!this.canLoop() || this.loopFrame) return;
        this.loopTimer = setTimeout(() => {
          if (!this.canLoop()) return;
          if (!this.loopRangeCache) this.loopRangeCache = this.makeLoopPlan(this.visibleLoopRange());
          if (this.loopRangeCache.end - this.loopRangeCache.start < .03) return;
          this.loopStamp = 0;
          this.loopFrame = requestAnimationFrame(now => this.drawLoop(now));
        }, delay);
      }

      visibleLoopRange() {
        const bounds = this.viewport.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const last = this.stages.length - 1;
        const margin = Math.min(46, bounds.width / 5);
        let start = null, end = null;
        this.paths.forEach((path, index) => {
          const rect = path.ownerSVGElement.getBoundingClientRect();
          if (rect.right < bounds.left || rect.left > bounds.right) return;
          const length = this.lengths[index];
          for (let sample = 0; sample <= 120; sample++) {
            const progress = sample / 120;
            const point = path.getPointAtLength(length * progress);
            const x = (rtl ? rect.right - point.x / 240 * rect.width : rect.left + point.x / 240 * rect.width) - bounds.left;
            const position = Math.max(0, Math.min(last, index + progress - .085));
            if (x >= margin && x <= bounds.width - margin) {
              if (start === null) start = position;
              end = position;
            }
          }
        });
        if (this.flourish) {
          const final = this.shuttlePoint(last);
          if (final.x >= margin && final.x <= bounds.width - margin) end = last;
        }
        return { start: start ?? 0, end: end ?? start ?? 0, duration: Math.max(7200, Math.min(16500, (bounds.width - 92) / .075)) };
      }

      makeLoopPlan(range) {
        const boundaries = this.nodes.map((node, index) => index - .085).filter(position => position > range.start && position < range.end);
        const positions = [range.start, ...boundaries, range.end];
        const points = positions.map(position => this.shuttlePoint(position));
        const total = Math.abs(points[points.length - 1].x - points[0].x) || 1;
        let elapsed = 0;
        const segments = positions.slice(1).map((position, index) => {
          const duration = range.duration * Math.abs(points[index + 1].x - points[index].x) / total;
          const segment = { from: positions[index], to: position, at: elapsed, duration };
          elapsed += duration;
          return segment;
        }).filter(segment => segment.duration > 0);
        return { ...range, duration: elapsed, segments };
      }

      loopPose(time, plan) {
        const segment = plan.segments.find(item => time < item.at + item.duration);
        if (!segment) return plan.end;
        const progress = Math.max(0, Math.min(1, (time - segment.at) / segment.duration));
        return segment.from + (segment.to - segment.from) * progress;
      }

      drawLoop(now) {
        this.loopFrame = null;
        if (!this.canLoop()) { this.loopStamp = 0; return; }
        if (this.loopStamp) this.loopElapsed += Math.min(64, now - this.loopStamp);
        this.loopStamp = now;
        const { start, duration } = this.loopRangeCache;
        const time = this.loopElapsed % (duration + 4200);
        if (time < this.stitchTime) this.resetStitchDetails();
        this.stitchTime = time;
        const position = this.loopPose(time, this.loopRangeCache);
        const opacity = Math.max(0, Math.min(1, time / 400, (duration + 4000 - time) / 1000));
        const shuttleOpacity = Math.max(0, Math.min(opacity, (duration - time) / 240));
        this.renderShuttle(position, shuttleOpacity, time);
        const visual = position + .085;
        const tail = start + .085;
        this.weaveMotion.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const span = final ? .085 : 1;
          const width = final ? 80 : 240;
          const from = Math.max(0, Math.min(1, (tail - index) / span));
          const rawFront = this.stageFrontX(index, (visual - index) / span);
          const fromX = this.stageFrontX(index, from);
          const completed = Math.max(0, Math.min(from, (this.maxReached - index) / span));
          this.weaveCompleted[index].setAttribute('width', String(this.stageFrontX(index, completed)));
          const front = Math.max(fromX, Math.min(width, rawFront));
          const edge = 'M' + fromX + ' 0H' + front + 'V48H' + fromX + 'Z';
          clip.setAttribute('d', edge);
          this.drawStitchDetails(index, rawFront, fromX, time);
          this.weaveLayers[index].style.opacity = String(rawFront > fromX ? opacity : 0);
        });
        this.loopFrame = requestAnimationFrame(next => this.drawLoop(next));
      }

      stopLoop(reset = false) {
        cancelAnimationFrame(this.loopFrame);
        clearTimeout(this.loopTimer);
        this.loopFrame = null;
        this.loopStamp = 0;
        if (reset) {
          this.resetStitchDetails();
          this.loopElapsed = 0;
          this.loopRangeCache = null;
          this.weaveLayers?.forEach(layer => { layer.style.opacity = '0'; });
          this.weaveMotion?.forEach(clip => { clip.setAttribute('d', 'M0 0'); });
        }
      }

      stopMotion() {
        cancelAnimationFrame(this.motionFrame);
        clearTimeout(this.settleTimer);
        this.motionFrame = null;
        this.animating = false;
      }

      disconnectedCallback() {
        this.stopLoop();
        this.loopObserver?.disconnect();
        this.stopMotion();
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-carpet-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-carpet-film')) {
    customElements.define('kk-carpet-film', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const video = this.querySelector('video');
        const playButton = this.querySelector('[data-film-toggle]');
        if (!video || !playButton) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.video = video;
        this.playButton = playButton;
        this.status = this.querySelector('[role="status"]');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.suspended = false;
        this.manualPaused = false;
        this.manualStarted = false;
        this.autoplayBlocked = false;
        this.playPending = false;
        this.ignorePause = false;
        this.managedPlay = false;
        this.failed = false;
        this.requestSerial = 0;
        video.controls = false;
        video.defaultMuted = true;
        video.muted = true;
        video.volume = 0;
        video.disablePictureInPicture = true;
        video.disableRemotePlayback = true;
        video.loop = true;
        video.playsInline = true;
        this.querySelector('.kk-carpet-film__actions').hidden = false;
        this.updateControls();

        playButton.addEventListener('click', () => {
          if (this.playPending || !video.paused) {
            this.manualPaused = true;
            this.pauseForContext();
          } else {
            this.manualPaused = false;
            this.manualStarted = true;
            this.autoplayBlocked = false;
            this.failed = false;
            this.status.textContent = '';
            this.requestPlayback();
          }
        }, options);
        video.addEventListener('volumechange', () => {
          if (!video.muted) video.muted = true;
          if (video.volume !== 0) video.volume = 0;
        }, options);
        video.addEventListener('play', () => {
          if (video.paused) { this.managedPlay = false; return; }
          if (!this.managedPlay) {

            this.manualPaused = false;
            this.manualStarted = true;
            this.autoplayBlocked = false;
            this.failed = false;
          }
          this.managedPlay = false;
          if (!this.canPlay()) this.pauseForContext();
        }, options);
        video.addEventListener('playing', () => {
          if (!this.canPlay()) { this.pauseForContext(); return; }
          clearTimeout(this.loadTimeout);
          this.playPending = false;
          this.failed = false;
          this.updateControls();
        }, options);
        video.addEventListener('pause', () => {
          if (this.ignorePause) {
            this.ignorePause = false;
          } else if (this.inView && !document.hidden && !this.suspended) {
            this.manualPaused = true;
            this.requestSerial += 1;
            this.playPending = false;
            clearTimeout(this.loadTimeout);
          }
          this.updateControls();
        }, options);
        video.addEventListener('error', () => this.handleFailure(), options);
        document.addEventListener('visibilitychange', () => this.reconcilePlayback(), options);
        this.motionQuery.addEventListener('change', () => this.reconcilePlayback(), options);
        if ('IntersectionObserver' in window) {
          this.preloadObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            video.preload = 'metadata';
            this.preloadObserver.disconnect();
          }, { rootMargin: '400px' });
          this.preloadObserver.observe(this);
          this.viewObserver = new IntersectionObserver(entries => {
            const entry = entries[entries.length - 1];
            this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.2;
            this.reconcilePlayback();
          }, { threshold: [0, 0.2] });
          this.viewObserver.observe(this.querySelector('.kk-carpet-film__viewport'));
        } else {

          this.inView = true;
          this.autoplayBlocked = true;
        }
      }
      canPlay() {
        return this.isConnected && this.inView && !document.hidden && !this.suspended &&
          !this.manualPaused && !this.autoplayBlocked && (!this.motionQuery.matches || this.manualStarted);
      }
      reconcilePlayback() {
        if (this.canPlay()) this.requestPlayback();
        else this.pauseForContext();
      }
      async requestPlayback() {
        if (!this.canPlay() || this.playPending || !this.video.paused) return;
        const video = this.video;
        video.muted = true;
        video.volume = 0;
        if (video.error) video.load();
        this.playPending = true;
        this.managedPlay = true;
        const request = ++this.requestSerial;
        this.updateControls();
        this.loadTimeout = setTimeout(() => {
          if (request === this.requestSerial && this.playPending) this.handleFailure();
        }, 15000);
        try {
          await video.play();
          if (request !== this.requestSerial) return;
          if (!this.canPlay()) { this.pauseForContext(); return; }
          this.playPending = false;
          clearTimeout(this.loadTimeout);
          this.updateControls();
        } catch (error) {
          if (request !== this.requestSerial || !this.isConnected) return;
          if (error.name === 'AbortError') {
            clearTimeout(this.loadTimeout);
            this.playPending = false;
            this.managedPlay = false;
            this.updateControls();
            return;
          }
          this.handleFailure(error.name === 'NotAllowedError');
        }
      }
      handleFailure(blocked = false) {
        if (!this.controller) return;
        this.autoplayBlocked = true;
        this.failed = !blocked;
        this.pauseForContext();
        this.status.textContent = blocked ? 'Select Play to watch this film.' : 'The film could not start. Please try again.';
        this.updateControls();
      }
      pauseForContext() {
        if (!this.video) return;
        this.requestSerial += 1;
        this.playPending = false;
        this.managedPlay = false;
        clearTimeout(this.loadTimeout);
        if (!this.video.paused) {
          this.ignorePause = true;
          this.video.pause();
        }
        this.updateControls();
      }
      updateControls() {
        const playing = !this.video.paused && !this.playPending;
        this.dataset.playing = String(playing);
        this.dataset.loading = String(this.playPending);
        const label = this.playPending ? (this.dataset.loadingLabel || 'Loading film…') :
          playing ? (this.dataset.pauseLabel || 'Pause film') :
          this.failed ? (this.dataset.retryLabel || 'Try again') : (this.dataset.playLabel || 'Play film');
        this.playButton.querySelector('[data-film-label]').textContent = label;
        this.playButton.setAttribute('aria-label', this.playPending ? 'Cancel video loading' : label);
        this.playButton.setAttribute('aria-busy', String(this.playPending));
      }
      suspendPlayback() {
        this.suspended = true;
        this.reconcilePlayback();
      }
      resumePlayback() {
        this.suspended = false;
        this.reconcilePlayback();
      }
      disconnectedCallback() {
        this.pauseForContext();
        this.preloadObserver?.disconnect();
        this.viewObserver?.disconnect();
        this.controller?.abort();
        this.controller = null;
        if (this.video) this.video.controls = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-cushion-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-cushion-film')) {
    customElements.define('kk-cushion-film', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.video.muted = true;
        this.video.controls = false;
        this.button.hidden = false;
        const sync = () => {
          this.toggleAttribute('data-paused', this.video.paused);
          this.button.querySelector('span').textContent = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        };
        this.video.addEventListener('play', sync, options);
        this.video.addEventListener('pause', sync, options);
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (this.userPaused) this.video.pause();
          else this.video.play().catch(sync);
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const visible = entries[0].isIntersecting;
            if (visible && !this.userPaused) this.video.play().catch(sync);
            else this.video.pause();
          }, { threshold: 0.15 });
          this.observer.observe(this.video);
        } else if (this.userPaused) this.video.pause();
        sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-fabric-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-fluid-fabrics')) {
    customElements.define('kk-fluid-fabrics', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.prepareEntrance(options);
      }
      prepareEntrance(options) {
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motionPreference.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
        this.revealedCloths ||= new WeakSet();
        this.visibleCloths = new WeakSet();
        this.entranceAnimations = new Set();
        const cloths = [...this.querySelectorAll('.kk-ff__cloth')];
        const reveal = cloth => {
          if (!this.isConnected || options.signal.aborted || this.motionPreference.matches || this.revealedCloths.has(cloth) || !this.visibleCloths.has(cloth)) return;
          const image = cloth.querySelector('img');
          if (image && !image.complete) return;
          this.revealedCloths.add(cloth);
          this.entranceObserver.unobserve(cloth);
          if (!image || !image.naturalWidth) return;
          const animation = cloth.animate([
            { opacity: 0, transform: 'translate3d(0,12px,0)' },
            { opacity: 1, transform: 'translate3d(0,0,0)' }
          ], {
            duration: 780,
            delay: cloths.indexOf(cloth) * 120,
            easing: 'cubic-bezier(.22,.61,.36,1)',
            fill: 'backwards'
          });
          this.entranceAnimations.add(animation);
          animation.onfinish = () => this.entranceAnimations.delete(animation);
        };
        this.entranceObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.visibleCloths.add(entry.target);
              reveal(entry.target);
            } else {
              this.visibleCloths.delete(entry.target);
            }
          });
        }, { threshold: .15 });
        cloths.forEach(cloth => {
          if (this.revealedCloths.has(cloth)) return;
          this.entranceObserver.observe(cloth);
          const image = cloth.querySelector('img');
          image?.addEventListener('load', () => reveal(cloth), { ...options, once: true });
        });
        this.motionPreference.addEventListener('change', event => {
          if (event.matches) this.stopEntrance();
        }, options);
      }
      stopEntrance() {
        this.entranceObserver?.disconnect();
        this.entranceAnimations?.forEach(animation => animation.cancel());
        this.entranceAnimations?.clear();
      }
      disconnectedCallback() {
        this.stopEntrance();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-family-archive"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kk-family-slideshow')) {
  customElements.define('kk-family-slideshow', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.events) return;
        this.slides = Array.from(this.querySelectorAll('[data-family-slide]'));
        this.links = Array.from(this.querySelectorAll('[data-family-go]'));
        if (!this.slides.length) return;
        this.index = 0;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.manualPaused = this.dataset.autoplay === 'false' || this.motion.matches;
        this.hovered = false;
        this.focused = false;
        this.inView = false;
        this.editorSelected = false;
        this.interval = Math.max(5000, Number(this.dataset.interval) || 8000);
        this.toggle = this.querySelector('[data-family-toggle]');
        this.querySelector('.kk-family-archive__controls')?.removeAttribute('hidden');
        this.links.forEach((link, index) => link.addEventListener('click', () => this.show(index), { signal }));
        this.querySelector('[data-family-prev]')?.addEventListener('click', () => this.show(this.index - 1), { signal });
        this.querySelector('[data-family-next]')?.addEventListener('click', () => this.show(this.index + 1), { signal });
        this.toggle?.addEventListener('click', () => {
          this.manualPaused = !this.manualPaused;
          if (!this.manualPaused) this.focused = false;
          this.updateToggle();
          this.schedule();
        }, { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.schedule();
        }, { signal });
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', event => { this.focused = event.target.matches(':focus-visible'); this.schedule(); }, { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => {
          this.focused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
          this.schedule();
        }), { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.manualPaused = true;
          this.updateToggle();
          this.schedule();
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorSelected = true;
          this.show(index);
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            if (this.inView) this.preloadNext();
            this.schedule();
          }, { threshold: 0.2 });
          this.observer.observe(this.querySelector('.kk-family-archive__stage'));
        } else {
          this.inView = true;
        }
        this.show(0);
        this.updateToggle();
      });
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-current', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        if (active) {
          const photo = slide.querySelector('img');
          if (photo) photo.loading = 'eager';
        }
      });
      this.links.forEach((link, i) => link.setAttribute('aria-current', String(i === this.index)));
      if (this.inView) this.preloadNext();
      this.schedule();
    }
    preloadNext() {
      const next = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
      if (next) next.loading = 'eager';
    }
    updateToggle() {
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-label', this.manualPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      this.toggle.querySelector('[data-family-pause-icon]').hidden = this.manualPaused;
      this.toggle.querySelector('[data-family-play-icon]').hidden = !this.manualPaused;
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || !this.events || this.slides.length < 2 || this.manualPaused || this.hovered || this.focused || this.editorSelected || !this.inView || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
      this.events = null;
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-gifting-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-gifting-editorial')) {
    customElements.define('kk-gifting-editorial', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) this.init();
        });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
        this.turns?.forEach((state, stage) => this.cancelTurn(stage));
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      }
      init() {
        this.events?.abort();
        this.resize?.disconnect();
        this.turns?.forEach((state, stage) => this.cancelTurn(stage));
        this.turns = new Map();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.rail = this.querySelector('[data-kk-rail]');
        this.items = Array.from(this.querySelectorAll('[data-kk-item]'));
        this.querySelectorAll('[data-kk-open], [data-kk-navigation]').forEach(element => { element.hidden = false; });
        const cta = this.querySelector('[data-kk-personalise]');
        cta.hidden = !this.giftFields();
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-kk-open')) this.open(button.closest('[data-kk-item]'));
          if (button.hasAttribute('data-kk-close')) button.closest('dialog').close();
          if (button.hasAttribute('data-kk-view')) this.show(button.closest('[data-kk-item]'), button.dataset.kkView);
          if (button.hasAttribute('data-kk-personalise')) this.personalise();
          if (button.hasAttribute('data-kk-previous')) this.move(-1);
          if (button.hasAttribute('data-kk-next')) this.move(1);
        }, options);
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('close', () => this.cancelTurn(dialog.querySelector('[data-kk-stage]')), options);
          dialog.addEventListener('click', event => {
            if (event.target === dialog) {
              const bounds = dialog.getBoundingClientRect();
              if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
            }
          }, options);
        });
        this.rail.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.position());
        }, { ...options, passive: true });
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          if (this.rail.scrollWidth <= this.rail.clientWidth + 1) return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('[data-kk-item]');
          if (item) item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }, options);
        this.resize = new ResizeObserver(() => {
          this.position();
          this.querySelectorAll('dialog[open] [data-kk-stage]').forEach(stage => this.fit(stage));
        });
        this.resize.observe(this.rail);
        this.querySelectorAll('[data-kk-stage]').forEach(stage => this.resize.observe(stage));
        this.position();
      }
      giftFields() {
        return Array.from(document.querySelectorAll('kk-gift-fields')).find(fields => fields.dataset.form?.startsWith(`product-form-${this.dataset.productId}-`));
      }
      personalise() {
        const fields = this.giftFields();
        if (!fields) return;
        const toggle = fields.querySelector('[data-gift-enable]');
        if (!toggle || toggle.disabled) return;
        if (!toggle.checked) toggle.click();
        fields.scrollIntoView({ behavior: this.motion(), block: 'start' });
        fields.querySelector('[data-gift-name]')?.focus({ preventScroll: true });
      }
      open(item) {
        const dialog = item.querySelector('dialog');
        const first = item.querySelector('[data-kk-view]');
        if (!dialog || !first) return;
        this.show(item, first.dataset.kkView, false);
        dialog.showModal();
        this.fit(dialog.querySelector('[data-kk-stage]'));
      }
      cancelTurn(stage) {
        const state = this.turns.get(stage);
        if (!state) return;
        state.request += 1;
        state.animations.forEach(animation => animation.cancel());
        state.animations = [];
        state.cleanup?.();
        state.cleanup = null;
        stage.removeAttribute('aria-busy');
        this.fit(stage);
      }
      makeCollection(item, index) {
        const face = document.createElement('div');
        face.className = 'kk-ge__face kk-ge__collection';
        face.dataset.collectionView = String(index);
        const frame = document.createElement('div');
        frame.className = 'kk-ge__collection-frame';
        for (const key of ['3', '2']) {
          const image = item.querySelector(`template[data-kk-detail="${key}"]`)
            ?.content.querySelector('img')?.cloneNode(true);
          if (!image) return null;
          image.loading = 'eager';
          image.decoding = 'async';
          image.classList.remove('kk-ge__rotated');
          const card = document.createElement('div');
          card.className = 'kk-ge__card';
          card.dataset.kkCard = key;
          const paper = document.createElement('div');
          paper.className = 'kk-ge__card-paper';
          paper.appendChild(image);
          card.appendChild(paper);
          frame.appendChild(card);
        }
        face.appendChild(frame);
        return face;
      }
      
      collectionPose(frame, key, view) {
        const width = frame.clientWidth || parseFloat(frame.style.width) || 1;
        const height = frame.clientHeight || parseFloat(frame.style.height) || width * .75;
        const arabic = key === '2';
        const ratio = arabic ? 1.632 : 1.571;
        const cardWidth = width * .86;
        let x, y, scale, angle, opacity = 1, zIndex = 2;
        if (view === '1') {
          scale = (arabic ? .57 : .58) / .86;
          x = width * (arabic ? .334 : .083);
          y = height * (arabic ? .488 : .10);
          angle = arabic ? -.5 : -3;
          zIndex = arabic ? 1 : 2;
        } else if (key === view) {
          scale = 1;
          x = width * .07;
          y = (height - cardWidth / ratio) / 2;
          angle = 0;
          zIndex = 3;
        } else {
          const side = arabic ? -1 : 1;
          scale = .90;
          x = (width - cardWidth * scale) / 2 + side * width * .065;
          y = (height - cardWidth * scale / ratio) / 2 + height * .025;
          angle = side * 2.25;
          opacity = 0;
          zIndex = 1;
        }
        return {
          transform: `translate3d(${x}px, ${y}px, 0) rotate(${angle}deg) scale(${scale})`,
          opacity,
          zIndex,
          filter: 'drop-shadow(0 2px 3px rgba(31,26,23,.08))'
        };
      }
      
      applyCollection(face, index) {
        const frame = face.querySelector('.kk-ge__collection-frame');
        if (!frame) return;
        face.dataset.collectionView = String(index);
        frame.querySelectorAll('[data-kk-card]').forEach(card => {
          const pose = this.collectionPose(frame, card.dataset.kkCard, String(index));
          Object.assign(card.style, pose);
          card.setAttribute('aria-hidden', String(index !== '1' && card.dataset.kkCard !== String(index)));
        });
      }
      
      async transitionCollection(item, index, state, current) {
        const stage = item.querySelector('[data-kk-stage]');
        const face = stage.querySelector('.kk-ge__collection');
        const frame = face?.querySelector('.kk-ge__collection-frame');
        if (!frame) return false;
        const from = face.dataset.collectionView;
        const to = String(index);
        if (from === to) return current();
        const cards = Array.from(frame.querySelectorAll('[data-kk-card]'));
        try {
          await Promise.all(cards.map(card => card.querySelector('img').decode()));
          if (!current()) return false;
          const restore = () => {
            if (stage.contains(face)) this.applyCollection(face, from);
          };
          state.cleanup = restore;
          const moving = cards.map(card => {
            const key = card.dataset.kkCard;
            const start = this.collectionPose(frame, key, from);
            const end = this.collectionPose(frame, key, to);
            const lifting = { filter: 'drop-shadow(0 10px 12px rgba(31,26,23,.13))' };
            let frames;
            if (from !== '1' && to !== '1') {
              const middleView = key === to ? to : from;
              const presented = this.collectionPose(frame, key, middleView);
              const side = key === '2' ? -1 : 1;
              const ratio = key === '2' ? 1.632 : 1.571;
              const width = frame.clientWidth;
              const height = frame.clientHeight;
              const scale = .955;
              const x = (width - width * .86 * scale) / 2 + side * width * .06;
              const y = (height - width * .86 * scale / ratio) / 2 + height * .012;
              const middle = {
                ...presented, ...lifting,
                transform: `translate3d(${x}px, ${y}px, 0) rotate(${side * 1.2}deg) scale(${scale})`,
                opacity: 1
              };
              frames = key === to ? [
                start,
                { ...start, ...lifting, opacity: 1, zIndex: 1, offset: .12 },
                { ...middle, zIndex: 1, offset: .44 },
                { ...middle, zIndex: 4, offset: .46 },
                end
              ] : [
                start,
                { ...middle, zIndex: 3, offset: .44 },
                { ...middle, zIndex: 1, offset: .46 },
                { ...end, opacity: 1, offset: .76 },
                end
              ];
            } else if (to !== '1' && key === to) {
              frames = [start, { ...end, ...lifting, offset: .78 }, end];
            } else if (from !== '1' && key === from) {
              frames = [start, { ...start, ...lifting, offset: .14 }, end];
            } else {
              frames = [start, end];
            }
            const animation = card.animate(frames, {
              duration: 650,
              easing: 'cubic-bezier(.22,.61,.36,1)',
              fill: 'both'
            });
            state.animations.push(animation);
            return animation;
          });
          await Promise.all(moving.map(animation => animation.finished));
          if (!current()) return false;
          this.applyCollection(face, to);
          if (state.cleanup === restore) state.cleanup = null;
          return true;
        } catch {
          return false;
        }
      }
      selectView(item, stage, index) {
        stage.dataset.view = index;
        item.querySelectorAll('[data-kk-view]').forEach(button => {
          const active = button.dataset.kkView === index;
          button.setAttribute('aria-pressed', String(active));
          if (active) item.querySelector('[data-kk-status]').textContent = button.textContent.trim();
        });
      }
      async show(item, index, animate = true) {
        const stage = item.querySelector('[data-kk-stage]');
        if (!stage) return;
        if (!this.turns.has(stage)) this.turns.set(stage, { request: 0, animations: [], cleanup: null });
        this.cancelTurn(stage);
        const state = this.turns.get(stage);
        const request = state.request;
        if (stage.dataset.view === index) return;
        const previous = stage.querySelector('.kk-ge__face');
        const previousView = stage.dataset.view;
        const collection = item.dataset.kkCardCollection === 'true' && ['1', '2', '3'].includes(index);
        const instant = !animate || !previous || this.motion() === 'instant';
        const current = () => state.request === request && this.isConnected && item.querySelector('dialog').open;
        if (collection && previous?.classList.contains('kk-ge__collection')) {
          if (instant || !previous.animate) {
            this.applyCollection(previous, index);
            this.selectView(item, stage, index);
            this.fit(stage);
            return;
          }
          stage.setAttribute('aria-busy', 'true');
          try {
            if (await this.transitionCollection(item, index, state, current)) this.selectView(item, stage, index);
          } finally {
            if (state.request === request) this.cancelTurn(stage);
          }
          return;
        }
        const template = item.querySelector(`template[data-kk-detail="${index}"]`);
        const image = template?.content.querySelector('img')?.cloneNode(true);
        if (!image) return;
        let face = collection ? this.makeCollection(item, index) : null;
        if (!face) {
          image.loading = 'eager';
          image.classList.toggle('kk-ge__rotated', template.dataset.kkRotate === 'true');
          face = document.createElement('div');
          face.className = 'kk-ge__face';
          face.appendChild(image);
        }
        const commit = () => {
          stage.replaceChildren(face);
          this.selectView(item, stage, index);
          this.fit(stage, true);
        };
        if (instant || !face.animate) {
          commit();
          return;
        }
        stage.setAttribute('aria-busy', 'true');
        try {
          await Promise.all(Array.from(face.querySelectorAll('img'), img => img.decode()));
          if (!current()) return;
          const back = item.dataset.kkBackView;
          const flip = back && back !== 'none' && (index === back || previousView === back);
          const direction = index === back ? 1 : -1;
          const leave = previous.animate(flip ? [
            { transform: 'rotateY(0deg)' },
            { transform: `rotateY(${direction * 88}deg)` }
          ] : [{ opacity: 1 }, { opacity: 0 }], {
            duration: flip ? 260 : 120, easing: 'cubic-bezier(.45,0,.7,.4)', fill: 'forwards'
          });
          state.animations.push(leave);
          await leave.finished;
          if (!current()) return;
          commit();
          const enter = face.animate(flip ? [
            { transform: `rotateY(${-direction * 88}deg)` },
            { transform: 'rotateY(0deg)' }
          ] : [{ opacity: 0 }, { opacity: 1 }], {
            duration: flip ? 340 : 160, easing: 'cubic-bezier(.2,.6,.3,1)', fill: 'both'
          });
          state.animations.push(enter);
          await enter.finished;
        } catch {
        } finally {
          if (state.request === request) this.cancelTurn(stage);
        }
      }
      fit(stage, force = false) {
        const face = stage.querySelector('.kk-ge__collection');
        if (face) {
          if (stage.hasAttribute('aria-busy') && !force) return;
          const frame = face.querySelector('.kk-ge__collection-frame');
          const width = Math.min(stage.clientWidth, stage.clientHeight * 4 / 3);
          frame.style.width = `${width}px`;
          frame.style.height = `${width * .75}px`;
          this.applyCollection(face, face.dataset.collectionView);
          return;
        }
        const image = stage.querySelector('.kk-ge__rotated');
        if (!image || !stage.clientWidth || !stage.clientHeight) return;
        image.style.width = `${stage.clientHeight}px`;
        image.style.height = `${stage.clientWidth}px`;
      }
      position() {
        if (!this.items.length) return;
        const start = this.rail.getBoundingClientRect().left;
        this.index = this.items.reduce((nearest, item, index) => Math.abs(item.getBoundingClientRect().left - start) < Math.abs(this.items[nearest].getBoundingClientRect().left - start) ? index : nearest, 0);
        const label = this.querySelector('[data-kk-position]');
        if (label) label.textContent = `${this.index + 1} / ${this.items.length}`;
        const previous = this.querySelector('[data-kk-previous]');
        const next = this.querySelector('[data-kk-next]');
        if (previous) previous.disabled = this.index === 0;
        if (next) next.disabled = this.index === this.items.length - 1;
      }
      move(direction) {
        const target = this.items[Math.max(0, Math.min(this.items.length - 1, this.index + direction))];
        target?.scrollIntoView({ behavior: this.motion(), block: 'nearest', inline: 'start' });
      }
      motion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-hand-embroidery-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-hand-embroidery-film')) {
    customElements.define('kk-hand-embroidery-film', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-kk-hand-film-toggle]');
        if (!this.video || !this.toggle || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.visible = false;
        this.userPaused = this.userPaused || false;
        this.manualPlay = false;
        this.blocked = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.video.muted = true;
        this.video.controls = false;
        this.toggle.hidden = false;
        this.updateToggle();
        this.toggle.addEventListener('click', () => {
          if (!this.video.paused) {
            this.userPaused = true;
            this.manualPlay = false;
            this.video.pause();
          } else {
            this.userPaused = false;
            this.manualPlay = true;
            this.blocked = false;
            this.visible = true;
            this.syncPlayback();
          }
        }, options);
        this.video.addEventListener('play', () => this.updateToggle(), options);
        this.video.addEventListener('pause', () => this.updateToggle(), options);
        this.video.addEventListener('error', () => {
          this.blocked = true;
          this.video.controls = true;
          this.toggle.hidden = true;
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.reducedMotion.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, options);
        this.connection?.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
            this.syncPlayback();
          }, { threshold: [0, .25] });
          this.observer.observe(this.video);
        }
      }

      canPlay() {
        return this.isConnected && this.visible && !document.hidden && !this.userPaused && !this.blocked &&
          (this.manualPlay || (!this.reducedMotion.matches && !this.connection?.saveData));
      }

      syncPlayback() {
        if (!this.canPlay()) {
          this.video.pause();
          return;
        }
        if (!this.video.paused || this.playPending) return;
        this.playPending = true;
        this.video.play().then(() => {
          if (!this.canPlay()) this.video.pause();
        }).catch(error => {
          if (error.name !== 'AbortError') this.blocked = true;
        }).finally(() => {
          this.playPending = false;
          this.updateToggle();
        });
      }

      updateToggle() {
        const playing = !this.video.paused;
        this.toggle.dataset.playing = String(playing);
        this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.abort?.abort();
        this.abort = null;
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-hand-jacket-making"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('kk-hand-jacket-journey')) {
    customElements.define('kk-hand-jacket-journey', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-journey-track]');
        this.viewport = this.querySelector('[data-journey-viewport]');
        this.needle = this.querySelector('[data-journey-needle]');
        this.stages = Array.from(this.querySelectorAll('[data-journey-stage]'));
        this.nodes = Array.from(this.querySelectorAll('[data-journey-choose]'));
        this.paths = Array.from(this.querySelectorAll('[data-journey-guide]'));
        this.flourish = this.querySelector('[data-journey-final-guide]');
        this.activePointers = new Set();
        this.loopButton = this.querySelector('[data-journey-loop]');
        this.jamaCompleted = Array.from(this.querySelectorAll('[data-jama-completed-clip]'));
        this.jamaMotion = Array.from(this.querySelectorAll('[data-jama-motion-clip]'));
        this.jamaLayers = Array.from(this.querySelectorAll('[data-jama-motion-layer]'));
        this.stitchDetails = this.jamaLayers.map(layer => Array.from(layer.querySelectorAll('[data-stitch-detail]'), element => ({
          element, end: Number(element.dataset.stitchEnd), duration: Number(element.dataset.stitchDuration), delay: Number(element.dataset.stitchDelay), parent: Number(element.dataset.stitchParent), began: null, progress: -1
        })));
        this.stitchTime = -1;
        this.loopElapsed = 0;
        this.loopVisible = false;
        this.loopFocus = false;
        this.previous = this.querySelector('[data-journey-previous]');
        this.next = this.querySelector('[data-journey-next]');
        this.counter = this.querySelector('[data-journey-counter]');
        this.status = this.querySelector('[data-journey-status]');
        this.progress = this.querySelector('[data-journey-progress]');
        if (!this.track || !this.stages.length || !this.needle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.lengths = this.paths.map(path => path.getTotalLength());
        this.flourishLength = this.flourish?.getTotalLength() || 0;
        this.position = 0;
        this.target = 0;
        this.maxReached = this.maxReached || 0;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.nodes.forEach((node, index) => {
          node.disabled = false;
          node.addEventListener('click', () => this.select(index), options);
        });
        this.track.addEventListener('scroll', () => {
          if (this.animating || performance.now() < (this.ignoreScrollUntil || 0)) return;
          this.stopLoop(true);
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.scheduleSettle();
        }, { ...options, passive: true });
        const interrupt = () => {
          this.stopLoop(true);
          this.stopMotion();
          this.ignoreScrollUntil = 0;
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.queueLoop(4000);
        };
        this.track.addEventListener('pointerdown', event => {
          this.activePointers.add(event.pointerId);
          this.loopFocus = false;
          interrupt();
        }, { ...options, passive: true });
        const release = event => {
          if (this.activePointers.delete(event.pointerId)) this.scheduleSettle();
        };
        document.addEventListener('pointerup', release, { ...options, passive: true });
        document.addEventListener('pointercancel', release, { ...options, passive: true });
        this.track.addEventListener('wheel', interrupt, { ...options, passive: true });
        this.track.addEventListener('keydown', event => this.onKey(event), options);
        this.reduceMotion.addEventListener('change', () => {
          this.select(this.target, false);
          this.loopButton.hidden = this.reduceMotion.matches;
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopLoop();
            if (this.animating) this.select(this.target, false);
          } else this.queueLoop();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.stages.findIndex(stage => stage.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.controller) this.select(this.target, false);
          });
        });
        this.resizeObserver.observe(this.track);
        this.stages.forEach(stage => this.resizeObserver.observe(stage));
        this.querySelector('[data-journey-controls]').hidden = false;
        this.querySelector('[data-journey-reading]').hidden = false;
        this.loopButton.hidden = this.reduceMotion.matches;
        this.loopButton.addEventListener('click', () => {
          this.loopPaused = !this.loopPaused;
          this.loopButton.setAttribute('aria-label', this.loopPaused ? this.loopButton.dataset.playLabel : this.loopButton.dataset.pauseLabel);
          this.loopButton.querySelector('[data-loop-pause]').hidden = this.loopPaused;
          this.loopButton.querySelector('[data-loop-play]').hidden = !this.loopPaused;
          if (this.loopPaused) this.stopLoop();
          else this.queueLoop(0);
        }, options);
        this.track.addEventListener('focusin', event => {
          this.loopFocus = event.target.matches(':focus-visible');
          if (this.loopFocus) this.stopLoop();
          else this.queueLoop();
        }, options);
        this.track.addEventListener('focusout', event => {
          if (!this.track.contains(event.relatedTarget)) { this.loopFocus = false; this.queueLoop(); }
        }, options);
        this.loopObserver = new IntersectionObserver(entries => {
          this.loopVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          if (this.loopVisible) this.queueLoop();
          else this.stopLoop();
        }, { threshold: [0, .3] });
        this.loopObserver.observe(this.viewport);
        this.classList.add('is-ready');
        this.select(Math.round(this.indexFromScroll()), false);
      }

      scheduleSettle() {
        clearTimeout(this.settleTimer);
        if (!this.activePointers.size) {
          this.settleTimer = setTimeout(() => {
            if (!this.activePointers.size) this.select(this.target);
          }, 170);
        }
      }

      geometry() {
        const bounds = this.track.getBoundingClientRect();
        const left = bounds.left + this.track.clientLeft;
        const right = left + this.track.clientWidth;
        const rects = this.stages.map(stage => stage.getBoundingClientRect());
        const first = rects[0];
        const last = rects[rects.length - 1];
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        return {
          left, right, rects, rtl,
          leftRoom: Math.max(0, left - Math.min(first.left, last.left)),
          rightRoom: Math.max(0, Math.max(first.right, last.right) - right)
        };
      }

      indexFromScroll() {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        return maximum > 1 ? (g.rtl ? g.rightRoom : g.leftRoom) / maximum * (this.stages.length - 1) : this.target || 0;
      }

      setScrollFraction(fraction) {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        const current = g.rtl ? g.rightRoom : g.leftRoom;
        const desired = Math.max(0, Math.min(1, fraction)) * maximum;
        this.track.scrollBy({ left: (desired - current) * (g.rtl ? -1 : 1), behavior: 'instant' });
      }

      move(direction) {
        this.select(this.target + direction);
      }

      select(index, animate = true) {
        this.stopLoop(true);
        this.stopMotion();
        const last = this.stages.length - 1;
        const next = Math.max(0, Math.min(last, index));
        const start = this.position;
        const scrollStart = last ? this.indexFromScroll() / last : 0;
        this.target = next;
        this.previous.disabled = next === 0;
        this.next.disabled = next === last;
        if (!animate || this.reduceMotion.matches || Math.abs(next - start) < .008) {
          this.position = next;
          this.ignoreScrollUntil = performance.now() + 100;
          this.setScrollFraction(last ? next / last : 0);
          this.update();
          this.arrive(next);
          return;
        }
        this.animating = true;
        const began = performance.now();
        const duration = Math.min(1100, 650 + Math.abs(next - start) * 70);
        const ease = value => value < .5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
        const frame = now => {
          if (!this.isConnected || !this.controller) return;
          const t = Math.min(1, (now - began) / duration);
          this.position = start + (next - start) * ease(t);
          const scrollEase = ease(t);
          this.setScrollFraction(scrollStart + ((last ? next / last : 0) - scrollStart) * scrollEase);
          this.update();
          if (t < 1) this.motionFrame = requestAnimationFrame(frame);
          else {
            this.animating = false;
            this.motionFrame = null;
            this.ignoreScrollUntil = performance.now() + 100;
            this.arrive(next);
          }
        };
        this.motionFrame = requestAnimationFrame(frame);
      }

      arrive(index) {
        this.stages.forEach((stage, i) => {
          stage.classList.toggle('is-current', i === index);
          if (i === index) this.nodes[i].setAttribute('aria-current', 'step');
          else this.nodes[i].removeAttribute('aria-current');
        });
        this.stages[index].classList.add('is-stitched');
        this.queueLoop(3000);
      }

      onKey(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target !== this.track && !this.nodes.includes(event.target)) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.loopFocus = true;
        if (event.key === 'Home') this.select(0);
        else if (event.key === 'End') this.select(this.stages.length - 1);
        else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.geometry().rtl ? -1 : 1));
      }

      needlePoint(position) {
        const last = this.stages.length - 1;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const viewport = this.viewport.getBoundingClientRect();
        if (!this.paths.length) {
          const node = this.nodes[0].getBoundingClientRect();
          return { x: node.left - viewport.left + node.width / 2 + (rtl ? -24 : 24), y: node.top - viewport.top + node.height / 2, angle: rtl ? 180 : 0 };
        }
        const visual = position + .085;
        if (visual > last && this.flourish) {
          const bounds = this.flourish.ownerSVGElement.getBoundingClientRect();
          const distance = Math.min(1, (visual - last) / .085) * this.flourishLength;
          const project = value => {
            const p = this.flourish.getPointAtLength(Math.max(0, Math.min(this.flourishLength, value)));
            return { x: (rtl ? bounds.right - p.x / 80 * bounds.width : bounds.left + p.x / 80 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
          };
          const point = project(distance);
          const before = project(distance - 1);
          const after = project(distance + 1);
          return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
        }
        const segment = Math.min(last - 1, Math.max(0, Math.floor(visual)));
        const progress = Math.min(1, visual - segment);
        const path = this.paths[segment];
        const length = this.lengths[segment];
        const bounds = path.ownerSVGElement.getBoundingClientRect();
        const project = distance => {
          const p = path.getPointAtLength(Math.max(0, Math.min(length, distance)));
          return { x: (rtl ? bounds.right - p.x / 240 * bounds.width : bounds.left + p.x / 240 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
        };
        const distance = progress * length;
        const point = project(distance);
        const before = project(distance - 1);
        const after = project(distance + 1);
        return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
      }

      stageFrontX(index, fraction) {
        const final = index === this.stages.length - 1;
        const width = final ? 80 : 240;
        const progress = Math.max(0, Math.min(1, fraction));
        if (progress === 0 || (!final && progress === 1)) return progress * width;
        const guide = final ? this.flourish : this.paths[index];
        const length = final ? this.flourishLength : this.lengths[index];
        return guide ? guide.getPointAtLength(progress * length).x : progress * width;
      }

      resetStitchDetails() {
        this.stitchTime = -1;
        this.stitchDetails?.forEach(strokes => strokes.forEach(stroke => {
          stroke.began = null;
          stroke.progress = -1;
          stroke.element.style.strokeDashoffset = '1';
          stroke.element.style.opacity = '0';
        }));
      }

      drawStitchDetails(index, front, from, time) {
        const scale = index === this.stages.length - 1 ? 1 : 2 / 3;
        const head = front / scale;
        const start = from / scale;
        const strokes = this.stitchDetails[index];
        strokes.forEach(stroke => {
          if (stroke.end <= start) return;
          const parent = strokes[stroke.parent];
          const outlineReady = !parent || parent.end <= start || parent.progress >= .8;
          if (stroke.began === null && head >= stroke.end + .35 && outlineReady) stroke.began = time + stroke.delay;
          const progress = stroke.began === null ? 0 : Math.max(0, Math.min(1, (time - stroke.began) / stroke.duration));
          if (Math.abs(progress - stroke.progress) < .0001) return;
          stroke.progress = progress;
          stroke.element.style.strokeDashoffset = String(1 - progress);
          stroke.element.style.opacity = progress > 0 ? '1' : '0';
        });
      }

      update() {
        const { left, right, rects } = this.geometry();
        if (!this.track.clientWidth) return;
        this.previous.disabled = this.target === 0;
        this.next.disabled = this.target === this.stages.length - 1;
        let visible = rects.reduce((indices, rect, index) => {
          const overlap = Math.max(0, Math.min(rect.right, right) - Math.max(rect.left, left));
          if (overlap >= Math.min(rect.width, right - left) * .5) indices.push(index);
          return indices;
        }, []);
        if (!visible.length) visible = [this.target];
        const start = String(visible[0] + 1).padStart(2, '0');
        const end = String(visible[visible.length - 1] + 1).padStart(2, '0');
        const count = String(this.stages.length).padStart(2, '0');
        const compact = start + '–' + end + ' / ' + count;
        if (this.counter.textContent !== compact) {
          this.counter.textContent = compact;
          this.status.textContent = this.dataset.visibleStages.replaceAll('[start]', start).replaceAll('[end]', end).replaceAll('[count]', count);
        }
        this.maxReached = Math.max(this.maxReached, this.position + .085);
        this.jamaCompleted.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const progress = Math.max(0, Math.min(1, (this.maxReached - index) / (final ? .085 : 1)));
          clip.setAttribute('width', String(this.stageFrontX(index, progress)));
        });
        this.progress.style.setProperty('--kk-hjm-progress', String(Math.min(1, (this.maxReached + 1) / this.stages.length)));
        this.stages.forEach((stage, index) => {
          stage.style.setProperty('--kk-hjm-stage-progress', String(Math.max(0, Math.min(1, this.maxReached - index))));
          if (this.maxReached >= index + .085) stage.classList.add('is-stitched');
        });
        this.renderNeedle(this.position, this.position >= this.stages.length - 1 ? 0 : 1);
      }

      renderNeedle(position, opacity = 1, time = 0) {
        if (this.reduceMotion.matches || opacity <= 0) {
          this.needle.hidden = true;
          return;
        }
        const point = this.needlePoint(position);
        this.needle.hidden = false;
        this.needle.style.opacity = String(opacity);
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const oscillation = Math.sin(time * Math.PI * 2 / 680) * 3;
        const tilt = direction * (18 + oscillation);
        this.needle.style.transform = 'translate(' + point.x + 'px,' + point.y + 'px) rotate(' + (point.angle + tilt) + 'deg)';
      }

      canLoop() {
        return this.loopButton && this.isConnected && this.controller && this.loopVisible && !this.loopPaused && !this.loopFocus && !this.reduceMotion.matches && !document.hidden && !this.animating && !this.activePointers.size && this.paths.length;
      }

      queueLoop(delay = 1200) {
        clearTimeout(this.loopTimer);
        if (!this.canLoop() || this.loopFrame) return;
        this.loopTimer = setTimeout(() => {
          if (!this.canLoop()) return;
          if (!this.loopRangeCache) this.loopRangeCache = this.makeLoopPlan(this.visibleLoopRange());
          if (this.loopRangeCache.end - this.loopRangeCache.start < .03) return;
          this.loopStamp = 0;
          this.loopFrame = requestAnimationFrame(now => this.drawLoop(now));
        }, delay);
      }

      visibleLoopRange() {
        const bounds = this.viewport.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const last = this.stages.length - 1;
        const margin = Math.min(46, bounds.width / 5);
        let start = null, end = null;
        this.paths.forEach((path, index) => {
          const rect = path.ownerSVGElement.getBoundingClientRect();
          if (rect.right < bounds.left || rect.left > bounds.right) return;
          const length = this.lengths[index];
          for (let sample = 0; sample <= 120; sample++) {
            const progress = sample / 120;
            const point = path.getPointAtLength(length * progress);
            const x = (rtl ? rect.right - point.x / 240 * rect.width : rect.left + point.x / 240 * rect.width) - bounds.left;
            const position = Math.max(0, Math.min(last, index + progress - .085));
            if (x >= margin && x <= bounds.width - margin) {
              if (start === null) start = position;
              end = position;
            }
          }
        });
        if (this.flourish) {
          const final = this.needlePoint(last);
          if (final.x >= margin && final.x <= bounds.width - margin) end = last;
        }
        return { start: start ?? 0, end: end ?? start ?? 0, duration: Math.max(7200, Math.min(16500, (bounds.width - 92) / .075)) };
      }

      makeLoopPlan(range) {
        const boundaries = this.nodes.map((node, index) => index - .085).filter(position => position > range.start && position < range.end);
        const positions = [range.start, ...boundaries, range.end];
        const points = positions.map(position => this.needlePoint(position));
        const total = Math.abs(points[points.length - 1].x - points[0].x) || 1;
        let elapsed = 0;
        const segments = positions.slice(1).map((position, index) => {
          const duration = range.duration * Math.abs(points[index + 1].x - points[index].x) / total;
          const segment = { from: positions[index], to: position, at: elapsed, duration };
          elapsed += duration;
          return segment;
        }).filter(segment => segment.duration > 0);
        return { ...range, duration: elapsed, segments };
      }

      loopPose(time, plan) {
        const segment = plan.segments.find(item => time < item.at + item.duration);
        if (!segment) return plan.end;
        const progress = Math.max(0, Math.min(1, (time - segment.at) / segment.duration));
        return segment.from + (segment.to - segment.from) * progress;
      }

      drawLoop(now) {
        this.loopFrame = null;
        if (!this.canLoop()) { this.loopStamp = 0; return; }
        if (this.loopStamp) this.loopElapsed += Math.min(64, now - this.loopStamp);
        this.loopStamp = now;
        const { start, duration } = this.loopRangeCache;
        const time = this.loopElapsed % (duration + 4200);
        if (time < this.stitchTime) this.resetStitchDetails();
        this.stitchTime = time;
        const position = this.loopPose(time, this.loopRangeCache);
        const opacity = Math.max(0, Math.min(1, time / 400, (duration + 4000 - time) / 1000));
        const needleOpacity = Math.max(0, Math.min(opacity, (duration - time) / 240));
        this.renderNeedle(position, needleOpacity, time);
        const visual = position + .085;
        const tail = start + .085;
        this.jamaMotion.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const span = final ? .085 : 1;
          const width = final ? 80 : 240;
          const from = Math.max(0, Math.min(1, (tail - index) / span));
          const rawFront = this.stageFrontX(index, (visual - index) / span);
          const fromX = this.stageFrontX(index, from);
          const completed = Math.max(0, Math.min(from, (this.maxReached - index) / span));
          this.jamaCompleted[index].setAttribute('width', String(this.stageFrontX(index, completed)));
          const front = Math.max(fromX, Math.min(width, rawFront));
          const edge = 'M' + fromX + ' 0H' + front + 'V48H' + fromX + 'Z';
          clip.setAttribute('d', edge);
          this.drawStitchDetails(index, rawFront, fromX, time);
          this.jamaLayers[index].style.opacity = String(rawFront > fromX ? opacity : 0);
        });
        this.loopFrame = requestAnimationFrame(next => this.drawLoop(next));
      }

      stopLoop(reset = false) {
        cancelAnimationFrame(this.loopFrame);
        clearTimeout(this.loopTimer);
        this.loopFrame = null;
        this.loopStamp = 0;
        if (reset) {
          this.resetStitchDetails();
          this.loopElapsed = 0;
          this.loopRangeCache = null;
          this.jamaLayers?.forEach(layer => { layer.style.opacity = '0'; });
          this.jamaMotion?.forEach(clip => { clip.setAttribute('d', 'M0 0'); });
        }
      }

      stopMotion() {
        cancelAnimationFrame(this.motionFrame);
        clearTimeout(this.settleTimer);
        this.motionFrame = null;
        this.animating = false;
      }

      disconnectedCallback() {
        this.stopLoop();
        this.loopObserver?.disconnect();
        this.stopMotion();
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-home-gift"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kk-home-gift')) {
  customElements.define('kk-home-gift', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.events) return;
        this.video = this.querySelector('video');
        this.playButton = this.querySelector('[data-gift-play]');
        if (!this.video || !this.playButton) return;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.video.controls = false;
        this.playButton.hidden = false;
        this.playButton.addEventListener('click', async () => {
          this.video.controls = true;
          this.video.muted = false;
          const owner = this.events;
          try {
            await this.video.play();
            if (this.events !== owner || !this.isConnected) return;
            if (document.activeElement === this.playButton) { this.video.tabIndex = 0; this.video.focus({ preventScroll: true }); }
          } catch {
            if (this.events !== owner || !this.isConnected) return;
            this.video.controls = true;
          }
          this.playButton.hidden = true;
        }, { signal });
        this.video.addEventListener('play', () => { this.playButton.hidden = true; }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (!entries[0].isIntersecting) this.video.pause();
          }, { threshold: 0 });
          this.observer.observe(this.video);
        }
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.video.pause(); }, { signal });
      });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-home-instagram"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-instagram-grid')) {
    customElements.define('kk-instagram-grid', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.app = this.querySelector('.kk-home-instagram__app');
        this.button = this.querySelector('.kk-home-instagram__more');
        this.archive = this.querySelector('.kk-home-instagram__archive');
        this.status = this.querySelector('.kk-home-instagram__status');
        this.mobile = window.matchMedia('(max-width: 699px)');
        this.visibleCount = this.mobile.matches ? 4 : 8;
        this.refresh = () => {
          const items = Array.from(this.app.querySelectorAll('.instafeed-new-layout-item'));
          this.visibleCount = Math.max(this.visibleCount, this.mobile.matches ? 4 : 8);
          items.forEach((item, index) => { item.hidden = index >= this.visibleCount; });
          this.button.hidden = items.length <= this.visibleCount;
          this.archive.hidden = items.length === 0 || items.length > this.visibleCount;
          const message = items.length ? this.status.dataset.template
            .replace('[shown]', Math.min(this.visibleCount, items.length))
            .replace('[total]', items.length) : '';
          if (this.status.textContent !== message) this.status.textContent = message;
        };
        this.loadMore = () => {
          const items = Array.from(this.app.querySelectorAll('.instafeed-new-layout-item'));
          const firstNewItem = items[this.visibleCount];
          this.visibleCount += 4;
          this.refresh();
          const target = firstNewItem?.querySelector('[role="button"], a, button');
          if (target) {
            target.focus({ preventScroll: true });
            target.scrollIntoView({ block: 'nearest' });
          } else if (this.button.hidden) {
            this.archive.focus({ preventScroll: true });
          }
        };
        this.button.addEventListener('click', this.loadMore);
        this.mobile.addEventListener('change', this.refresh);
        this.observer = new MutationObserver(this.refresh);
        this.observer.observe(this.app, { childList: true, subtree: true });
        this.refresh();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.loadMore);
        this.mobile?.removeEventListener('change', this.refresh);
        this.observer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-home-pashmina"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('kk-pashmina-film')) {
  customElements.define('kk-pashmina-film', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.initialize()); }
    initialize() {
      if (!this.isConnected || this.events) return;
      this.video = this.querySelector('[data-pashmina-film]');
      this.scenes = Array.from(this.querySelectorAll('[data-process-scene]'));
      this.steps = Array.from(this.querySelectorAll('[data-process-step]'));
      this.stageTitle = this.querySelector('[data-process-title]');
      this.stageDescription = this.querySelector('[data-process-description]');
      this.stageCounter = this.querySelector('[data-process-count]');
      this.stage = -1;
      this.stillStage = 0;
      this.durations = this.steps.map((_, index) => index === 3 ? 9000 : index === 6 ? 7800 : 6500);
      this.cycle = this.durations.reduce((sum, duration) => sum + duration, 0);
      this.hooks = {};
      ['comb', 'tuft', 'clean-comb', 'wheel', 'yarn', 'machine-wheel', 'machine-yarn', 'weft-mask', 'shuttle', 'loom-thread', 'weaver-left', 'weaver-right', 'loom-reed', 'dye', 'embroidery', 'needle', 'water', 'finish-cloth', 'finished-shawl'].forEach(name => {
        const node = this.querySelector('[data-process-' + name + ']');
        if (node) this.hooks[name] = { node, base: node.getAttribute('transform') || '' };
      });
      if (this.hooks['weft-mask']) {
        const row = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        row.setAttribute('fill', '#fff');
        this.hooks['weft-mask'].node.parentNode.appendChild(row);
        this.weaveRow = row;
      }
      this.embroideryPaths = Array.from(this.querySelectorAll('[data-process-embroidery] path')).filter(path => path.getAttribute('d'));
      this.embroideryPaths.forEach(path => { path.setAttribute('pathLength', '1'); path.style.strokeDasharray = '1'; });
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.visible = false;
      this.filmVisible = false;
      this.userPaused = false;
      this.manualPlay = false;
      this.blocked = false;
      this.playPending = false;
      this.elapsed = 0;
      this.frame = 0;
      this.lastFrame = 0;
      if (this.video) {
        this.video.muted = true;
        this.video.controls = false;
        this.video.tabIndex = 0;
        this.video.setAttribute('role', 'button');
        const toggle = () => {
          if (this.blocked) {
            this.userPaused = false;
            this.manualPlay = true;
            this.blocked = false;
          } else if (!this.userPaused && (this.frame || !this.video.paused)) {
            this.userPaused = true;
            this.manualPlay = false;
          } else {
            this.userPaused = false;
            this.manualPlay = true;
            this.blocked = false;
          }
          this.sync();
        };
        this.video.addEventListener('click', toggle, options);
        this.video.addEventListener('keydown', event => {
          if (event.key !== ' ' && event.key !== 'Enter') return;
          event.preventDefault();
          if (!event.repeat) toggle();
        }, options);
        this.video.addEventListener('play', () => this.updateLabel(), options);
        this.video.addEventListener('pause', () => this.updateLabel(), options);
        this.video.addEventListener('error', () => { this.blocked = true; this.updateLabel(); }, options);
      }
      this.steps.forEach((step, index) => {
        step.addEventListener('click', () => {
          this.stillStage = index;
          this.elapsed = this.durations.slice(0, index).reduce((sum, duration) => sum + duration, 0) + 250;
          this.draw(this.userPaused || this.motion.matches || this.connection?.saveData);
          this.sync();
        }, options);
      });
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { this.manualPlay = false; this.sync(); }, options);
      this.connection?.addEventListener('change', () => { this.manualPlay = false; this.sync(); }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this.observer.observe(this);
        if (this.video) {
          this.filmObserver = new IntersectionObserver(entries => {
            this.filmVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;
            this.sync();
          }, { threshold: [0, .2] });
          this.filmObserver.observe(this.video);
        }
      } else {
        this.visible = this.filmVisible = true;
      }
      this.draw(true);
      this.sync();
    }
    updateLabel() {
      if (!this.video) return;
      const active = !this.blocked && !this.userPaused && (this.frame || !this.video.paused);
      this.video.setAttribute('aria-label', active ? this.video.dataset.pauseLabel : this.video.dataset.playLabel);
      this.video.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
    sync() {
      const allowed = !document.hidden && !this.userPaused;
      if (this.video) {
        const play = allowed && this.filmVisible && !this.blocked && (this.manualPlay || (!this.motion.matches && !this.connection?.saveData));
        if (play && this.video.paused && !this.playPending) {
          const owner = this.events;
          this.playPending = true;
          this.video.play().catch(error => {
            if (this.events !== owner || !this.isConnected) return;
            if (error.name !== 'AbortError') this.blocked = true;
            this.updateLabel();
          }).finally(() => {
            if (this.events !== owner || !this.isConnected) return;
            this.playPending = false;
            if (!this.blocked) this.sync();
          });
        }
        else if (!play && !this.video.paused) this.video.pause();
      }
      const animate = allowed && this.visible && !this.motion.matches && !this.connection?.saveData;
      if (animate && !this.frame) {
        this.lastFrame = 0;
        this.frame = requestAnimationFrame(time => this.tick(time));
      } else if (!animate && this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.lastFrame = 0;
      }
      if (this.motion.matches || this.connection?.saveData) this.draw(true);
      this.updateLabel();
    }
    tick(time) {
      if (!this.isConnected) return;
      if (!this.lastFrame) this.lastFrame = time;
      const delta = time - this.lastFrame;
      if (delta >= 32) {
        this.elapsed += Math.min(delta, 100);
        this.lastFrame = time;
        this.draw(false);
      }
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    position(name, transform) {
      const hook = this.hooks[name];
      if (hook) hook.node.setAttribute('transform', (hook.base ? hook.base + ' ' : '') + transform);
    }
    setStage(index) {
      if (this.stage === index) return;
      this.stage = index;
      this.stillStage = index;
      const step = this.steps[index];
      if (!step) return;
      this.stageTitle.textContent = step.dataset.title;
      this.stageDescription.textContent = step.dataset.description;
      this.stageCounter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(this.steps.length).padStart(2, '0');
      this.steps.forEach((button, i) => button.setAttribute('aria-current', i === index ? 'step' : 'false'));
    }
    draw(still) {
      if (!this.scenes.length || !this.cycle) return;
      let time = this.elapsed % this.cycle;
      let index = 0;
      while (time >= this.durations[index] && index < this.durations.length - 1) { time -= this.durations[index]; index += 1; }
      if (still) index = this.stillStage;
      const progress = still ? .72 : time / this.durations[index];
      const blend = still ? 0 : Math.max(0, (progress - .89) / .11);
      const next = (index + 1) % this.scenes.length;
      this.setStage(index);
      this.scenes.forEach((scene, i) => {
        const opacity = i === index ? 1 - blend : i === next ? blend : 0;
        scene.setAttribute('opacity', opacity.toFixed(3));
        scene.style.visibility = opacity > 0 ? 'visible' : 'hidden';
      });
      this.steps.forEach((button, i) => {
        const line = button.querySelector('[data-process-progress]');
        if (line) line.style.transform = 'scaleX(' + (i < index ? 1 : i === index ? (still ? 1 : progress) : 0) + ')';
      });
      this.pose(index, progress, still);
      if (blend > 0) this.pose(next, 0, still);
    }
    pose(index, progress, still) {
      const p = Math.min(progress / .89, 1);
      const wave = still ? 0 : Math.sin(p * Math.PI * 6);
      if (index === 0) {
        this.position('comb', 'translate(' + (wave * 9).toFixed(2) + ' ' + (Math.cos(p * Math.PI * 6) * 2).toFixed(2) + ')');
        this.position('tuft', 'translate(' + (p * 13).toFixed(2) + ' ' + (-Math.sin(p * Math.PI) * 5).toFixed(2) + ')');
      } else if (index === 1) {
        this.position('clean-comb', 'translate(' + (wave * 11).toFixed(2) + ' ' + (-Math.abs(wave) * 4).toFixed(2) + ')');
      } else if (index === 2) {
        this.position('wheel', 'rotate(' + (p * 1000).toFixed(2) + ' 220 125)');
        this.position('machine-wheel', 'rotate(' + (p * 1600).toFixed(2) + ' 345 152)');
        if (this.hooks['machine-yarn']) { this.hooks['machine-yarn'].node.style.strokeDasharray = '.03 .018'; this.hooks['machine-yarn'].node.style.strokeDashoffset = String(-p * 1.4); }
        if (this.hooks.yarn) { this.hooks.yarn.node.style.strokeDasharray = '.05 .015'; this.hooks.yarn.node.style.strokeDashoffset = String(-p * 2); }
      } else if (index === 3) {
        const rowHeight = 133 / 8;
        const steps = Math.min(p * 8, 8);
        const row = Math.min(7, Math.floor(steps));
        const phase = Math.min(1, steps - row);
        const pass = Math.max(0, Math.min(1, (phase - .08) / .77));
        const travel = .5 - Math.cos(pass * Math.PI) * .5;
        const rightward = row % 2 === 0;
        const distance = travel * 280;
        const x = rightward ? 180 + distance : 460 - distance;
        const y = 55 + row * rowHeight;
        this.hooks['weft-mask']?.node.setAttribute('height', String(row * rowHeight));
        if (this.weaveRow) {
          this.weaveRow.setAttribute('x', String(rightward ? 180 : 460 - distance));
          this.weaveRow.setAttribute('y', String(y));
          this.weaveRow.setAttribute('width', String(distance));
          this.weaveRow.setAttribute('height', String(rowHeight));
        }
        if (this.hooks.shuttle) this.hooks.shuttle.node.setAttribute('transform', 'translate(' + x.toFixed(2) + ' ' + (y + 3).toFixed(2) + ')');
        this.hooks['loom-thread']?.node.setAttribute('d', 'M' + (rightward ? 180 : 460) + ' ' + (y + 3) + 'Q320 ' + (y + 6) + ' ' + x + ' ' + (y + 3));
        const reachLeft = 143 + Math.min(36, x - 180);
        const reachRight = 497 - Math.min(36, 460 - x);
        const handY = y + 3;
        const wrist = still ? 0 : Math.sin(pass * Math.PI) * 3;
        this.hooks['weaver-left']?.node.setAttribute('transform', 'translate(' + reachLeft.toFixed(2) + ' ' + handY.toFixed(2) + ') rotate(' + (-wrist).toFixed(2) + ')');
        this.hooks['weaver-right']?.node.setAttribute('transform', 'translate(' + reachRight.toFixed(2) + ' ' + handY.toFixed(2) + ') scale(-1 1) rotate(' + (-wrist).toFixed(2) + ')');
        const beat = still ? 0 : Math.sin(Math.max(0, (phase - .85) / .15) * Math.PI);
        this.position('loom-reed', 'translate(0 ' + (beat * 5).toFixed(2) + ')');
      } else if (index === 4) {
        this.hooks.dye?.node.setAttribute('opacity', String(.18 + .44 * p));
        const pathProgress = Math.min(p * this.embroideryPaths.length, this.embroideryPaths.length);
        this.embroideryPaths.forEach((path, i) => { path.style.strokeDashoffset = String(1 - Math.max(0, Math.min(1, pathProgress - i))); });
        const routeIndex = Math.min(this.embroideryPaths.length - 1, Math.floor(pathProgress));
        const route = this.embroideryPaths[routeIndex];
        if (route && this.hooks.needle) {
          const amount = Math.max(0, Math.min(1, pathProgress - routeIndex));
          const point = route.getPointAtLength(route.getTotalLength() * amount);
          this.hooks.needle.node.setAttribute('transform', 'translate(' + point.x.toFixed(2) + ' ' + point.y.toFixed(2) + ') rotate(' + (-35 + wave * 5).toFixed(2) + ') translate(15 -11)');
        }
      } else if (index === 5) {
        this.position('water', 'translate(' + (wave * 3).toFixed(2) + ' 0)');
        this.position('finish-cloth', 'translate(0 ' + (-Math.abs(wave) * 3).toFixed(2) + ')');
      } else {
        this.position('finished-shawl', 'rotate(' + (wave * .7).toFixed(2) + ' 320 125)');
      }
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.observer?.disconnect();
      this.filmObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.video?.pause();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-home-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kk-home-reviews')) {
  customElements.define('kk-home-reviews', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.events) return;
        this.events = new AbortController();
        const button = this.querySelector('[data-read-reviews]');
        const ratingContainer = this.querySelector('.kk-home-reviews__rating');
        if (!button || !ratingContainer) return;
        const update = () => {
          const rating = ratingContainer.querySelector('.loox-rating');
          button.hidden = !rating || rating.dataset.ratingUpgraded !== '1';
        };
        button.addEventListener('click', () => ratingContainer.querySelector('.loox-rating')?.click(), { signal:this.events.signal });
        this.addEventListener('keydown', event => {
          if (!['Enter',' '].includes(event.key) || !event.target.matches('.kk-home-reviews__rating-trigger')) return;
          event.preventDefault();
          ratingContainer.querySelector('.loox-rating')?.click();
        }, { signal:this.events.signal });
        this.observer = new MutationObserver(update);
        this.observer.observe(ratingContainer, { childList:true, subtree:true, attributes:true, attributeFilter:['data-rating-upgraded'] });
        update();
      });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-home-sozni"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kk-home-sozni')) {
customElements.define('kk-home-sozni', class extends HTMLElement {
  connectedCallback() { queueMicrotask(() => this.initialize()); }
  initialize() {
    if (!this.isConnected || this.events) return;
    this.video = this.querySelector('[data-preview-video]');
    if (!this.video) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.connection = navigator.connection;
    this.visible = false;
    this.ornamentVisible = false;
    this.userPaused = false;
    this.manualPlay = false;
    this.blocked = false;
    this.video.muted = true;
    this.video.controls = false;
    this.video.tabIndex = 0;
    this.video.setAttribute('role', 'button');
    const togglePlayback = () => {
      if (!this.userPaused && (!this.video.paused || this.frame)) {
        this.userPaused = true;
        this.manualPlay = false;
      } else {
        this.userPaused = false;
        this.manualPlay = true;
        this.blocked = false;
      }
      this.sync();
    };
    this.video.addEventListener('click', togglePlayback, options);
    this.video.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      if (!event.repeat) togglePlayback();
    }, options);
    this.video.addEventListener('play', () => this.update(), options);
    this.video.addEventListener('pause', () => this.update(), options);
    this.video.addEventListener('error', () => { this.blocked = true; this.update(); }, options);
    document.addEventListener('visibilitychange', () => this.sync(), options);
    this.motion.addEventListener('change', () => { this.manualPlay = false; this.sync(); }, options);
    this.connection?.addEventListener('change', () => { this.manualPlay = false; this.sync(); }, options);
    if ('IntersectionObserver' in window) {
      this.workshopObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.workshopObserver.disconnect();
        this.prepareWorkshop();
      }, { rootMargin: '600px 0px', threshold: 0 });
      this.workshopObserver.observe(this);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;
        this.sync();
      }, { threshold: [0, .2] });
      this.observer.observe(this.video);
      this.ornamentObserver = new IntersectionObserver(entries => {
        this.ornamentVisible = entries[0].isIntersecting;
        this.syncEmbroidery();
      }, { threshold: 0 });
      this.ornamentObserver.observe(this);
    } else {
      this.visible = this.ornamentVisible = true;
      this.prepareWorkshop();
      this.sync();
    }
    this.update();
  }
  prepareWorkshop() {
    if (!this.isConnected || this.motifs) return;
    this.svg = this.querySelector('.kk-home-sozni__embroidery');
    this.panel = this.querySelector('.kk-home-sozni__panel');
    this.media = this.querySelector('.kk-home-sozni__media');
    this.motifRoot = this.querySelector('[data-craft-motifs]');
    this.art = this.querySelector('[data-craft-art]');
    this.block = this.querySelector('[data-chapai-block]');
    this.blockBody = this.querySelector('[data-block-body]');
    this.blockShadow = this.querySelector('[data-block-shadow]');
    this.needle = this.querySelector('[data-needle]');
    this.shaft = this.querySelector('[data-needle-shaft]');
    this.thread = this.querySelector('[data-loose-thread]');
    this.eyebrow = this.querySelector('.kk-home-sozni__eyebrow');
    this.originalEyebrow = this.eyebrow?.textContent;
    const data = JSON.parse(this.querySelector('[data-stitch-routes]').textContent);
    this.colors = data.colors;
    this.features = data.features.map(feature => ({ ...feature, routes: feature.routes.map(route => {
      const cumulative = [0];
      for (let i = 1; i < route.points.length; i++) {
        const a = route.points[i - 1], b = route.points[i];
        cumulative.push(cumulative[i - 1] + Math.hypot(b[0] - a[0], b[1] - a[1]));
      }
      return { ...route, cumulative, length: cumulative[cumulative.length - 1] };
    }) }));
    this.elapsed = 0;
    this.frame = 0;
    this.lastTime = 0;
    this.buildWorkshop();
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.buildWorkshop());
      this.resizeObserver.observe(this.panel);
    }
  }
  svgNode(name, attributes) {
    const node = document.createElementNS('http://www.w3.org/2000/svg', name);
    for (const [key, value] of Object.entries(attributes)) node.setAttribute(key, value);
    return node;
  }
  buildWorkshop() {
    const box = this.panel.getBoundingClientRect(), media = this.media.getBoundingClientRect();
    if (!box.width || !box.height) return;
    const size = `${Math.round(box.width)}:${Math.round(box.height)}:${Math.round(media.width)}`;
    if (this.workshopSize === size) return;
    this.workshopSize = size;
    this.svg.setAttribute('viewBox', `0 0 ${box.width} ${box.height}`);
    const positions = [];
    const copy = this.querySelector('.kk-home-sozni__copy').getBoundingClientRect();
    const placeBand = (x, y, width, height, indices) => {
      const tileWidth = this.features[0].bounds[2], tileHeight = this.features[0].bounds[3];
      const scale = Math.min(1.2, width / (indices.length * tileWidth), height / tileHeight);
      const originX = x + (width - indices.length * tileWidth * scale) / 2;
      const originY = y + (height - tileHeight * scale) / 2;
      indices.forEach((featureIndex, col) => {
        const feature = this.features[featureIndex], bounds = feature.bounds;
        positions.push({ x: originX + col * tileWidth * scale - bounds[0] * scale, y: originY - bounds[1] * scale, scale, feature });
      });
    };
    if (matchMedia('(max-width: 749px)').matches) {
      placeBand(20, media.bottom - box.top + 18, box.width - 68, 92, [0, 1]);
      placeBand(20, box.height - 108, box.width - 68, 92, [1, 0]);
    } else {
      const left = media.right - box.left;
      const compact = box.width - left < 400;
      const topHeight = Math.max(64, copy.top - box.top + 16);
      const bottomStart = Math.min(box.height - 78, copy.bottom - box.top - 14);
      placeBand(left + 18, 30, box.width - left - 66, topHeight - 30, compact ? [0, 1] : [0, 1, 0]);
      placeBand(left + 18, bottomStart, box.width - left - 66, box.height - bottomStart - 14, compact ? [1, 0] : [1, 0, 1]);
    }
    this.motifRoot.replaceChildren();
    this.motifs = positions.map(position => {
      const group = this.svgNode('g', { transform: `translate(${position.x} ${position.y}) scale(${position.scale})` });
      const guide = this.svgNode('g', { class: 'kk-home-sozni__printed-guide', fill: 'none', stroke: 'currentColor', 'stroke-width': '.75' });
      position.feature.contours.forEach(contour => guide.append(this.svgNode('path', { d: contour.d, transform: contour.transform || 'matrix(1 0 0 1 0 0)' })));
      group.append(guide);
      const paths = position.feature.routes.map(route => {
        const path = this.svgNode('path', { d: route.d, pathLength: '1', class: 'kk-home-sozni__worked-thread', stroke: this.colors[route.color] });
        path.style.strokeWidth = `${route.strokeWidth || 1.15}`;
        group.append(path);
        return path;
      });
      this.motifRoot.append(group);
      return { ...position, guide, paths };
    });
    this.stampStart = 900;
    this.stampSlot = 1100;
    this.sewStart = this.stampStart + this.motifs.length * this.stampSlot + 600;
    let cursor = this.sewStart, previous = null;
    this.schedule = [];
    this.motifs.forEach(motif => {
      motif.feature.routes.forEach((route, routeIndex) => {
        const points = route.points.map(point => [motif.x + point[0] * motif.scale, motif.y + point[1] * motif.scale]);
        const start = points[0], end = points[points.length - 1];
        const distance = previous ? Math.hypot(start[0] - previous[0], start[1] - previous[1]) : 0;
        const transfer = previous ? Math.min(260, 45 + distance * .55) : 200;
        this.schedule.push({ start: cursor, end: cursor + transfer, move: true, from: previous || [start[0] + 20, start[1] - 20], to: start, color: this.colors[route.color] });
        cursor += transfer;
        const duration = Math.max(100, route.length * motif.scale / .30);
        this.schedule.push({ start: cursor, end: cursor + duration, route, motif, path: motif.paths[routeIndex], color: this.colors[route.color] });
        cursor += duration;
        previous = end;
      });
    });
    this.sewEnd = cursor;
    this.fadeStart = cursor + 5000;
    this.fadeEnd = this.fadeStart + 1700;
    this.duration = this.fadeEnd + 1000;
    this.elapsed = 0;
    this.lastTime = 0;
    this.resetWork();
    this.syncEmbroidery();
  }
  resetWork() {
    this.scheduleIndex = 0;
    this.motifs.forEach(motif => {
      motif.guide.style.opacity = '0';
      motif.paths.forEach(path => { path.style.strokeDashoffset = '1'; path.style.visibility = 'hidden'; });
    });
    this.art.style.opacity = '1';
    this.block.style.opacity = '0';
    this.needle.style.opacity = '0';
    this.setStage('blank');
  }
  setStage(stage) {
    if (this.dataset.craftStage === stage) return;
    this.dataset.craftStage = stage;

  }
  smooth(value) { return value * value * (3 - 2 * value); }
  renderWork(time) {
    this.art.style.opacity = time > this.fadeStart ? `${Math.max(0, 1 - (time - this.fadeStart) / (this.fadeEnd - this.fadeStart))}` : '1';
    if (time < this.stampStart) { this.setStage('blank'); return; }
    if (time < this.sewStart) {
      this.setStage('chapai');
      const index = Math.min(this.motifs.length - 1, Math.floor((time - this.stampStart) / this.stampSlot));
      const p = Math.min(1, ((time - this.stampStart) - index * this.stampSlot) / this.stampSlot);
      const motif = this.motifs[index];
      for (let i = 0; i < this.motifs.length; i++) this.motifs[i].guide.style.opacity = i < index || (i === index && p >= .52) ? '.66' : '0';
      const footprint = item => ({
        x: item.x + (item.feature.bounds[0] - 8) * item.scale,
        y: item.y + (item.feature.bounds[1] - 8) * item.scale,
        sx: (item.feature.bounds[2] + 16) * item.scale / 240,
        sy: (item.feature.bounds[3] + 16) * item.scale / 250
      });
      const target = footprint(motif);
      const previous = index ? footprint(this.motifs[index - 1]) : { x: target.x - 20, y: target.y - 35 };
      const travel = this.smooth(Math.min(1, p / .35));
      const x = previous.x + (target.x - previous.x) * travel;
      const y = previous.y + (target.y - previous.y) * travel;
      const lift = p < .35 ? 1 : p < .52 ? 1 - (p - .35) / .17 : p < .68 ? 0 : Math.min(1, (p - .68) / .28);
      this.block.setAttribute('transform', `translate(${x} ${y}) scale(${target.sx} ${target.sy})`);
      this.blockBody.setAttribute('transform', `translate(${lift * 5} ${-lift * 16}) rotate(${-lift * 3} 120 125)`);
      this.blockShadow.setAttribute('opacity', `${.07 + (1 - lift) * .09}`);
      this.block.style.opacity = p > .94 && index === this.motifs.length - 1 ? `${Math.max(0, (1 - p) / .06)}` : '.86';
      return;
    }
    this.block.style.opacity = '0';
    this.motifs.forEach(motif => { motif.guide.style.opacity = '.52'; });
    if (time >= this.sewEnd) {
      while (this.scheduleIndex < this.schedule.length) {
        const entry = this.schedule[this.scheduleIndex++];
        if (entry.path) { entry.path.style.strokeDashoffset = '0'; entry.path.style.visibility = 'visible'; }
      }
      this.needle.style.opacity = '0';
      this.setStage(time >= this.fadeEnd ? 'blank' : time >= this.fadeStart ? 'fade' : 'finished');
      return;
    }
    this.setStage('sozni');
    while (this.scheduleIndex < this.schedule.length - 1 && time >= this.schedule[this.scheduleIndex].end) {
      const completed = this.schedule[this.scheduleIndex++];
      if (completed.path) { completed.path.style.strokeDashoffset = '0'; completed.path.style.visibility = 'visible'; }
    }
    const entry = this.schedule[this.scheduleIndex];
    const progress = Math.max(0, Math.min(1, (time - entry.start) / (entry.end - entry.start)));
    let point, lift = 0;
    if (entry.move) {
      const eased = this.smooth(progress);
      lift = Math.sin(progress * Math.PI);
      point = [entry.from[0] + (entry.to[0] - entry.from[0]) * eased, entry.from[1] + (entry.to[1] - entry.from[1]) * eased - lift * 7];
    } else {
      entry.path.style.visibility = 'visible';
      entry.path.style.strokeDashoffset = `${1 - progress}`;
      const distance = entry.route.length * progress, cumulative = entry.route.cumulative;
      let segment = 1;
      while (segment < cumulative.length - 1 && cumulative[segment] < distance) segment++;
      const a = entry.route.points[segment - 1], b = entry.route.points[segment];
      const part = (distance - cumulative[segment - 1]) / (cumulative[segment] - cumulative[segment - 1] || 1);
      point = [entry.motif.x + (a[0] + (b[0] - a[0]) * part) * entry.motif.scale, entry.motif.y + (a[1] + (b[1] - a[1]) * part) * entry.motif.scale];
    }
    const dip = Math.sin(time / 45) * (entry.move ? 0 : 2);
    this.needle.style.opacity = '.95';
    this.needle.setAttribute('transform', `translate(${point[0]} ${point[1]})`);
    this.shaft.setAttribute('transform', `rotate(${dip - lift * 9})`);
    this.thread.setAttribute('stroke', entry.color);
    this.thread.setAttribute('d', `M0 0C${-12 - lift * 4} ${-6 - dip} ${3 + dip} ${-38 - lift * 4} 38 -26`);
  }
  syncEmbroidery() {
    if (!this.motifs) return;
    const still = this.motion.matches || this.connection?.saveData;
    const running = this.isConnected && this.ornamentVisible && !document.hidden && !this.userPaused && !still;
    this.classList.toggle('is-embroidering', running);
    if (still) {
      this.motifs.forEach(motif => {
        motif.guide.style.opacity = '.4';
        motif.paths.forEach(path => { path.style.strokeDashoffset = '0'; path.style.visibility = 'visible'; });
      });
      this.art.style.opacity = '1';
      this.block.style.opacity = this.needle.style.opacity = '0';
      this.setStage('finished');
      this.wasStill = true;
    } else if (this.wasStill) {
      this.wasStill = false;
      this.elapsed = 0;
      this.resetWork();
    }
    if (running && !this.frame) {
      this.lastTime = 0;
      const tick = now => {
        if (this.lastTime) this.elapsed += now - this.lastTime;
        this.lastTime = now;
        if (this.elapsed >= this.duration) { this.elapsed %= this.duration; this.resetWork(); }
        this.renderWork(this.elapsed);
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    } else if (!running) {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.lastTime = 0;
    }
  }
  canPlay() {
    return this.isConnected && this.visible && !document.hidden && !this.userPaused && !this.blocked && (this.manualPlay || (!this.motion.matches && !this.connection?.saveData));
  }
  sync() {
    this.syncEmbroidery();
    if (!this.canPlay()) { this.video.pause(); return; }
    if (!this.video.paused || this.pending) return;
    this.pending = true;
    this.video.play().then(() => {
      if (!this.canPlay()) this.video.pause();
    }).catch(error => {
      if (error.name !== 'AbortError') this.blocked = true;
    }).finally(() => { this.pending = false; this.update(); });
  }
  update() {
    this.syncEmbroidery();
    const action = !this.userPaused && (!this.video.paused || this.frame) ? this.video.dataset.pauseLabel : this.video.dataset.playLabel;
    this.video.setAttribute('aria-label', `${this.video.dataset.videoLabel}. ${action}`);
  }
  disconnectedCallback() {
    this.events?.abort();
    this.events = null;
    this.observer?.disconnect();
    this.ornamentObserver?.disconnect();
    this.workshopObserver?.disconnect();
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.frame);
    this.frame = 0;
    this.workshopSize = null;
    this.motifs = null;
    this.classList.remove('is-embroidering');
    this.video?.pause();
  }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-kani-journey"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kk-kani-journey')) {
  customElements.define('kk-kani-journey', class extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.initialize()); }
    initialize() {
      if (!this.isConnected || this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.video = this.querySelector('[data-kani-film]');
      this.scenes = Array.from(this.querySelectorAll('[data-kani-scene]'));
      this.steps = Array.from(this.querySelectorAll('[data-kani-step]'));
      this.tracks = this.steps.map(step => step.querySelector('[data-kani-progress]'));
      this.stageTitle = this.querySelector('[data-kani-title]');
      this.description = this.querySelector('[data-kani-description]');
      this.count = this.querySelector('[data-kani-count]');
      this.toggle = this.querySelector('[data-kani-toggle]');
      this.toggle.hidden = false;
      this.toggleLabel = this.querySelector('[data-kani-toggle-label]');
      this.filmToggle = this.querySelector('[data-kani-film-toggle]');
      if (this.filmToggle) {
        this.filmToggle.hidden = false;
        this.filmToggle.addEventListener('click', () => this.toggle.click(), options);
      }
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.durations = [10000, 8000, 10000, 9000, 18000, 10000, 10000, 7000];
      this.cycle = this.durations.reduce((sum, duration) => sum + duration, 0);
      this.elapsed = 0;
      this.stage = -1;
      this.frame = 0;
      this.lastFrame = 0;
      this.visible = false;
      this.filmVisible = false;
      this.userPaused = false;
      this.manualPlay = false;
      this.playPending = false;
      this.videoBlocked = false;
      this.filmUserPaused = false;
      this.autoPausing = false;
      this.hooks = {};
      ['guide', 'design', 'design-fill', 'pencil', 'yarns', 'colour-hand', 'colour-thread', 'warp-reveal', 'warp-hand', 'tension', 'winding', 'feed-thread', 'wind-hand', 'weave-hand', 'weave-hand-right', 'talim-active', 'beater', 'setting-row', 'wash-cloth', 'wash-hand', 'wash-hand-right', 'smooth-hand', 'finish-fold', 'finished'].forEach(name => {
        const node = this.querySelector('[data-kani-' + name + ']');
        if (node) this.hooks[name] = { node, base: node.getAttribute('transform') || '' };
      });
      this.rowMask = this.querySelector('[data-kani-woven-mask]');
      this.localMasks = Array.from(this.querySelectorAll('[data-kani-row-mask]'));
      this.localSticks = Array.from(this.querySelectorAll('[data-kani-local-stick]'));
      this.localThreads = Array.from(this.querySelectorAll('[data-kani-local-thread]'));
      this.reed = this.querySelector('[data-kani-reed]');
      this.hanks = Array.from(this.querySelectorAll('[data-kani-hank]')).map(node => ({ node, base: node.getAttribute('transform') }));
      this.swatches = Array.from(this.querySelectorAll('[data-kani-colour-swatch]'));
      this.wraps = Array.from(this.querySelectorAll('[data-kani-wrap]'));
      this.twillRows = Array.from(this.querySelectorAll('[data-kani-twill-row]'));
      this.ripples = Array.from(this.querySelectorAll('[data-kani-ripple]'));
      this.talimRows = Array.from(this.querySelectorAll('[data-kani-talim-row]'));
      this.toggle.addEventListener('click', () => {
        const paused = this.userPaused || (!this.manualPlay && (this.motion.matches || this.connection?.saveData));
        this.userPaused = !paused;
        this.manualPlay = paused;
        if (paused) { this.videoBlocked = false; this.filmUserPaused = false; }
        this.sync();
      }, options);
      this.steps.forEach((button, index) => {
        button.addEventListener('click', () => {
          this.elapsed = this.durations.slice(0, index).reduce((sum, duration) => sum + duration, 0) + 150;
          this.draw(this.userPaused || (!this.manualPlay && (this.motion.matches || this.connection?.saveData)));
          this.sync();
        }, options);
      });
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { this.manualPlay = false; this.sync(); }, options);
      this.connection?.addEventListener('change', () => { this.manualPlay = false; this.sync(); }, options);
      if (this.video) {
        this.video.muted = true;
        this.video.addEventListener('error', () => { this.videoBlocked = true; }, options);
        this.video.addEventListener('pause', () => {
          if (this.autoPausing) this.autoPausing = false;
          else this.filmUserPaused = true;
        }, options);
        this.video.addEventListener('play', () => { this.filmUserPaused = false; }, options);
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this.observer.observe(this.querySelector('.kk-kani-process__art'));
        if (this.video) {
          this.filmObserver = new IntersectionObserver(entries => {
            this.filmVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .15;
            this.sync();
          }, { threshold: [0, .15] });
          this.filmObserver.observe(this.video);
        }
      } else {
        this.visible = this.filmVisible = true;
      }
      this.draw(true);
      this.sync();
    }
    sync() {
      if (!this.events) return;
      const paused = this.userPaused || (!this.manualPlay && (this.motion.matches || this.connection?.saveData));
      const allowed = !document.hidden && !paused;
      const animate = allowed && this.visible;
      if (animate && !this.frame) {
        this.lastFrame = 0;
        this.frame = requestAnimationFrame(time => this.tick(time));
      } else if (!animate && this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.lastFrame = 0;
      }
      if (!this.manualPlay && (this.motion.matches || this.connection?.saveData)) this.draw(true);
      if (this.video) {
        const play = allowed && this.filmVisible && !this.videoBlocked && !this.filmUserPaused;
        if (play && this.video.paused && !this.playPending) {
          const owner = this.events;
          this.playPending = true;
          this.video.play().catch(error => {
            if (this.events !== owner || !this.isConnected) return;
            if (error.name !== 'AbortError') this.videoBlocked = true;
          }).finally(() => {
            if (this.events !== owner || !this.isConnected) return;
            this.playPending = false;
            const allowedNow = !document.hidden && this.filmVisible && !this.userPaused && (this.manualPlay || (!this.motion.matches && !this.connection?.saveData));
            if (!allowedNow) this.pauseFilm();
          });
        } else if (!play && !this.video.paused) this.pauseFilm();
      }
      this.toggleLabel.textContent = paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      if (this.filmToggle) this.filmToggle.textContent = this.toggleLabel.textContent;
      this.querySelector('[data-kani-pause-icon]').toggleAttribute('hidden', paused);
      this.querySelector('[data-kani-play-icon]').toggleAttribute('hidden', !paused);
    }
    pauseFilm() {
      if (this.video && !this.video.paused) { this.autoPausing = true; this.video.pause(); }
    }
    tick(time) {
      if (!this.isConnected || !this.events || !this.visible || document.hidden) { this.frame = 0; return; }
      if (!this.lastFrame) this.lastFrame = time;
      const delta = time - this.lastFrame;
      if (delta >= 32) {
        this.elapsed += Math.min(delta, 100);
        this.lastFrame = time;
        this.draw(false);
      }
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    position(name, transform) {
      const hook = this.hooks[name];
      if (hook) hook.node.setAttribute('transform', (hook.base ? hook.base + ' ' : '') + transform);
    }
    draw(still) {
      if (!this.scenes.length) return;
      let time = this.elapsed % this.cycle;
      let index = 0;
      while (time >= this.durations[index] && index < this.durations.length - 1) { time -= this.durations[index]; index += 1; }
      const progress = still ? .72 : time / this.durations[index];
      const blend = still ? 0 : Math.max(0, (progress - .93) / .07);
      const next = (index + 1) % this.durations.length;
      if (index !== this.stage) {
        this.stage = index;
        this.stageTitle.textContent = this.steps[index].dataset.title;
        this.description.textContent = this.steps[index].dataset.description;
        this.count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(this.durations.length).padStart(2, '0');
        this.steps.forEach((button, i) => button.setAttribute('aria-current', i === index ? 'step' : 'false'));
      }
      this.scenes.forEach((scene, i) => {
        const opacity = i === index ? 1 - blend : i === next ? blend : 0;
        scene.setAttribute('opacity', opacity.toFixed(3));
        scene.style.visibility = opacity > 0 ? 'visible' : 'hidden';
      });
      this.tracks.forEach((track, i) => { track.style.transform = 'scaleX(' + (i < index ? 1 : i === index ? (still ? 1 : progress) : 0) + ')'; });
      this.pose(index, progress, still);
      if (blend > 0) this.pose(next, 0, still);
    }
    pose(index, progress, still) {
      const p = Math.min(progress / .92, 1);
      const wave = still ? 0 : Math.sin(p * Math.PI * 4);
      const clamp = value => Math.max(0, Math.min(1, value));
      const ease = value => .5 - Math.cos(clamp(value) * Math.PI) * .5;
      const attr = (name, key, value) => this.hooks[name]?.node.setAttribute(key, String(value));
      if (index === 0) {
        attr('design', 'stroke-dashoffset', 1 - clamp(p * 2));
        attr('design-fill', 'opacity', .12 + .72 * clamp(p * 2));
        this.talimRows.forEach((row, i) => row.setAttribute('opacity', String(.12 + .88 * clamp(p * 10 - i - 1))));
        this.position('guide', 'translate(0 ' + (Math.min(6, Math.floor(p * 8)) * 20) + ')');
        const path = this.hooks.design?.node;
        if (path) {
          const point = path.getPointAtLength(path.getTotalLength() * clamp(p * 2));
          attr('pencil', 'transform', 'translate(' + (point.x - 3) + ' ' + (point.y - 5) + ') rotate(24)');
          attr('pencil', 'opacity', 1 - clamp((p - .55) * 5));
        }
      } else if (index === 1) {
        const sorting = Math.min(3.999, p * 4);
        const current = Math.floor(sorting);
        const part = sorting - current;
        const shades = ['#617588', '#974f4d', '#818763', '#be9b5c'];
        this.hanks.forEach((hank, i) => {
          const move = i === current && !still ? Math.sin(part * Math.PI) * 5 : 0;
          hank.node.setAttribute('transform', hank.base + ' translate(0 ' + -move + ')');
          hank.node.setAttribute('opacity', i > current ? '.48' : '1');
        });
        this.swatches.forEach((swatch, i) => swatch.setAttribute('opacity', String(i < current ? 1 : i === current ? .2 + .8 * part : .15)));
        const x = 155 + current * 109;
        attr('colour-hand', 'transform', 'translate(' + (x + 10) + ' ' + (118 + ease(part) * 17) + ') rotate(7)');
        attr('colour-thread', 'stroke', shades[current]);
        attr('colour-thread', 'd', 'M' + x + ' 199Q' + (x - 25) + ' ' + (234 - Math.sin(part * Math.PI) * 15) + ' ' + x + ' 278');
      } else if (index === 2) {
        const wraps = p * this.wraps.length;
        this.wraps.forEach((wrap, i) => wrap.setAttribute('opacity', String(clamp(wraps - i))));
        const turn = still ? .5 : (p * 11) % 1;
        const y = 151 + p * 45;
        const tipX = 323 + Math.sin(turn * Math.PI * 2) * 16;
        attr('wind-hand', 'transform', 'translate(' + (tipX + 22) + ' ' + (y - 3) + ') rotate(-154)');
        attr('feed-thread', 'd', 'M167 158C202 140 211 213 262 191Q296 ' + (y + 21) + ' ' + tipX + ' ' + y);
        this.position('winding', 'rotate(' + (Math.sin(turn * Math.PI * 2) * 2) + ')');
      } else if (index === 3) {
        const x = 177 + ease(p) * 291;
        attr('warp-reveal', 'width', 22 + 294 * ease(p));
        attr('warp-hand', 'transform', 'translate(' + x + ' ' + (115 + Math.sin(p * Math.PI * 6) * 5) + ') rotate(-8)');
        attr('tension', 'd', 'M' + (x - 9) + ' 66L' + x + ' 112L' + (x - 9) + ' 244');
      } else if (index === 4) {
        const amount = Math.min(p * 20, 19.999);
        const row = Math.floor(amount);
        const phase = amount - row;
        const y = 242 - row * 7.6;
        this.rowMask.setAttribute('y', String(y));
        this.rowMask.setAttribute('height', String(242 - y));
        let leftX = 220, rightX = 420;
        this.localMasks.forEach((mask, i) => {
          const x = 168 + i * 76;
          const forward = (row + i) % 2 === 0;
          const pair = i % 2;
          const localPass = clamp((phase - pair * .36) / .52);
          const travel = ease(localPass);
          const width = 76 * travel;
          mask.setAttribute('x', String(forward ? x : x + 76 - width));
          mask.setAttribute('y', String(y - 7.6));
          mask.setAttribute('width', String(width));
          mask.setAttribute('height', '7.7');
          const stickX = x + 10 + (forward ? travel : 1 - travel) * 56;
          const lift = Math.sin(localPass * Math.PI) * 10;
          this.localSticks[i].setAttribute('transform', 'translate(' + stickX.toFixed(2) + ' ' + (y - 8 - lift).toFixed(2) + ') rotate(' + (forward ? -32 : 32) + ')');
          this.localThreads[i].setAttribute('d', 'M' + (forward ? x : x + 76) + ' ' + (y - 3) + 'Q' + ((x + 38 + stickX) / 2).toFixed(2) + ' ' + (y + 1) + ' ' + stickX.toFixed(2) + ' ' + (y - 8 - lift).toFixed(2));
          if (i === (phase < .4 ? 0 : 1)) leftX = stickX;
          if (i === (phase < .4 ? 2 : 3)) rightX = stickX;
        });
        attr('weave-hand', 'transform', 'translate(' + (leftX + 4) + ' ' + (y + 3) + ') rotate(-14)');
        attr('weave-hand-right', 'transform', 'translate(' + (rightX - 4) + ' ' + (y - 8) + ') rotate(170)');
        attr('talim-active', 'transform', 'translate(0 ' + (row % 8 * 10) + ')');
        this.reed.setAttribute('transform', 'translate(0 0)');
      } else if (index === 5) {
        const cycle = still ? .55 : (p * 3) % 1;
        const approach = cycle < .6 ? ease(cycle / .6) : 1 - ease((cycle - .6) / .4);
        attr('beater', 'transform', 'translate(0 ' + (95 + approach * 38) + ')');
        attr('setting-row', 'd', 'M168 ' + (175 + approach * 9) + 'H472');
        this.twillRows.forEach((row, i) => {
          const dist = i > 7 ? (1 - approach) * (i - 7) * .8 : 0;
          row.setAttribute('transform', 'translate(0 ' + -dist + ')');
          row.setAttribute('opacity', i > 7 ? String(.7 + .3 * approach) : '1');
        });
      } else if (index === 6) {
        const wash = still ? 0 : Math.sin(p * Math.PI * 5);
        this.position('wash-cloth', 'translate(0 ' + (wash * 3) + ')');
        this.position('wash-hand', 'translate(0 ' + (wash * 4) + ')');
        this.position('wash-hand-right', 'translate(0 ' + (-wash * 3) + ')');
        this.ripples.forEach((ripple, i) => ripple.setAttribute('opacity', String(.3 + .45 * (.5 + .5 * Math.sin(p * Math.PI * 7 - i)))));
        const smooth = ease(still ? .65 : (p * 2) % 1);
        attr('smooth-hand', 'transform', 'translate(' + (398 + smooth * 76) + ' ' + (134 + smooth * 84) + ') rotate(-38)');
        attr('finish-fold', 'stroke-opacity', .24 * (1 - smooth));
      } else if (index === 7) {
        this.position('finished', 'translate(0 ' + (wave * 1.1).toFixed(2) + ') rotate(' + (wave * .22).toFixed(2) + ' 320 160)');
      }
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.observer?.disconnect();
      this.filmObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-machine-shawl-making"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('kk-machine-shawl-journey')) {
    customElements.define('kk-machine-shawl-journey', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-journey-track]');
        this.viewport = this.querySelector('[data-journey-viewport]');
        this.needle = this.querySelector('[data-journey-needle]');
        this.stages = Array.from(this.querySelectorAll('[data-journey-stage]'));
        this.nodes = Array.from(this.querySelectorAll('[data-journey-choose]'));
        this.paths = Array.from(this.querySelectorAll('[data-journey-guide]'));
        this.flourish = this.querySelector('[data-journey-final-guide]');
        this.activePointers = new Set();
        this.loopButton = this.querySelector('[data-journey-loop]');
        this.jamaCompleted = Array.from(this.querySelectorAll('[data-jama-completed-clip]'));
        this.jamaMotion = Array.from(this.querySelectorAll('[data-jama-motion-clip]'));
        this.jamaLayers = Array.from(this.querySelectorAll('[data-jama-motion-layer]'));
        this.stitchDetails = this.jamaLayers.map(layer => Array.from(layer.querySelectorAll('[data-stitch-detail]'), element => ({
          element, end: Number(element.dataset.stitchEnd), duration: Number(element.dataset.stitchDuration), delay: Number(element.dataset.stitchDelay), parent: Number(element.dataset.stitchParent), began: null, progress: -1
        })));
        this.stitchTime = -1;
        this.loopElapsed = 0;
        this.loopVisible = false;
        this.loopFocus = false;
        this.previous = this.querySelector('[data-journey-previous]');
        this.next = this.querySelector('[data-journey-next]');
        this.counter = this.querySelector('[data-journey-counter]');
        this.status = this.querySelector('[data-journey-status]');
        this.progress = this.querySelector('[data-journey-progress]');
        if (!this.track || !this.stages.length || !this.needle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.lengths = this.paths.map(path => path.getTotalLength());
        this.flourishLength = this.flourish?.getTotalLength() || 0;
        this.position = 0;
        this.target = 0;
        this.maxReached = this.maxReached || 0;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.nodes.forEach((node, index) => {
          node.disabled = false;
          node.addEventListener('click', () => this.select(index), options);
        });
        this.track.addEventListener('scroll', () => {
          if (this.animating || performance.now() < (this.ignoreScrollUntil || 0)) return;
          this.stopLoop(true);
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.scheduleSettle();
        }, { ...options, passive: true });
        const interrupt = () => {
          this.stopLoop(true);
          this.stopMotion();
          this.ignoreScrollUntil = 0;
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.queueLoop(4000);
        };
        this.track.addEventListener('pointerdown', event => {
          this.activePointers.add(event.pointerId);
          this.loopFocus = false;
          interrupt();
        }, { ...options, passive: true });
        const release = event => {
          if (this.activePointers.delete(event.pointerId)) this.scheduleSettle();
        };
        document.addEventListener('pointerup', release, { ...options, passive: true });
        document.addEventListener('pointercancel', release, { ...options, passive: true });
        this.track.addEventListener('wheel', interrupt, { ...options, passive: true });
        this.track.addEventListener('keydown', event => this.onKey(event), options);
        this.reduceMotion.addEventListener('change', () => {
          this.select(this.target, false);
          this.loopButton.hidden = this.reduceMotion.matches;
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopLoop();
            if (this.animating) this.select(this.target, false);
          } else this.queueLoop();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.stages.findIndex(stage => stage.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.controller) this.select(this.target, false);
          });
        });
        this.resizeObserver.observe(this.track);
        this.stages.forEach(stage => this.resizeObserver.observe(stage));
        this.querySelector('[data-journey-controls]').hidden = false;
        this.querySelector('[data-journey-reading]').hidden = false;
        this.loopButton.hidden = this.reduceMotion.matches;
        this.loopButton.addEventListener('click', () => {
          this.loopPaused = !this.loopPaused;
          this.loopButton.setAttribute('aria-label', this.loopPaused ? this.loopButton.dataset.playLabel : this.loopButton.dataset.pauseLabel);
          this.loopButton.querySelector('[data-loop-pause]').hidden = this.loopPaused;
          this.loopButton.querySelector('[data-loop-play]').hidden = !this.loopPaused;
          if (this.loopPaused) this.stopLoop();
          else this.queueLoop(0);
        }, options);
        this.track.addEventListener('focusin', event => {
          this.loopFocus = event.target.matches(':focus-visible');
          if (this.loopFocus) this.stopLoop();
          else this.queueLoop();
        }, options);
        this.track.addEventListener('focusout', event => {
          if (!this.track.contains(event.relatedTarget)) { this.loopFocus = false; this.queueLoop(); }
        }, options);
        this.loopObserver = new IntersectionObserver(entries => {
          this.loopVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          if (this.loopVisible) this.queueLoop();
          else this.stopLoop();
        }, { threshold: [0, .3] });
        this.loopObserver.observe(this.viewport);
        this.classList.add('is-ready');
        this.select(Math.round(this.indexFromScroll()), false);
      }

      scheduleSettle() {
        clearTimeout(this.settleTimer);
        if (!this.activePointers.size) {
          this.settleTimer = setTimeout(() => {
            if (!this.activePointers.size) this.select(this.target);
          }, 170);
        }
      }

      geometry() {
        const bounds = this.track.getBoundingClientRect();
        const left = bounds.left + this.track.clientLeft;
        const right = left + this.track.clientWidth;
        const rects = this.stages.map(stage => stage.getBoundingClientRect());
        const first = rects[0];
        const last = rects[rects.length - 1];
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        return {
          left, right, rects, rtl,
          leftRoom: Math.max(0, left - Math.min(first.left, last.left)),
          rightRoom: Math.max(0, Math.max(first.right, last.right) - right)
        };
      }

      indexFromScroll() {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        return maximum > 1 ? (g.rtl ? g.rightRoom : g.leftRoom) / maximum * (this.stages.length - 1) : this.target || 0;
      }

      setScrollFraction(fraction) {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        const current = g.rtl ? g.rightRoom : g.leftRoom;
        const desired = Math.max(0, Math.min(1, fraction)) * maximum;
        this.track.scrollBy({ left: (desired - current) * (g.rtl ? -1 : 1), behavior: 'instant' });
      }

      move(direction) {
        this.select(this.target + direction);
      }

      select(index, animate = true) {
        this.stopLoop(true);
        this.stopMotion();
        const last = this.stages.length - 1;
        const next = Math.max(0, Math.min(last, index));
        const start = this.position;
        const scrollStart = last ? this.indexFromScroll() / last : 0;
        this.target = next;
        this.previous.disabled = next === 0;
        this.next.disabled = next === last;
        if (!animate || this.reduceMotion.matches || Math.abs(next - start) < .008) {
          this.position = next;
          this.ignoreScrollUntil = performance.now() + 100;
          this.setScrollFraction(last ? next / last : 0);
          this.update();
          this.arrive(next);
          return;
        }
        this.animating = true;
        const began = performance.now();
        const duration = Math.min(1100, 650 + Math.abs(next - start) * 70);
        const ease = value => value < .5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
        const frame = now => {
          if (!this.isConnected || !this.controller) return;
          const t = Math.min(1, (now - began) / duration);
          this.position = start + (next - start) * ease(t);
          const scrollEase = ease(t);
          this.setScrollFraction(scrollStart + ((last ? next / last : 0) - scrollStart) * scrollEase);
          this.update();
          if (t < 1) this.motionFrame = requestAnimationFrame(frame);
          else {
            this.animating = false;
            this.motionFrame = null;
            this.ignoreScrollUntil = performance.now() + 100;
            this.arrive(next);
          }
        };
        this.motionFrame = requestAnimationFrame(frame);
      }

      arrive(index) {
        this.stages.forEach((stage, i) => {
          stage.classList.toggle('is-current', i === index);
          if (i === index) this.nodes[i].setAttribute('aria-current', 'step');
          else this.nodes[i].removeAttribute('aria-current');
        });
        this.stages[index].classList.add('is-stitched');
        this.queueLoop(3000);
      }

      onKey(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target !== this.track && !this.nodes.includes(event.target)) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.loopFocus = true;
        if (event.key === 'Home') this.select(0);
        else if (event.key === 'End') this.select(this.stages.length - 1);
        else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.geometry().rtl ? -1 : 1));
      }

      needlePoint(position) {
        const last = this.stages.length - 1;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const viewport = this.viewport.getBoundingClientRect();
        if (!this.paths.length) {
          const node = this.nodes[0].getBoundingClientRect();
          return { x: node.left - viewport.left + node.width / 2 + (rtl ? -24 : 24), y: node.top - viewport.top + node.height / 2, angle: rtl ? 180 : 0 };
        }
        const visual = position + .085;
        if (visual > last && this.flourish) {
          const bounds = this.flourish.ownerSVGElement.getBoundingClientRect();
          const distance = Math.min(1, (visual - last) / .085) * this.flourishLength;
          const project = value => {
            const p = this.flourish.getPointAtLength(Math.max(0, Math.min(this.flourishLength, value)));
            return { x: (rtl ? bounds.right - p.x / 80 * bounds.width : bounds.left + p.x / 80 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
          };
          const point = project(distance);
          const before = project(distance - 1);
          const after = project(distance + 1);
          return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
        }
        const segment = Math.min(last - 1, Math.max(0, Math.floor(visual)));
        const progress = Math.min(1, visual - segment);
        const path = this.paths[segment];
        const length = this.lengths[segment];
        const bounds = path.ownerSVGElement.getBoundingClientRect();
        const project = distance => {
          const p = path.getPointAtLength(Math.max(0, Math.min(length, distance)));
          return { x: (rtl ? bounds.right - p.x / 240 * bounds.width : bounds.left + p.x / 240 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
        };
        const distance = progress * length;
        const point = project(distance);
        const before = project(distance - 1);
        const after = project(distance + 1);
        return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
      }

      stageFrontX(index, fraction) {
        const final = index === this.stages.length - 1;
        const width = final ? 80 : 240;
        const progress = Math.max(0, Math.min(1, fraction));
        if (progress === 0 || (!final && progress === 1)) return progress * width;
        const guide = final ? this.flourish : this.paths[index];
        const length = final ? this.flourishLength : this.lengths[index];
        return guide ? guide.getPointAtLength(progress * length).x : progress * width;
      }

      resetStitchDetails() {
        this.stitchTime = -1;
        this.stitchDetails?.forEach(strokes => strokes.forEach(stroke => {
          stroke.began = null;
          stroke.progress = -1;
          stroke.element.style.strokeDashoffset = '1';
          stroke.element.style.opacity = '0';
        }));
      }

      drawStitchDetails(index, front, from, time) {
        const scale = index === this.stages.length - 1 ? 1 : 2 / 3;
        const head = front / scale;
        const start = from / scale;
        const strokes = this.stitchDetails[index];
        strokes.forEach(stroke => {
          if (stroke.end <= start) return;
          const parent = strokes[stroke.parent];
          const outlineReady = !parent || parent.end <= start || parent.progress >= .8;
          if (stroke.began === null && head >= stroke.end + .35 && outlineReady) stroke.began = time + stroke.delay;
          const progress = stroke.began === null ? 0 : Math.max(0, Math.min(1, (time - stroke.began) / stroke.duration));
          if (Math.abs(progress - stroke.progress) < .0001) return;
          stroke.progress = progress;
          stroke.element.style.strokeDashoffset = String(1 - progress);
          stroke.element.style.opacity = progress > 0 ? '1' : '0';
        });
      }

      update() {
        const { left, right, rects } = this.geometry();
        if (!this.track.clientWidth) return;
        this.previous.disabled = this.target === 0;
        this.next.disabled = this.target === this.stages.length - 1;
        let visible = rects.reduce((indices, rect, index) => {
          const overlap = Math.max(0, Math.min(rect.right, right) - Math.max(rect.left, left));
          if (overlap >= Math.min(rect.width, right - left) * .5) indices.push(index);
          return indices;
        }, []);
        if (!visible.length) visible = [this.target];
        const start = String(visible[0] + 1).padStart(2, '0');
        const end = String(visible[visible.length - 1] + 1).padStart(2, '0');
        const count = String(this.stages.length).padStart(2, '0');
        const compact = start + '–' + end + ' / ' + count;
        if (this.counter.textContent !== compact) {
          this.counter.textContent = compact;
          this.status.textContent = this.dataset.visibleStages.replaceAll('[start]', start).replaceAll('[end]', end).replaceAll('[count]', count);
        }
        this.maxReached = Math.max(this.maxReached, this.position + .085);
        this.jamaCompleted.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const progress = Math.max(0, Math.min(1, (this.maxReached - index) / (final ? .085 : 1)));
          clip.setAttribute('width', String(this.stageFrontX(index, progress)));
        });
        this.progress.style.setProperty('--kk-msj-progress', String(Math.min(1, (this.maxReached + 1) / this.stages.length)));
        this.stages.forEach((stage, index) => {
          stage.style.setProperty('--kk-msj-stage-progress', String(Math.max(0, Math.min(1, this.maxReached - index))));
          if (this.maxReached >= index + .085) stage.classList.add('is-stitched');
        });
        this.renderNeedle(this.position, this.position >= this.stages.length - 1 ? 0 : 1);
      }

      renderNeedle(position, opacity = 1, time = 0) {
        if (this.reduceMotion.matches || opacity <= 0) {
          this.needle.hidden = true;
          return;
        }
        const point = this.needlePoint(position);
        this.needle.hidden = false;
        this.needle.style.opacity = String(opacity);
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const oscillation = Math.sin(time * Math.PI * 2 / 680) * 3;
        const tilt = direction * (18 + oscillation);
        this.needle.style.transform = 'translate(' + point.x + 'px,' + point.y + 'px) rotate(' + (point.angle + tilt) + 'deg)';
      }

      canLoop() {
        return this.loopButton && this.isConnected && this.controller && this.loopVisible && !this.loopPaused && !this.loopFocus && !this.reduceMotion.matches && !document.hidden && !this.animating && !this.activePointers.size && this.paths.length;
      }

      queueLoop(delay = 1200) {
        clearTimeout(this.loopTimer);
        if (!this.canLoop() || this.loopFrame) return;
        this.loopTimer = setTimeout(() => {
          if (!this.canLoop()) return;
          if (!this.loopRangeCache) this.loopRangeCache = this.makeLoopPlan(this.visibleLoopRange());
          if (this.loopRangeCache.end - this.loopRangeCache.start < .03) return;
          this.loopStamp = 0;
          this.loopFrame = requestAnimationFrame(now => this.drawLoop(now));
        }, delay);
      }

      visibleLoopRange() {
        const bounds = this.viewport.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const last = this.stages.length - 1;
        const margin = Math.min(46, bounds.width / 5);
        let start = null, end = null;
        this.paths.forEach((path, index) => {
          const rect = path.ownerSVGElement.getBoundingClientRect();
          if (rect.right < bounds.left || rect.left > bounds.right) return;
          const length = this.lengths[index];
          for (let sample = 0; sample <= 120; sample++) {
            const progress = sample / 120;
            const point = path.getPointAtLength(length * progress);
            const x = (rtl ? rect.right - point.x / 240 * rect.width : rect.left + point.x / 240 * rect.width) - bounds.left;
            const position = Math.max(0, Math.min(last, index + progress - .085));
            if (x >= margin && x <= bounds.width - margin) {
              if (start === null) start = position;
              end = position;
            }
          }
        });
        if (this.flourish) {
          const final = this.needlePoint(last);
          if (final.x >= margin && final.x <= bounds.width - margin) end = last;
        }
        return { start: start ?? 0, end: end ?? start ?? 0, duration: Math.max(7200, Math.min(16500, (bounds.width - 92) / .075)) };
      }

      makeLoopPlan(range) {
        const boundaries = this.nodes.map((node, index) => index - .085).filter(position => position > range.start && position < range.end);
        const positions = [range.start, ...boundaries, range.end];
        const points = positions.map(position => this.needlePoint(position));
        const total = Math.abs(points[points.length - 1].x - points[0].x) || 1;
        let elapsed = 0;
        const segments = positions.slice(1).map((position, index) => {
          const duration = range.duration * Math.abs(points[index + 1].x - points[index].x) / total;
          const segment = { from: positions[index], to: position, at: elapsed, duration };
          elapsed += duration;
          return segment;
        }).filter(segment => segment.duration > 0);
        return { ...range, duration: elapsed, segments };
      }

      loopPose(time, plan) {
        const segment = plan.segments.find(item => time < item.at + item.duration);
        if (!segment) return plan.end;
        const progress = Math.max(0, Math.min(1, (time - segment.at) / segment.duration));
        return segment.from + (segment.to - segment.from) * progress;
      }

      drawLoop(now) {
        this.loopFrame = null;
        if (!this.canLoop()) { this.loopStamp = 0; return; }
        if (this.loopStamp) this.loopElapsed += Math.min(64, now - this.loopStamp);
        this.loopStamp = now;
        const { start, duration } = this.loopRangeCache;
        const time = this.loopElapsed % (duration + 4200);
        if (time < this.stitchTime) this.resetStitchDetails();
        this.stitchTime = time;
        const position = this.loopPose(time, this.loopRangeCache);
        const opacity = Math.max(0, Math.min(1, time / 400, (duration + 4000 - time) / 1000));
        const needleOpacity = Math.max(0, Math.min(opacity, (duration - time) / 240));
        this.renderNeedle(position, needleOpacity, time);
        const visual = position + .085;
        const tail = start + .085;
        this.jamaMotion.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const span = final ? .085 : 1;
          const width = final ? 80 : 240;
          const from = Math.max(0, Math.min(1, (tail - index) / span));
          const rawFront = this.stageFrontX(index, (visual - index) / span);
          const fromX = this.stageFrontX(index, from);
          const completed = Math.max(0, Math.min(from, (this.maxReached - index) / span));
          this.jamaCompleted[index].setAttribute('width', String(this.stageFrontX(index, completed)));
          const front = Math.max(fromX, Math.min(width, rawFront));
          const edge = 'M' + fromX + ' 0H' + front + 'V48H' + fromX + 'Z';
          clip.setAttribute('d', edge);
          this.drawStitchDetails(index, rawFront, fromX, time);
          this.jamaLayers[index].style.opacity = String(rawFront > fromX ? opacity : 0);
        });
        this.loopFrame = requestAnimationFrame(next => this.drawLoop(next));
      }

      stopLoop(reset = false) {
        cancelAnimationFrame(this.loopFrame);
        clearTimeout(this.loopTimer);
        this.loopFrame = null;
        this.loopStamp = 0;
        if (reset) {
          this.resetStitchDetails();
          this.loopElapsed = 0;
          this.loopRangeCache = null;
          this.jamaLayers?.forEach(layer => { layer.style.opacity = '0'; });
          this.jamaMotion?.forEach(clip => { clip.setAttribute('d', 'M0 0'); });
        }
      }

      stopMotion() {
        cancelAnimationFrame(this.motionFrame);
        clearTimeout(this.settleTimer);
        this.motionFrame = null;
        this.animating = false;
      }

      disconnectedCallback() {
        this.stopLoop();
        this.loopObserver?.disconnect();
        this.stopMotion();
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-order-included"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-order-included')) {
    customElements.define('kk-order-included', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.events?.abort();
          this.observer?.disconnect();
          this.events = new AbortController();
          const signal = this.events.signal;
          this.video = this.querySelector('video');
          this.playButton = this.querySelector('[data-play-film]');
          const detailsLink = this.querySelector('[data-gift-details]');
          if (detailsLink && !document.getElementById(detailsLink.hash.slice(1))) detailsLink.hidden = true;
          if (!this.video || !this.playButton) return;
          this.video.controls = false;
          this.playButton.hidden = false;
          this.playButton.addEventListener('click', async () => {
            this.video.controls = true;
            this.video.muted = false;
            try {
              await this.video.play();
              if (document.activeElement === this.playButton) { this.video.tabIndex = 0; this.video.focus(); }
              this.playButton.hidden = true;
            } catch {
              this.playButton.hidden = true;
            }
          }, { signal });
          this.video.addEventListener('play', () => { this.playButton.hidden = true; }, { signal });
          this.observer = new IntersectionObserver(entries => {
            if (!entries[0].isIntersecting) this.video.pause();
          });
          this.observer.observe(this.video);
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) this.video.pause();
          }, { signal });
        });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-papier-mache-making"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-papier-making')) {
    customElements.define('kk-papier-making', class extends HTMLElement {
      connectedCallback() {
        if (this.abort || this.classList.contains('kk-papier-making--still')) return;
        this.abort = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.stages = Array.from(this.querySelectorAll('[data-craft-stage]'));
        this.visibleStages = new Set();
        const options = { signal: this.abort.signal };
        this.sync = () => {
          const allowed = !this.motion.matches && !document.hidden;
          this.stages.forEach(stage => {
            const visible = this.visibleStages.has(stage);
            stage.classList.toggle('is-animated', !this.motion.matches);
            stage.classList.toggle('is-playing', allowed && visible);
          });
        };
        this.motion.addEventListener('change', this.sync, options);
        document.addEventListener('visibilitychange', this.sync, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting && entry.intersectionRatio >= .2) this.visibleStages.add(entry.target);
              else this.visibleStages.delete(entry.target);
            });
            this.sync();
          }, { threshold: [0, .2] });
          this.stages.forEach(stage => this.observer.observe(stage));
        } else {
          this.stages.forEach(stage => this.visibleStages.add(stage));
        }
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.stages?.forEach(stage => stage.classList.remove('is-playing'));
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-papier-mache-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-naqqashi')) customElements.define('kk-naqqashi', class extends HTMLElement {
    connectedCallback() {
      if (this.abort || !this.hasAttribute('data-animate')) return;
      this.abort = new AbortController();
      this.strokes = [...this.querySelectorAll('[data-paint-stroke]')].map(el => ({ el, start: Number(el.dataset.start), end: Number(el.dataset.end), length: el.getTotalLength() }));
      this.fills = [...this.querySelectorAll('[data-paint-fill]')];
      this.brush = this.querySelector('[data-paint-brush]');
      this.painting = this.querySelector('.kk-naqqashi__painting');
      this.plane = this.querySelector('[data-paint-plane]').transform.baseVal.consolidate().matrix;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.elapsed = 0;
      this.visible = false;
      this.sync = () => {
        cancelAnimationFrame(this.frame);
        this.previous = null;
        if (this.motion.matches) { this.render(.82); return; }
        if (this.visible && !document.hidden) this.frame = requestAnimationFrame(this.tick);
      };
      this.tick = time => {
        if (this.previous !== null) this.elapsed += Math.min(time - this.previous, 80);
        this.previous = time;
        this.render((this.elapsed % 16000) / 16000);
        this.frame = requestAnimationFrame(this.tick);
      };
      this.motion.addEventListener('change', this.sync, { signal: this.abort.signal });
      document.addEventListener('visibilitychange', this.sync, { signal: this.abort.signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold: .1 });
        this.observer.observe(this);
      } else { this.visible = true; this.sync(); }
    }
    render(progress) {
      const clamp = n => Math.min(1, Math.max(0, n));
      this.painting.style.opacity = progress > .95 ? String(1 - (progress - .95) / .05) : '1';
      let current;
      for (const stroke of this.strokes) {
        const amount = clamp((progress - stroke.start) / (stroke.end - stroke.start));
        stroke.el.style.strokeDashoffset = String((1 - amount) * 100);
        if (progress >= stroke.start && progress <= stroke.end) current = { stroke, amount };
      }
      for (const el of this.fills) el.style.opacity = String(clamp((progress - Number(el.dataset.at)) / .055));
      if (current) {
        const point = current.stroke.el.getPointAtLength(current.amount * current.stroke.length);
        const x = this.plane.a * point.x + this.plane.c * point.y + this.plane.e;
        const y = this.plane.b * point.x + this.plane.d * point.y + this.plane.f;
        this.brush.setAttribute('transform', `translate(${x} ${y}) rotate(36)`);
      }
      this.brush.style.opacity = current ? String(Math.min(1, current.amount / .12, (1 - current.amount) / .12)) : '0';
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-pashmina-authenticity"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-pashmina-certificate')) {
    customElements.define('kk-pashmina-certificate', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const papers = Array.from(this.querySelectorAll('[data-certificate-plane]'));
        const alignPaper = (paper) => {
          const width = paper.getBoundingClientRect().width;
          if (!width) return;
          paper.style.setProperty('--paper-scale', width / 644);
          paper.style.setProperty('--paper-plane', paper.dataset.certificatePlane);
          paper.classList.add('is-aligned');
        };
        this.paperResize?.disconnect();
        this.paperResize = new ResizeObserver(entries => entries.forEach(entry => alignPaper(entry.target)));
        papers.forEach(paper => { alignPaper(paper); this.paperResize.observe(paper); });
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-certificate-open]');
        const close = this.querySelector('[data-certificate-close]');
        const zoom = this.querySelector('[data-certificate-zoom]');
        const viewport = this.querySelector('[data-certificate-viewport]');
        const sheet = this.querySelector('.kk-pcert__sheet');
        const details = this.querySelector('.kk-pcert__details');
        if (!dialog || !trigger || !close || !viewport || typeof dialog.showModal !== 'function') return;
        const sizeSheet = () => {
          if (!dialog.open) return;
          const padding = window.innerWidth < 750 ? 32 : 56;
          const width = viewport.clientWidth - padding;
          const height = viewport.clientHeight - padding;
          const ratio = papers.length ? 644 / 912 : Number(sheet.querySelector('img')?.getAttribute('width')) / Number(sheet.querySelector('img')?.getAttribute('height')) || 644 / 912;
          const frameStyle = getComputedStyle(sheet);
          const inset = properties => properties.reduce((sum, property) => sum + (parseFloat(frameStyle[property]) || 0), 0);
          const horizontalInset = inset(['paddingLeft','paddingRight','borderLeftWidth','borderRightWidth']);
          const verticalInset = inset(['paddingTop','paddingBottom','borderTopWidth','borderBottomWidth']);
          const fit = Math.max(100, Math.min(width, Math.max(0, height - verticalInset) * ratio + horizontalInset, 820));
          const expanded = dialog.classList.contains('is-zoomed');
          sheet.style.setProperty('--viewer-paper-width', (expanded ? Math.min(920, Math.max(620, fit * 1.85)) : fit) + 'px');
          papers.forEach(alignPaper);
        };
        this.viewerResize?.disconnect();
        this.viewerResize = new ResizeObserver(sizeSheet);
        this.viewerResize.observe(viewport);
        const setZoom = expanded => {
          dialog.classList.toggle('is-zoomed', expanded);
          zoom?.setAttribute('aria-pressed', String(expanded));
          if (zoom) zoom.textContent = expanded ? zoom.dataset.fitLabel : zoom.dataset.zoomLabel;
          sizeSheet();
          viewport.scrollLeft = 0;
          viewport.scrollTop = 0;
        };
        trigger.setAttribute('aria-haspopup','dialog');
        trigger.setAttribute('aria-controls',dialog.id);
        trigger.addEventListener('click', event => {
          event.preventDefault();
          this.returnFocus = trigger;
          if (details) { details.open = window.innerWidth >= 750; details.querySelector('summary').tabIndex = window.innerWidth >= 750 ? -1 : 0; }
          dialog.showModal();
          setZoom(false);
          close.focus({preventScroll:true});
        },options);
        details?.addEventListener('toggle',()=>{if(dialog.open && window.innerWidth >= 750 && !details.open) details.open=true;sizeSheet();},options);
        close.addEventListener('click',()=>dialog.close(),options);
        zoom?.addEventListener('click',()=>setZoom(!dialog.classList.contains('is-zoomed')),options);
        dialog.addEventListener('close',()=>{
          setZoom(false);
          if(this.returnFocus?.isConnected)this.returnFocus.focus({preventScroll:true});
        },options);
        dialog.addEventListener('click',event=>{
          if(event.target!==dialog)return;
          const b=dialog.getBoundingClientRect();
          if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();
        },options);
      }
      disconnectedCallback(){this.paperResize?.disconnect();this.viewerResize?.disconnect();this.events?.abort();const dialog=this.querySelector('dialog');if(dialog?.open)dialog.close();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-pashmina-collection-grid"]) return;
  try {
    
if (!customElements.get('kk-pashmina-collection-grid')) {
  customElements.define('kk-pashmina-collection-grid', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.visibilityObserver?.disconnect();
      this.removeAttribute('data-grid-in-view');
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      const preserveView = event => {
        const url = event.detail?.url;
        if (url && typeof url.searchParams?.set === 'function') url.searchParams.set('view', this.dataset.view);
      };
      this.addEventListener('facet:update', preserveView, { signal });
      queueMicrotask(() => {
        if (!this.isConnected || signal.aborted) return;
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.toggleAttribute('data-grid-in-view', entries.some(entry => entry.isIntersecting));
        }, { rootMargin: '0px 0px -10% 0px' });
        this.visibilityObserver.observe(this);
        this.querySelectorAll('a[is="facet-link"],.pagination a[href]').forEach(link => {
          const url = new URL(link.href, location.href);
          if (url.origin !== location.origin) return;
          url.searchParams.set('view', this.dataset.view);
          link.href = url.toString();
        });
        this.querySelectorAll('form[is="facet-form"]').forEach(form => {
          let viewInput = form.querySelector('input[name="view"]');
          if (!viewInput) {
            viewInput = document.createElement('input');
            viewInput.type = 'hidden';
            viewInput.name = 'view';
            form.appendChild(viewInput);
          }
          viewInput.value = this.dataset.view;
          form.addEventListener('facet:update', preserveView, { signal });
          const updateCount = () => queueMicrotask(() => {
            if (signal.aborted || !form.isConnected) return;
            const button = form.querySelector('[is="facet-apply-button"]');
            const countElement = button?.filterCountElement;
            if (!countElement) return;
            const formData = new FormData(form);
            let count = Array.from(formData.values()).filter(value => value !== '').length;
            if (formData.has('sort_by')) count -= 1;
            if (formData.has('view')) count -= 1;
            countElement.textContent = ' (' + Math.max(0, count) + ')';
          });
          form.addEventListener('change', updateCount, { signal });
          form.closest('facet-drawer')?.addEventListener('toggle', updateCount, { signal });
          customElements.whenDefined('facet-apply-button').then(updateCount);
        });
      });
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.visibilityObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-pashmina-collection-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const observed = new WeakSet();
  const frameCertificate = (crop) => {
    const width = crop.getBoundingClientRect().width;
    const image = crop.querySelector('img');
    if (!image || width === 0) return;
    image.style.transform = `matrix3d(1.19806619,0.0337752,0,${0.02603402 / width},0.04095139,1.21872188,0,${0.07016091 / width},0,0,1,0,${-0.08694245 * width},${-0.05062383 * width},0,1)`;
  };
  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach(({ target }) => frameCertificate(target));
  });
  const viewers = new WeakMap();
  const mountViewer = (section) => {
    if (viewers.has(section)) return;
    const dialog = section.querySelector('.kk-pashmina-guide__dialog');
    const viewport = section.querySelector('[data-kk-gi-viewport]');
    const frame = section.querySelector('[data-kk-gi-viewer-frame]');
    const zoom = section.querySelector('[data-kk-gi-zoom]');
    const close = section.querySelector('[data-kk-gi-close]');
    if (!dialog || !viewport || !frame || !zoom || !close || typeof dialog.showModal !== 'function') return;
    const events = new AbortController();
    const options = { signal: events.signal };
    let returnFocus;
    const sizeViewer = () => {
      if (!dialog.open) return;
      const canvas = frame.parentElement;
      const canvasStyle = getComputedStyle(canvas);
      const frameStyle = getComputedStyle(frame);
      const total = (style, keys) => keys.reduce((sum, key) => sum + (parseFloat(style[key]) || 0), 0);
      const horizontal = total(frameStyle, ['paddingLeft','paddingRight','borderLeftWidth','borderRightWidth']);
      const vertical = total(frameStyle, ['paddingTop','paddingBottom','borderTopWidth','borderBottomWidth']);
      const width = viewport.clientWidth - total(canvasStyle, ['paddingLeft','paddingRight']);
      const height = viewport.clientHeight - total(canvasStyle, ['paddingTop','paddingBottom']);
      const fit = Math.max(100, Math.min(width, Math.max(0, height - vertical) * 900 / 1250 + horizontal, 900));
      const enlarged = zoom.getAttribute('aria-pressed') === 'true';
      frame.style.setProperty('--kk-gi-viewer-width', `${enlarged ? Math.min(900, Math.max(620, fit * 1.8)) : fit}px`);
      dialog.querySelectorAll('[data-kk-gi-original]').forEach(frameCertificate);
    };
    const setZoom = (enlarged) => {
      zoom.setAttribute('aria-pressed', String(enlarged));
      zoom.querySelector('[data-kk-gi-zoom-icon]').textContent = enlarged ? '−' : '+';
      sizeViewer();
      viewport.scrollTop = 0;
      viewport.scrollLeft = 0;
    };
    const viewerResize = new ResizeObserver(sizeViewer);
    viewerResize.observe(viewport);
    section.querySelectorAll('[data-kk-gi-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        returnFocus = trigger;
        dialog.showModal();
        setZoom(false);
        requestAnimationFrame(() => {
          sizeViewer();
          dialog.querySelectorAll('[data-kk-gi-original]').forEach(frameCertificate);
        });
        close.focus({ preventScroll: true });
      }, options);
    });
    zoom.addEventListener('click', () => setZoom(zoom.getAttribute('aria-pressed') !== 'true'), options);
    close.addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('close', () => {
      setZoom(false);
      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    }, options);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }, options);
    viewers.set(section, () => {
      events.abort();
      viewerResize.disconnect();
      if (dialog.open) dialog.close();
    });
  };
  const mountCertificates = () => {
    document.querySelectorAll('.kk-pashmina-guide__document-crop[data-kk-gi-original]').forEach((crop) => {
      if (observed.has(crop)) return;
      observed.add(crop);
      frameCertificate(crop);
      resizeObserver.observe(crop);
    });
    document.querySelectorAll('.kk-pashmina-guide__authenticity').forEach(mountViewer);
  };
  mountCertificates();
  document.addEventListener('shopify:section:load', mountCertificates);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.kk-pashmina-guide__document-crop[data-kk-gi-original]').forEach((crop) => resizeObserver.unobserve(crop));
    event.target.querySelectorAll('.kk-pashmina-guide__authenticity').forEach((section) => {
      viewers.get(section)?.();
      viewers.delete(section);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-pashmina-collection-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kk-pashmina-collection-film')) {
  customElements.define('kk-pashmina-collection-film', class extends HTMLElement {
    connectedCallback() {
      this.film = this.querySelector('video');
      if (!this.film) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.manualPause = false;
      this.inView = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.film.controls = false;
      this.film.muted = true;
      this.film.setAttribute('role', 'button');
      this.film.tabIndex = 0;
      const label = () => this.film.setAttribute('aria-label', this.film.paused ? this.film.dataset.playLabel : this.film.dataset.pauseLabel);
      const play = () => this.film.play().catch(() => label());
      const toggle = () => {
        if (this.film.paused) { this.manualPause = false; play(); }
        else { this.manualPause = true; this.film.pause(); }
      };
      this.film.addEventListener('click', toggle, options);
      this.film.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
      }, options);
      this.film.addEventListener('play', label, options);
      this.film.addEventListener('pause', label, options);
      const sync = () => {
        if (this.inView && !document.hidden && !this.manualPause && !this.motion.matches && !navigator.connection?.saveData) play();
        else this.film.pause();
      };
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; sync(); }, { threshold:.2 });
      this.observer.observe(this.film);
      document.addEventListener('visibilitychange', sync, options);
      this.motion.addEventListener('change', sync, options);
      label();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.abort?.abort(); this.film?.pause(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-pashmina-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-pashmina-loom-film')) {
    customElements.define('kk-pashmina-loom-film', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.dialog = this.querySelector('dialog');
        this.video = this.querySelector('video');
        this.opener = this.querySelector('[data-loom-open]');
        if (!this.dialog || !this.video || !this.opener) return;
        this.opener.addEventListener('click', () => {
          if (this.dialog.open) return;
          this.returnFocus = document.activeElement;
          this.dialog.showModal();
          this.opener.setAttribute('aria-expanded', 'true');
          if (!this.video.getAttribute('src')) {
            this.video.src = this.video.dataset.loomSrc;
            this.video.load();
          }
          this.video.muted = true;
          if (this.video.ended) this.video.currentTime = 0;
          this.video.play().catch(() => {});
        }, options);
        this.querySelector('[data-loom-close]')?.addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('cancel', () => this.video.pause(), options);
        this.dialog.addEventListener('close', () => {
          this.video.pause();
          this.opener.setAttribute('aria-expanded', 'false');
          const focusTarget = this.returnFocus?.isConnected ? this.returnFocus : this.opener;
          if (focusTarget.isConnected) focusTarget.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
      }
      disconnectedCallback() {
        this.video?.pause();
        this.abort?.abort();
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-pashmina-making"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('kk-pashmina-making'))customElements.define('kk-pashmina-making',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.video=this.querySelector('[data-main-film]');
      this.dialog=this.querySelector('dialog');this.handloom=this.querySelector('[data-handloom-film]');this.opener=this.querySelector('[data-handloom-open]');
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.connection=navigator.connection;this.visible=false;this.userPaused=false;this.autoPause=false;
      this.pauseMain=()=>{if(this.video&&!this.video.paused){this.autoPause=true;this.video.pause()}};
      this.sync=()=>{if(!this.video)return;if(!this.visible||document.hidden||this.dialog?.open){this.pauseMain();return}if(!this.motion.matches&&!this.connection?.saveData&&!this.userPaused)this.video.play().catch(()=>{})};
      if(this.video){
        this.toggle=this.querySelector('[data-film-toggle]');
        this.updateToggle=()=>{if(!this.toggle)return;const playing=!this.video.paused;this.toggle.toggleAttribute('data-playing',playing);this.toggle.querySelector('span').textContent=playing?this.toggle.dataset.pauseLabel:this.toggle.dataset.playLabel};
        if(this.toggle){this.toggle.hidden=false;this.toggle.addEventListener('click',()=>{if(this.video.paused){this.userPaused=false;this.video.play().catch(()=>{})}else{this.userPaused=true;this.video.pause()}},options)}
        this.video.addEventListener('play',()=>{this.userPaused=false;this.updateToggle()},options);
        this.video.addEventListener('pause',()=>{if(!this.autoPause&&this.visible)this.userPaused=true;this.autoPause=false;this.updateToggle()},options);this.updateToggle();
        this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.3;this.sync()},{threshold:[0,.3]});this.observer.observe(this.video);
        this.motion.addEventListener('change',()=>{if(this.motion.matches)this.pauseMain();else this.sync()},options);
        this.connection?.addEventListener('change',()=>{if(this.connection.saveData)this.pauseMain();else this.sync()},options);
      }
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.handloom?.pause();this.sync()},options);
      if(this.dialog&&this.handloom&&this.opener){
        this.opener.hidden=false;
        this.opener.addEventListener('click',()=>{this.pauseMain();if(!this.handloom.getAttribute('src')){this.handloom.src=this.handloom.dataset.src;if(this.handloom.dataset.poster)this.handloom.poster=this.handloom.dataset.poster}this.dialog.showModal();this.handloom.play().catch(()=>{})},options);
        this.querySelector('[data-handloom-close]').addEventListener('click',()=>this.dialog.close(),options);
        this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const bounds=this.dialog.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)this.dialog.close()},options);
        this.dialog.addEventListener('close',()=>{this.handloom.pause();this.opener.focus({preventScroll:true});this.sync()},options);
      }
    }
    disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();this.abort=null;this.video?.pause();this.handloom?.pause();this.dialog?.close()}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-pashmina-sozni"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-pashmina-sozni')) {
    customElements.define('kk-pashmina-sozni', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-kk-psozni-toggle]');
        if (!this.video || !this.toggle || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.visible = false;
        this.userPaused = this.userPaused || false;
        this.manualPlay = false;
        this.blocked = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.video.muted = true;
        this.video.controls = true;
        this.toggle.hidden = false;
        this.updateToggle();
        this.toggle.addEventListener('click', () => {
          if (!this.video.paused) {
            this.userPaused = true;
            this.manualPlay = false;
            this.video.pause();
          } else {
            this.userPaused = false;
            this.manualPlay = true;
            this.video.muted = false;
            this.blocked = false;
            this.visible = true;
            this.syncPlayback();
          }
        }, options);
        this.video.addEventListener('play', () => { this.userPaused = false; if (!this.playPending) this.manualPlay = true; this.updateToggle(); }, options);
        this.video.addEventListener('pause', () => { if (this.autoPause) { this.autoPause = false; } else { this.userPaused = true; this.manualPlay = false; } this.updateToggle(); }, options);
        this.video.addEventListener('error', () => {
          this.blocked = true;
          this.video.controls = true;
          this.toggle.hidden = true;
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.reducedMotion.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, options);
        this.connection?.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
            this.syncPlayback();
          }, { threshold: [0, .25] });
          this.observer.observe(this.video);
        }
      }

      canPlay() {
        return this.isConnected && this.visible && !document.hidden && !this.userPaused && !this.blocked &&
          (this.manualPlay || (!this.reducedMotion.matches && !this.connection?.saveData));
      }

      syncPlayback() {
        if (!this.canPlay()) {
          if (!this.video.paused) { this.autoPause = true; this.video.pause(); }
          return;
        }
        if (!this.video.paused || this.playPending) return;
        this.playPending = true;
        this.video.play().then(() => {
          if (!this.canPlay() && !this.video.paused) { this.autoPause = true; this.video.pause(); }
        }).catch(error => {
          if (error.name !== 'AbortError') this.blocked = true;
        }).finally(() => {
          this.playPending = false;
          this.updateToggle();
        });
      }

      updateToggle() {
        const playing = !this.video.paused;
        this.toggle.dataset.playing = String(playing);
        this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.abort?.abort();
        this.abort = null;
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-pashmina-story"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('kk-pashmina-story'))customElements.define('kk-pashmina-story',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;this.abort=new AbortController();const opt={signal:this.abort.signal};
      this.dialog=this.querySelector('dialog');this.opener=this.querySelector('[data-detail-open]');
      this.opener?.addEventListener('click',()=>{this.dialog?.showModal()},opt);
      this.querySelector('[data-detail-close]')?.addEventListener('click',()=>this.dialog.close(),opt);
      this.dialog?.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()}},opt);
      this.dialog?.addEventListener('close',()=>this.opener?.focus(),opt);
      this.video=this.querySelector('video');if(!this.video)return;
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.userPaused=false;this.visible=false;this.autoPause=false;
      this.filmToggle=this.querySelector('[data-film-toggle]');
      this.updateToggle=()=>{if(!this.filmToggle)return;const playing=!this.video.paused;this.filmToggle.toggleAttribute('data-playing',playing);this.filmToggle.querySelector('span').textContent=playing?this.filmToggle.dataset.pauseLabel:this.filmToggle.dataset.playLabel};
      if(this.filmToggle){this.filmToggle.hidden=false;this.filmToggle.addEventListener('click',()=>{if(this.video.paused){this.userPaused=false;this.video.play().catch(()=>{})}else{this.userPaused=true;this.video.pause()}},opt)}
      this.video.addEventListener('play',this.updateToggle,opt);this.video.addEventListener('pause',this.updateToggle,opt);this.updateToggle();
      this.video.addEventListener('pause',()=>{if(!this.autoPause&&this.visible)this.userPaused=true;this.autoPause=false},opt);
      this.video.addEventListener('play',()=>{this.userPaused=false},opt);
      this.sync=()=>{if(this.visible&&!document.hidden&&!this.motion.matches&&!navigator.connection?.saveData&&!this.userPaused){this.video.play().catch(()=>{})}else if(!this.video.paused){this.autoPause=true;this.video.pause()}};
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync()},{threshold:.3});this.observer.observe(this.video);
      document.addEventListener('visibilitychange',this.sync,opt);this.motion.addEventListener('change',this.sync,opt);
    }
    disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();this.abort=null;this.video?.pause();this.dialog?.close()}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-pheran-making"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('kk-shawl-journey')) {
    customElements.define('kk-shawl-journey', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-journey-track]');
        this.viewport = this.querySelector('[data-journey-viewport]');
        this.needle = this.querySelector('[data-journey-needle]');
        this.stages = Array.from(this.querySelectorAll('[data-journey-stage]'));
        this.nodes = Array.from(this.querySelectorAll('[data-journey-choose]'));
        this.paths = Array.from(this.querySelectorAll('[data-journey-guide]'));
        this.flourish = this.querySelector('[data-journey-final-guide]');
        this.activePointers = new Set();
        this.loopButton = this.querySelector('[data-journey-loop]');
        this.jamaCompleted = Array.from(this.querySelectorAll('[data-jama-completed-clip]'));
        this.jamaMotion = Array.from(this.querySelectorAll('[data-jama-motion-clip]'));
        this.jamaLayers = Array.from(this.querySelectorAll('[data-jama-motion-layer]'));
        this.stitchDetails = this.jamaLayers.map(layer => Array.from(layer.querySelectorAll('[data-stitch-detail]'), element => ({
          element, end: Number(element.dataset.stitchEnd), duration: Number(element.dataset.stitchDuration), delay: Number(element.dataset.stitchDelay), parent: Number(element.dataset.stitchParent), began: null, progress: -1
        })));
        this.stitchTime = -1;
        this.loopElapsed = 0;
        this.loopVisible = false;
        this.loopFocus = false;
        this.previous = this.querySelector('[data-journey-previous]');
        this.next = this.querySelector('[data-journey-next]');
        this.counter = this.querySelector('[data-journey-counter]');
        this.status = this.querySelector('[data-journey-status]');
        this.progress = this.querySelector('[data-journey-progress]');
        if (!this.track || !this.stages.length || !this.needle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.lengths = this.paths.map(path => path.getTotalLength());
        this.flourishLength = this.flourish?.getTotalLength() || 0;
        this.position = 0;
        this.target = 0;
        this.maxReached = this.maxReached || 0;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.nodes.forEach((node, index) => {
          node.disabled = false;
          node.addEventListener('click', () => this.select(index), options);
        });
        this.track.addEventListener('scroll', () => {
          if (this.animating || performance.now() < (this.ignoreScrollUntil || 0)) return;
          this.stopLoop(true);
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.scheduleSettle();
        }, { ...options, passive: true });
        const interrupt = () => {
          this.stopLoop(true);
          this.stopMotion();
          this.ignoreScrollUntil = 0;
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.queueLoop(4000);
        };
        this.track.addEventListener('pointerdown', event => {
          this.activePointers.add(event.pointerId);
          this.loopFocus = false;
          interrupt();
        }, { ...options, passive: true });
        const release = event => {
          if (this.activePointers.delete(event.pointerId)) this.scheduleSettle();
        };
        document.addEventListener('pointerup', release, { ...options, passive: true });
        document.addEventListener('pointercancel', release, { ...options, passive: true });
        this.track.addEventListener('wheel', interrupt, { ...options, passive: true });
        this.track.addEventListener('keydown', event => this.onKey(event), options);
        this.reduceMotion.addEventListener('change', () => {
          this.select(this.target, false);
          this.loopButton.hidden = this.reduceMotion.matches;
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopLoop();
            if (this.animating) this.select(this.target, false);
          } else this.queueLoop();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.stages.findIndex(stage => stage.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.controller) this.select(this.target, false);
          });
        });
        this.resizeObserver.observe(this.track);
        this.stages.forEach(stage => this.resizeObserver.observe(stage));
        this.querySelector('[data-journey-controls]').hidden = false;
        this.querySelector('[data-journey-reading]').hidden = false;
        this.loopButton.hidden = this.reduceMotion.matches;
        this.loopButton.addEventListener('click', () => {
          this.loopPaused = !this.loopPaused;
          this.loopButton.setAttribute('aria-label', this.loopPaused ? this.loopButton.dataset.playLabel : this.loopButton.dataset.pauseLabel);
          this.loopButton.querySelector('[data-loop-pause]').hidden = this.loopPaused;
          this.loopButton.querySelector('[data-loop-play]').hidden = !this.loopPaused;
          if (this.loopPaused) this.stopLoop();
          else this.queueLoop(0);
        }, options);
        this.track.addEventListener('focusin', event => {
          this.loopFocus = event.target.matches(':focus-visible');
          if (this.loopFocus) this.stopLoop();
          else this.queueLoop();
        }, options);
        this.track.addEventListener('focusout', event => {
          if (!this.track.contains(event.relatedTarget)) { this.loopFocus = false; this.queueLoop(); }
        }, options);
        this.loopObserver = new IntersectionObserver(entries => {
          this.loopVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          if (this.loopVisible) this.queueLoop();
          else this.stopLoop();
        }, { threshold: [0, .3] });
        this.loopObserver.observe(this.viewport);
        this.classList.add('is-ready');
        this.select(Math.round(this.indexFromScroll()), false);
      }

      scheduleSettle() {
        clearTimeout(this.settleTimer);
        if (!this.activePointers.size) {
          this.settleTimer = setTimeout(() => {
            if (!this.activePointers.size) this.select(this.target);
          }, 170);
        }
      }

      geometry() {
        const bounds = this.track.getBoundingClientRect();
        const left = bounds.left + this.track.clientLeft;
        const right = left + this.track.clientWidth;
        const rects = this.stages.map(stage => stage.getBoundingClientRect());
        const first = rects[0];
        const last = rects[rects.length - 1];
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        return {
          left, right, rects, rtl,
          leftRoom: Math.max(0, left - Math.min(first.left, last.left)),
          rightRoom: Math.max(0, Math.max(first.right, last.right) - right)
        };
      }

      indexFromScroll() {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        return maximum > 1 ? (g.rtl ? g.rightRoom : g.leftRoom) / maximum * (this.stages.length - 1) : this.target || 0;
      }

      setScrollFraction(fraction) {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        const current = g.rtl ? g.rightRoom : g.leftRoom;
        const desired = Math.max(0, Math.min(1, fraction)) * maximum;
        this.track.scrollBy({ left: (desired - current) * (g.rtl ? -1 : 1), behavior: 'instant' });
      }

      move(direction) {
        this.select(this.target + direction);
      }

      select(index, animate = true) {
        this.stopLoop(true);
        this.stopMotion();
        const last = this.stages.length - 1;
        const next = Math.max(0, Math.min(last, index));
        const start = this.position;
        const scrollStart = last ? this.indexFromScroll() / last : 0;
        this.target = next;
        this.previous.disabled = next === 0;
        this.next.disabled = next === last;
        if (!animate || this.reduceMotion.matches || Math.abs(next - start) < .008) {
          this.position = next;
          this.ignoreScrollUntil = performance.now() + 100;
          this.setScrollFraction(last ? next / last : 0);
          this.update();
          this.arrive(next);
          return;
        }
        this.animating = true;
        const began = performance.now();
        const duration = Math.min(1100, 650 + Math.abs(next - start) * 70);
        const ease = value => value < .5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
        const frame = now => {
          if (!this.isConnected || !this.controller) return;
          const t = Math.min(1, (now - began) / duration);
          this.position = start + (next - start) * ease(t);
          const scrollEase = ease(t);
          this.setScrollFraction(scrollStart + ((last ? next / last : 0) - scrollStart) * scrollEase);
          this.update();
          if (t < 1) this.motionFrame = requestAnimationFrame(frame);
          else {
            this.animating = false;
            this.motionFrame = null;
            this.ignoreScrollUntil = performance.now() + 100;
            this.arrive(next);
          }
        };
        this.motionFrame = requestAnimationFrame(frame);
      }

      arrive(index) {
        this.stages.forEach((stage, i) => {
          stage.classList.toggle('is-current', i === index);
          if (i === index) this.nodes[i].setAttribute('aria-current', 'step');
          else this.nodes[i].removeAttribute('aria-current');
        });
        this.stages[index].classList.add('is-stitched');
        this.queueLoop(3000);
      }

      onKey(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target !== this.track && !this.nodes.includes(event.target)) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.loopFocus = true;
        if (event.key === 'Home') this.select(0);
        else if (event.key === 'End') this.select(this.stages.length - 1);
        else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.geometry().rtl ? -1 : 1));
      }

      needlePoint(position) {
        const last = this.stages.length - 1;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const viewport = this.viewport.getBoundingClientRect();
        if (!this.paths.length) {
          const node = this.nodes[0].getBoundingClientRect();
          return { x: node.left - viewport.left + node.width / 2 + (rtl ? -24 : 24), y: node.top - viewport.top + node.height / 2, angle: rtl ? 180 : 0 };
        }
        const visual = position + .085;
        if (visual > last && this.flourish) {
          const bounds = this.flourish.ownerSVGElement.getBoundingClientRect();
          const distance = Math.min(1, (visual - last) / .085) * this.flourishLength;
          const project = value => {
            const p = this.flourish.getPointAtLength(Math.max(0, Math.min(this.flourishLength, value)));
            return { x: (rtl ? bounds.right - p.x / 80 * bounds.width : bounds.left + p.x / 80 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
          };
          const point = project(distance);
          const before = project(distance - 1);
          const after = project(distance + 1);
          return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
        }
        const segment = Math.min(last - 1, Math.max(0, Math.floor(visual)));
        const progress = Math.min(1, visual - segment);
        const path = this.paths[segment];
        const length = this.lengths[segment];
        const bounds = path.ownerSVGElement.getBoundingClientRect();
        const project = distance => {
          const p = path.getPointAtLength(Math.max(0, Math.min(length, distance)));
          return { x: (rtl ? bounds.right - p.x / 240 * bounds.width : bounds.left + p.x / 240 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
        };
        const distance = progress * length;
        const point = project(distance);
        const before = project(distance - 1);
        const after = project(distance + 1);
        return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
      }

      stageFrontX(index, fraction) {
        const final = index === this.stages.length - 1;
        const width = final ? 80 : 240;
        const progress = Math.max(0, Math.min(1, fraction));
        if (progress === 0 || (!final && progress === 1)) return progress * width;
        const guide = final ? this.flourish : this.paths[index];
        const length = final ? this.flourishLength : this.lengths[index];
        return guide ? guide.getPointAtLength(progress * length).x : progress * width;
      }

      resetStitchDetails() {
        this.stitchTime = -1;
        this.stitchDetails?.forEach(strokes => strokes.forEach(stroke => {
          stroke.began = null;
          stroke.progress = -1;
          stroke.element.style.strokeDashoffset = '1';
          stroke.element.style.opacity = '0';
        }));
      }

      drawStitchDetails(index, front, from, time) {
        const scale = index === this.stages.length - 1 ? 1 : 2 / 3;
        const head = front / scale;
        const start = from / scale;
        const strokes = this.stitchDetails[index];
        strokes.forEach(stroke => {
          if (stroke.end <= start) return;
          const parent = strokes[stroke.parent];
          const outlineReady = !parent || parent.end <= start || parent.progress >= .8;
          if (stroke.began === null && head >= stroke.end + .35 && outlineReady) stroke.began = time + stroke.delay;
          const progress = stroke.began === null ? 0 : Math.max(0, Math.min(1, (time - stroke.began) / stroke.duration));
          if (Math.abs(progress - stroke.progress) < .0001) return;
          stroke.progress = progress;
          stroke.element.style.strokeDashoffset = String(1 - progress);
          stroke.element.style.opacity = progress > 0 ? '1' : '0';
        });
      }

      update() {
        const { left, right, rects } = this.geometry();
        if (!this.track.clientWidth) return;
        this.previous.disabled = this.target === 0;
        this.next.disabled = this.target === this.stages.length - 1;
        let visible = rects.reduce((indices, rect, index) => {
          const overlap = Math.max(0, Math.min(rect.right, right) - Math.max(rect.left, left));
          if (overlap >= Math.min(rect.width, right - left) * .5) indices.push(index);
          return indices;
        }, []);
        if (!visible.length) visible = [this.target];
        const start = String(visible[0] + 1).padStart(2, '0');
        const end = String(visible[visible.length - 1] + 1).padStart(2, '0');
        const count = String(this.stages.length).padStart(2, '0');
        const compact = start + '–' + end + ' / ' + count;
        if (this.counter.textContent !== compact) {
          this.counter.textContent = compact;
          this.status.textContent = this.dataset.visibleStages.replaceAll('[start]', start).replaceAll('[end]', end).replaceAll('[count]', count);
        }
        this.maxReached = Math.max(this.maxReached, this.position + .085);
        this.jamaCompleted.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const progress = Math.max(0, Math.min(1, (this.maxReached - index) / (final ? .085 : 1)));
          clip.setAttribute('width', String(this.stageFrontX(index, progress)));
        });
        this.progress.style.setProperty('--kk-sj-progress', String(Math.min(1, (this.maxReached + 1) / this.stages.length)));
        this.stages.forEach((stage, index) => {
          stage.style.setProperty('--kk-sj-stage-progress', String(Math.max(0, Math.min(1, this.maxReached - index))));
          if (this.maxReached >= index + .085) stage.classList.add('is-stitched');
        });
        this.renderNeedle(this.position, this.position >= this.stages.length - 1 ? 0 : 1);
      }

      renderNeedle(position, opacity = 1, time = 0) {
        if (this.reduceMotion.matches || opacity <= 0) {
          this.needle.hidden = true;
          return;
        }
        const point = this.needlePoint(position);
        this.needle.hidden = false;
        this.needle.style.opacity = String(opacity);
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const oscillation = Math.sin(time * Math.PI * 2 / 680) * 3;
        const tilt = direction * (18 + oscillation);
        this.needle.style.transform = 'translate(' + point.x + 'px,' + point.y + 'px) rotate(' + (point.angle + tilt) + 'deg)';
      }

      canLoop() {
        return this.loopButton && this.isConnected && this.controller && this.loopVisible && !this.loopPaused && !this.loopFocus && !this.reduceMotion.matches && !document.hidden && !this.animating && !this.activePointers.size && this.paths.length;
      }

      queueLoop(delay = 1200) {
        clearTimeout(this.loopTimer);
        if (!this.canLoop() || this.loopFrame) return;
        this.loopTimer = setTimeout(() => {
          if (!this.canLoop()) return;
          if (!this.loopRangeCache) this.loopRangeCache = this.makeLoopPlan(this.visibleLoopRange());
          if (this.loopRangeCache.end - this.loopRangeCache.start < .03) return;
          this.loopStamp = 0;
          this.loopFrame = requestAnimationFrame(now => this.drawLoop(now));
        }, delay);
      }

      visibleLoopRange() {
        const bounds = this.viewport.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const last = this.stages.length - 1;
        const margin = Math.min(46, bounds.width / 5);
        let start = null, end = null;
        this.paths.forEach((path, index) => {
          const rect = path.ownerSVGElement.getBoundingClientRect();
          if (rect.right < bounds.left || rect.left > bounds.right) return;
          const length = this.lengths[index];
          for (let sample = 0; sample <= 120; sample++) {
            const progress = sample / 120;
            const point = path.getPointAtLength(length * progress);
            const x = (rtl ? rect.right - point.x / 240 * rect.width : rect.left + point.x / 240 * rect.width) - bounds.left;
            const position = Math.max(0, Math.min(last, index + progress - .085));
            if (x >= margin && x <= bounds.width - margin) {
              if (start === null) start = position;
              end = position;
            }
          }
        });
        if (this.flourish) {
          const final = this.needlePoint(last);
          if (final.x >= margin && final.x <= bounds.width - margin) end = last;
        }
        return { start: start ?? 0, end: end ?? start ?? 0, duration: Math.max(7200, Math.min(16500, (bounds.width - 92) / .075)) };
      }

      makeLoopPlan(range) {
        const boundaries = this.nodes.map((node, index) => index - .085).filter(position => position > range.start && position < range.end);
        const positions = [range.start, ...boundaries, range.end];
        const points = positions.map(position => this.needlePoint(position));
        const total = Math.abs(points[points.length - 1].x - points[0].x) || 1;
        let elapsed = 0;
        const segments = positions.slice(1).map((position, index) => {
          const duration = range.duration * Math.abs(points[index + 1].x - points[index].x) / total;
          const segment = { from: positions[index], to: position, at: elapsed, duration };
          elapsed += duration;
          return segment;
        }).filter(segment => segment.duration > 0);
        return { ...range, duration: elapsed, segments };
      }

      loopPose(time, plan) {
        const segment = plan.segments.find(item => time < item.at + item.duration);
        if (!segment) return plan.end;
        const progress = Math.max(0, Math.min(1, (time - segment.at) / segment.duration));
        return segment.from + (segment.to - segment.from) * progress;
      }

      drawLoop(now) {
        this.loopFrame = null;
        if (!this.canLoop()) { this.loopStamp = 0; return; }
        if (this.loopStamp) this.loopElapsed += Math.min(64, now - this.loopStamp);
        this.loopStamp = now;
        const { start, duration } = this.loopRangeCache;
        const time = this.loopElapsed % (duration + 4200);
        if (time < this.stitchTime) this.resetStitchDetails();
        this.stitchTime = time;
        const position = this.loopPose(time, this.loopRangeCache);
        const opacity = Math.max(0, Math.min(1, time / 400, (duration + 4000 - time) / 1000));
        const needleOpacity = Math.max(0, Math.min(opacity, (duration - time) / 240));
        this.renderNeedle(position, needleOpacity, time);
        const visual = position + .085;
        const tail = start + .085;
        this.jamaMotion.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const span = final ? .085 : 1;
          const width = final ? 80 : 240;
          const from = Math.max(0, Math.min(1, (tail - index) / span));
          const rawFront = this.stageFrontX(index, (visual - index) / span);
          const fromX = this.stageFrontX(index, from);
          const completed = Math.max(0, Math.min(from, (this.maxReached - index) / span));
          this.jamaCompleted[index].setAttribute('width', String(this.stageFrontX(index, completed)));
          const front = Math.max(fromX, Math.min(width, rawFront));
          const edge = 'M' + fromX + ' 0H' + front + 'V48H' + fromX + 'Z';
          clip.setAttribute('d', edge);
          this.drawStitchDetails(index, rawFront, fromX, time);
          this.jamaLayers[index].style.opacity = String(rawFront > fromX ? opacity : 0);
        });
        this.loopFrame = requestAnimationFrame(next => this.drawLoop(next));
      }

      stopLoop(reset = false) {
        cancelAnimationFrame(this.loopFrame);
        clearTimeout(this.loopTimer);
        this.loopFrame = null;
        this.loopStamp = 0;
        if (reset) {
          this.resetStitchDetails();
          this.loopElapsed = 0;
          this.loopRangeCache = null;
          this.jamaLayers?.forEach(layer => { layer.style.opacity = '0'; });
          this.jamaMotion?.forEach(clip => { clip.setAttribute('d', 'M0 0'); });
        }
      }

      stopMotion() {
        cancelAnimationFrame(this.motionFrame);
        clearTimeout(this.settleTimer);
        this.motionFrame = null;
        this.animating = false;
      }

      disconnectedCallback() {
        this.stopLoop();
        this.loopObserver?.disconnect();
        this.stopMotion();
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-poncho-making"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('kk-shawl-journey')) {
    customElements.define('kk-shawl-journey', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-journey-track]');
        this.viewport = this.querySelector('[data-journey-viewport]');
        this.needle = this.querySelector('[data-journey-needle]');
        this.stages = Array.from(this.querySelectorAll('[data-journey-stage]'));
        this.nodes = Array.from(this.querySelectorAll('[data-journey-choose]'));
        this.paths = Array.from(this.querySelectorAll('[data-journey-guide]'));
        this.flourish = this.querySelector('[data-journey-final-guide]');
        this.activePointers = new Set();
        this.loopButton = this.querySelector('[data-journey-loop]');
        this.jamaCompleted = Array.from(this.querySelectorAll('[data-jama-completed-clip]'));
        this.jamaMotion = Array.from(this.querySelectorAll('[data-jama-motion-clip]'));
        this.jamaLayers = Array.from(this.querySelectorAll('[data-jama-motion-layer]'));
        this.stitchDetails = this.jamaLayers.map(layer => Array.from(layer.querySelectorAll('[data-stitch-detail]'), element => ({
          element, end: Number(element.dataset.stitchEnd), duration: Number(element.dataset.stitchDuration), delay: Number(element.dataset.stitchDelay), parent: Number(element.dataset.stitchParent), began: null, progress: -1
        })));
        this.stitchTime = -1;
        this.loopElapsed = 0;
        this.loopVisible = false;
        this.loopFocus = false;
        this.previous = this.querySelector('[data-journey-previous]');
        this.next = this.querySelector('[data-journey-next]');
        this.counter = this.querySelector('[data-journey-counter]');
        this.status = this.querySelector('[data-journey-status]');
        this.progress = this.querySelector('[data-journey-progress]');
        if (!this.track || !this.stages.length || !this.needle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.lengths = this.paths.map(path => path.getTotalLength());
        this.flourishLength = this.flourish?.getTotalLength() || 0;
        this.position = 0;
        this.target = 0;
        this.maxReached = this.maxReached || 0;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.nodes.forEach((node, index) => {
          node.disabled = false;
          node.addEventListener('click', () => this.select(index), options);
        });
        this.track.addEventListener('scroll', () => {
          if (this.animating || performance.now() < (this.ignoreScrollUntil || 0)) return;
          this.stopLoop(true);
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.scheduleSettle();
        }, { ...options, passive: true });
        const interrupt = () => {
          this.stopLoop(true);
          this.stopMotion();
          this.ignoreScrollUntil = 0;
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.queueLoop(4000);
        };
        this.track.addEventListener('pointerdown', event => {
          this.activePointers.add(event.pointerId);
          this.loopFocus = false;
          interrupt();
        }, { ...options, passive: true });
        const release = event => {
          if (this.activePointers.delete(event.pointerId)) this.scheduleSettle();
        };
        document.addEventListener('pointerup', release, { ...options, passive: true });
        document.addEventListener('pointercancel', release, { ...options, passive: true });
        this.track.addEventListener('wheel', interrupt, { ...options, passive: true });
        this.track.addEventListener('keydown', event => this.onKey(event), options);
        this.reduceMotion.addEventListener('change', () => {
          this.select(this.target, false);
          this.loopButton.hidden = this.reduceMotion.matches;
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopLoop();
            if (this.animating) this.select(this.target, false);
          } else this.queueLoop();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.stages.findIndex(stage => stage.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.controller) this.select(this.target, false);
          });
        });
        this.resizeObserver.observe(this.track);
        this.stages.forEach(stage => this.resizeObserver.observe(stage));
        this.querySelector('[data-journey-controls]').hidden = false;
        this.querySelector('[data-journey-reading]').hidden = false;
        this.loopButton.hidden = this.reduceMotion.matches;
        this.loopButton.addEventListener('click', () => {
          this.loopPaused = !this.loopPaused;
          this.loopButton.setAttribute('aria-label', this.loopPaused ? this.loopButton.dataset.playLabel : this.loopButton.dataset.pauseLabel);
          this.loopButton.querySelector('[data-loop-pause]').hidden = this.loopPaused;
          this.loopButton.querySelector('[data-loop-play]').hidden = !this.loopPaused;
          if (this.loopPaused) this.stopLoop();
          else this.queueLoop(0);
        }, options);
        this.track.addEventListener('focusin', event => {
          this.loopFocus = event.target.matches(':focus-visible');
          if (this.loopFocus) this.stopLoop();
          else this.queueLoop();
        }, options);
        this.track.addEventListener('focusout', event => {
          if (!this.track.contains(event.relatedTarget)) { this.loopFocus = false; this.queueLoop(); }
        }, options);
        this.loopObserver = new IntersectionObserver(entries => {
          this.loopVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          if (this.loopVisible) this.queueLoop();
          else this.stopLoop();
        }, { threshold: [0, .3] });
        this.loopObserver.observe(this.viewport);
        this.classList.add('is-ready');
        this.select(Math.round(this.indexFromScroll()), false);
      }

      scheduleSettle() {
        clearTimeout(this.settleTimer);
        if (!this.activePointers.size) {
          this.settleTimer = setTimeout(() => {
            if (!this.activePointers.size) this.select(this.target);
          }, 170);
        }
      }

      geometry() {
        const bounds = this.track.getBoundingClientRect();
        const left = bounds.left + this.track.clientLeft;
        const right = left + this.track.clientWidth;
        const rects = this.stages.map(stage => stage.getBoundingClientRect());
        const first = rects[0];
        const last = rects[rects.length - 1];
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        return {
          left, right, rects, rtl,
          leftRoom: Math.max(0, left - Math.min(first.left, last.left)),
          rightRoom: Math.max(0, Math.max(first.right, last.right) - right)
        };
      }

      indexFromScroll() {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        return maximum > 1 ? (g.rtl ? g.rightRoom : g.leftRoom) / maximum * (this.stages.length - 1) : this.target || 0;
      }

      setScrollFraction(fraction) {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        const current = g.rtl ? g.rightRoom : g.leftRoom;
        const desired = Math.max(0, Math.min(1, fraction)) * maximum;
        this.track.scrollBy({ left: (desired - current) * (g.rtl ? -1 : 1), behavior: 'instant' });
      }

      move(direction) {
        this.select(this.target + direction);
      }

      select(index, animate = true) {
        this.stopLoop(true);
        this.stopMotion();
        const last = this.stages.length - 1;
        const next = Math.max(0, Math.min(last, index));
        const start = this.position;
        const scrollStart = last ? this.indexFromScroll() / last : 0;
        this.target = next;
        this.previous.disabled = next === 0;
        this.next.disabled = next === last;
        if (!animate || this.reduceMotion.matches || Math.abs(next - start) < .008) {
          this.position = next;
          this.ignoreScrollUntil = performance.now() + 100;
          this.setScrollFraction(last ? next / last : 0);
          this.update();
          this.arrive(next);
          return;
        }
        this.animating = true;
        const began = performance.now();
        const duration = Math.min(1100, 650 + Math.abs(next - start) * 70);
        const ease = value => value < .5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
        const frame = now => {
          if (!this.isConnected || !this.controller) return;
          const t = Math.min(1, (now - began) / duration);
          this.position = start + (next - start) * ease(t);
          const scrollEase = ease(t);
          this.setScrollFraction(scrollStart + ((last ? next / last : 0) - scrollStart) * scrollEase);
          this.update();
          if (t < 1) this.motionFrame = requestAnimationFrame(frame);
          else {
            this.animating = false;
            this.motionFrame = null;
            this.ignoreScrollUntil = performance.now() + 100;
            this.arrive(next);
          }
        };
        this.motionFrame = requestAnimationFrame(frame);
      }

      arrive(index) {
        this.stages.forEach((stage, i) => {
          stage.classList.toggle('is-current', i === index);
          if (i === index) this.nodes[i].setAttribute('aria-current', 'step');
          else this.nodes[i].removeAttribute('aria-current');
        });
        this.stages[index].classList.add('is-stitched');
        this.queueLoop(3000);
      }

      onKey(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target !== this.track && !this.nodes.includes(event.target)) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.loopFocus = true;
        if (event.key === 'Home') this.select(0);
        else if (event.key === 'End') this.select(this.stages.length - 1);
        else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.geometry().rtl ? -1 : 1));
      }

      needlePoint(position) {
        const last = this.stages.length - 1;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const viewport = this.viewport.getBoundingClientRect();
        if (!this.paths.length) {
          const node = this.nodes[0].getBoundingClientRect();
          return { x: node.left - viewport.left + node.width / 2 + (rtl ? -24 : 24), y: node.top - viewport.top + node.height / 2, angle: rtl ? 180 : 0 };
        }
        const visual = position + .085;
        if (visual > last && this.flourish) {
          const bounds = this.flourish.ownerSVGElement.getBoundingClientRect();
          const distance = Math.min(1, (visual - last) / .085) * this.flourishLength;
          const project = value => {
            const p = this.flourish.getPointAtLength(Math.max(0, Math.min(this.flourishLength, value)));
            return { x: (rtl ? bounds.right - p.x / 80 * bounds.width : bounds.left + p.x / 80 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
          };
          const point = project(distance);
          const before = project(distance - 1);
          const after = project(distance + 1);
          return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
        }
        const segment = Math.min(last - 1, Math.max(0, Math.floor(visual)));
        const progress = Math.min(1, visual - segment);
        const path = this.paths[segment];
        const length = this.lengths[segment];
        const bounds = path.ownerSVGElement.getBoundingClientRect();
        const project = distance => {
          const p = path.getPointAtLength(Math.max(0, Math.min(length, distance)));
          return { x: (rtl ? bounds.right - p.x / 240 * bounds.width : bounds.left + p.x / 240 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
        };
        const distance = progress * length;
        const point = project(distance);
        const before = project(distance - 1);
        const after = project(distance + 1);
        return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
      }

      stageFrontX(index, fraction) {
        const final = index === this.stages.length - 1;
        const width = final ? 80 : 240;
        const progress = Math.max(0, Math.min(1, fraction));
        if (progress === 0 || (!final && progress === 1)) return progress * width;
        const guide = final ? this.flourish : this.paths[index];
        const length = final ? this.flourishLength : this.lengths[index];
        return guide ? guide.getPointAtLength(progress * length).x : progress * width;
      }

      resetStitchDetails() {
        this.stitchTime = -1;
        this.stitchDetails?.forEach(strokes => strokes.forEach(stroke => {
          stroke.began = null;
          stroke.progress = -1;
          stroke.element.style.strokeDashoffset = '1';
          stroke.element.style.opacity = '0';
        }));
      }

      drawStitchDetails(index, front, from, time) {
        const scale = index === this.stages.length - 1 ? 1 : 2 / 3;
        const head = front / scale;
        const start = from / scale;
        const strokes = this.stitchDetails[index];
        strokes.forEach(stroke => {
          if (stroke.end <= start) return;
          const parent = strokes[stroke.parent];
          const outlineReady = !parent || parent.end <= start || parent.progress >= .8;
          if (stroke.began === null && head >= stroke.end + .35 && outlineReady) stroke.began = time + stroke.delay;
          const progress = stroke.began === null ? 0 : Math.max(0, Math.min(1, (time - stroke.began) / stroke.duration));
          if (Math.abs(progress - stroke.progress) < .0001) return;
          stroke.progress = progress;
          stroke.element.style.strokeDashoffset = String(1 - progress);
          stroke.element.style.opacity = progress > 0 ? '1' : '0';
        });
      }

      update() {
        const { left, right, rects } = this.geometry();
        if (!this.track.clientWidth) return;
        this.previous.disabled = this.target === 0;
        this.next.disabled = this.target === this.stages.length - 1;
        let visible = rects.reduce((indices, rect, index) => {
          const overlap = Math.max(0, Math.min(rect.right, right) - Math.max(rect.left, left));
          if (overlap >= Math.min(rect.width, right - left) * .5) indices.push(index);
          return indices;
        }, []);
        if (!visible.length) visible = [this.target];
        const start = String(visible[0] + 1).padStart(2, '0');
        const end = String(visible[visible.length - 1] + 1).padStart(2, '0');
        const count = String(this.stages.length).padStart(2, '0');
        const compact = start + '–' + end + ' / ' + count;
        if (this.counter.textContent !== compact) {
          this.counter.textContent = compact;
          this.status.textContent = this.dataset.visibleStages.replaceAll('[start]', start).replaceAll('[end]', end).replaceAll('[count]', count);
        }
        this.maxReached = Math.max(this.maxReached, this.position + .085);
        this.jamaCompleted.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const progress = Math.max(0, Math.min(1, (this.maxReached - index) / (final ? .085 : 1)));
          clip.setAttribute('width', String(this.stageFrontX(index, progress)));
        });
        this.progress.style.setProperty('--kk-sj-progress', String(Math.min(1, (this.maxReached + 1) / this.stages.length)));
        this.stages.forEach((stage, index) => {
          stage.style.setProperty('--kk-sj-stage-progress', String(Math.max(0, Math.min(1, this.maxReached - index))));
          if (this.maxReached >= index + .085) stage.classList.add('is-stitched');
        });
        this.renderNeedle(this.position, this.position >= this.stages.length - 1 ? 0 : 1);
      }

      renderNeedle(position, opacity = 1, time = 0) {
        if (this.reduceMotion.matches || opacity <= 0) {
          this.needle.hidden = true;
          return;
        }
        const point = this.needlePoint(position);
        this.needle.hidden = false;
        this.needle.style.opacity = String(opacity);
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const oscillation = Math.sin(time * Math.PI * 2 / 680) * 3;
        const tilt = direction * (18 + oscillation);
        this.needle.style.transform = 'translate(' + point.x + 'px,' + point.y + 'px) rotate(' + (point.angle + tilt) + 'deg)';
      }

      canLoop() {
        return this.loopButton && this.isConnected && this.controller && this.loopVisible && !this.loopPaused && !this.loopFocus && !this.reduceMotion.matches && !document.hidden && !this.animating && !this.activePointers.size && this.paths.length;
      }

      queueLoop(delay = 1200) {
        clearTimeout(this.loopTimer);
        if (!this.canLoop() || this.loopFrame) return;
        this.loopTimer = setTimeout(() => {
          if (!this.canLoop()) return;
          if (!this.loopRangeCache) this.loopRangeCache = this.makeLoopPlan(this.visibleLoopRange());
          if (this.loopRangeCache.end - this.loopRangeCache.start < .03) return;
          this.loopStamp = 0;
          this.loopFrame = requestAnimationFrame(now => this.drawLoop(now));
        }, delay);
      }

      visibleLoopRange() {
        const bounds = this.viewport.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const last = this.stages.length - 1;
        const margin = Math.min(46, bounds.width / 5);
        let start = null, end = null;
        this.paths.forEach((path, index) => {
          const rect = path.ownerSVGElement.getBoundingClientRect();
          if (rect.right < bounds.left || rect.left > bounds.right) return;
          const length = this.lengths[index];
          for (let sample = 0; sample <= 120; sample++) {
            const progress = sample / 120;
            const point = path.getPointAtLength(length * progress);
            const x = (rtl ? rect.right - point.x / 240 * rect.width : rect.left + point.x / 240 * rect.width) - bounds.left;
            const position = Math.max(0, Math.min(last, index + progress - .085));
            if (x >= margin && x <= bounds.width - margin) {
              if (start === null) start = position;
              end = position;
            }
          }
        });
        if (this.flourish) {
          const final = this.needlePoint(last);
          if (final.x >= margin && final.x <= bounds.width - margin) end = last;
        }
        return { start: start ?? 0, end: end ?? start ?? 0, duration: Math.max(7200, Math.min(16500, (bounds.width - 92) / .075)) };
      }

      makeLoopPlan(range) {
        const boundaries = this.nodes.map((node, index) => index - .085).filter(position => position > range.start && position < range.end);
        const positions = [range.start, ...boundaries, range.end];
        const points = positions.map(position => this.needlePoint(position));
        const total = Math.abs(points[points.length - 1].x - points[0].x) || 1;
        let elapsed = 0;
        const segments = positions.slice(1).map((position, index) => {
          const duration = range.duration * Math.abs(points[index + 1].x - points[index].x) / total;
          const segment = { from: positions[index], to: position, at: elapsed, duration };
          elapsed += duration;
          return segment;
        }).filter(segment => segment.duration > 0);
        return { ...range, duration: elapsed, segments };
      }

      loopPose(time, plan) {
        const segment = plan.segments.find(item => time < item.at + item.duration);
        if (!segment) return plan.end;
        const progress = Math.max(0, Math.min(1, (time - segment.at) / segment.duration));
        return segment.from + (segment.to - segment.from) * progress;
      }

      drawLoop(now) {
        this.loopFrame = null;
        if (!this.canLoop()) { this.loopStamp = 0; return; }
        if (this.loopStamp) this.loopElapsed += Math.min(64, now - this.loopStamp);
        this.loopStamp = now;
        const { start, duration } = this.loopRangeCache;
        const time = this.loopElapsed % (duration + 4200);
        if (time < this.stitchTime) this.resetStitchDetails();
        this.stitchTime = time;
        const position = this.loopPose(time, this.loopRangeCache);
        const opacity = Math.max(0, Math.min(1, time / 400, (duration + 4000 - time) / 1000));
        const needleOpacity = Math.max(0, Math.min(opacity, (duration - time) / 240));
        this.renderNeedle(position, needleOpacity, time);
        const visual = position + .085;
        const tail = start + .085;
        this.jamaMotion.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const span = final ? .085 : 1;
          const width = final ? 80 : 240;
          const from = Math.max(0, Math.min(1, (tail - index) / span));
          const rawFront = this.stageFrontX(index, (visual - index) / span);
          const fromX = this.stageFrontX(index, from);
          const completed = Math.max(0, Math.min(from, (this.maxReached - index) / span));
          this.jamaCompleted[index].setAttribute('width', String(this.stageFrontX(index, completed)));
          const front = Math.max(fromX, Math.min(width, rawFront));
          const edge = 'M' + fromX + ' 0H' + front + 'V48H' + fromX + 'Z';
          clip.setAttribute('d', edge);
          this.drawStitchDetails(index, rawFront, fromX, time);
          this.jamaLayers[index].style.opacity = String(rawFront > fromX ? opacity : 0);
        });
        this.loopFrame = requestAnimationFrame(next => this.drawLoop(next));
      }

      stopLoop(reset = false) {
        cancelAnimationFrame(this.loopFrame);
        clearTimeout(this.loopTimer);
        this.loopFrame = null;
        this.loopStamp = 0;
        if (reset) {
          this.resetStitchDetails();
          this.loopElapsed = 0;
          this.loopRangeCache = null;
          this.jamaLayers?.forEach(layer => { layer.style.opacity = '0'; });
          this.jamaMotion?.forEach(clip => { clip.setAttribute('d', 'M0 0'); });
        }
      }

      stopMotion() {
        cancelAnimationFrame(this.motionFrame);
        clearTimeout(this.settleTimer);
        this.motionFrame = null;
        this.animating = false;
      }

      disconnectedCallback() {
        this.stopLoop();
        this.loopObserver?.disconnect();
        this.stopMotion();
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-rug-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-rug-film')) {
    customElements.define('kk-rug-film', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.video.muted = true;
        this.video.controls = false;
        this.button.hidden = false;
        const sync = () => {
          this.toggleAttribute('data-paused', this.video.paused);
          this.button.querySelector('span').textContent = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        };
        this.video.addEventListener('play', sync, options);
        this.video.addEventListener('pause', sync, options);
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (this.userPaused) this.video.pause();
          else this.video.play().catch(sync);
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const visible = entries[0].isIntersecting;
            if (visible && !this.userPaused) this.video.play().catch(sync);
            else this.video.pause();
          }, { threshold: 0.15 });
          this.observer.observe(this.video);
        } else if (this.userPaused) this.video.pause();
        sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-shawl-making"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('kk-shawl-journey')) {
    customElements.define('kk-shawl-journey', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-journey-track]');
        this.viewport = this.querySelector('[data-journey-viewport]');
        this.needle = this.querySelector('[data-journey-needle]');
        this.stages = Array.from(this.querySelectorAll('[data-journey-stage]'));
        this.nodes = Array.from(this.querySelectorAll('[data-journey-choose]'));
        this.paths = Array.from(this.querySelectorAll('[data-journey-guide]'));
        this.flourish = this.querySelector('[data-journey-final-guide]');
        this.activePointers = new Set();
        this.loopButton = this.querySelector('[data-journey-loop]');
        this.jamaCompleted = Array.from(this.querySelectorAll('[data-jama-completed-clip]'));
        this.jamaMotion = Array.from(this.querySelectorAll('[data-jama-motion-clip]'));
        this.jamaLayers = Array.from(this.querySelectorAll('[data-jama-motion-layer]'));
        this.stitchDetails = this.jamaLayers.map(layer => Array.from(layer.querySelectorAll('[data-stitch-detail]'), element => ({
          element, end: Number(element.dataset.stitchEnd), duration: Number(element.dataset.stitchDuration), delay: Number(element.dataset.stitchDelay), parent: Number(element.dataset.stitchParent), began: null, progress: -1
        })));
        this.stitchTime = -1;
        this.loopElapsed = 0;
        this.loopVisible = false;
        this.loopFocus = false;
        this.previous = this.querySelector('[data-journey-previous]');
        this.next = this.querySelector('[data-journey-next]');
        this.counter = this.querySelector('[data-journey-counter]');
        this.status = this.querySelector('[data-journey-status]');
        this.progress = this.querySelector('[data-journey-progress]');
        if (!this.track || !this.stages.length || !this.needle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.lengths = this.paths.map(path => path.getTotalLength());
        this.flourishLength = this.flourish?.getTotalLength() || 0;
        this.position = 0;
        this.target = 0;
        this.maxReached = this.maxReached || 0;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.nodes.forEach((node, index) => {
          node.disabled = false;
          node.addEventListener('click', () => this.select(index), options);
        });
        this.track.addEventListener('scroll', () => {
          if (this.animating || performance.now() < (this.ignoreScrollUntil || 0)) return;
          this.stopLoop(true);
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.scheduleSettle();
        }, { ...options, passive: true });
        const interrupt = () => {
          this.stopLoop(true);
          this.stopMotion();
          this.ignoreScrollUntil = 0;
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.queueLoop(4000);
        };
        this.track.addEventListener('pointerdown', event => {
          this.activePointers.add(event.pointerId);
          this.loopFocus = false;
          interrupt();
        }, { ...options, passive: true });
        const release = event => {
          if (this.activePointers.delete(event.pointerId)) this.scheduleSettle();
        };
        document.addEventListener('pointerup', release, { ...options, passive: true });
        document.addEventListener('pointercancel', release, { ...options, passive: true });
        this.track.addEventListener('wheel', interrupt, { ...options, passive: true });
        this.track.addEventListener('keydown', event => this.onKey(event), options);
        this.reduceMotion.addEventListener('change', () => {
          this.select(this.target, false);
          this.loopButton.hidden = this.reduceMotion.matches;
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopLoop();
            if (this.animating) this.select(this.target, false);
          } else this.queueLoop();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.stages.findIndex(stage => stage.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.controller) this.select(this.target, false);
          });
        });
        this.resizeObserver.observe(this.track);
        this.stages.forEach(stage => this.resizeObserver.observe(stage));
        this.querySelector('[data-journey-controls]').hidden = false;
        this.querySelector('[data-journey-reading]').hidden = false;
        this.loopButton.hidden = this.reduceMotion.matches;
        this.loopButton.addEventListener('click', () => {
          this.loopPaused = !this.loopPaused;
          this.loopButton.setAttribute('aria-label', this.loopPaused ? this.loopButton.dataset.playLabel : this.loopButton.dataset.pauseLabel);
          this.loopButton.querySelector('[data-loop-pause]').hidden = this.loopPaused;
          this.loopButton.querySelector('[data-loop-play]').hidden = !this.loopPaused;
          if (this.loopPaused) this.stopLoop();
          else this.queueLoop(0);
        }, options);
        this.track.addEventListener('focusin', event => {
          this.loopFocus = event.target.matches(':focus-visible');
          if (this.loopFocus) this.stopLoop();
          else this.queueLoop();
        }, options);
        this.track.addEventListener('focusout', event => {
          if (!this.track.contains(event.relatedTarget)) { this.loopFocus = false; this.queueLoop(); }
        }, options);
        this.loopObserver = new IntersectionObserver(entries => {
          this.loopVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          if (this.loopVisible) this.queueLoop();
          else this.stopLoop();
        }, { threshold: [0, .3] });
        this.loopObserver.observe(this.viewport);
        this.classList.add('is-ready');
        this.select(Math.round(this.indexFromScroll()), false);
      }

      scheduleSettle() {
        clearTimeout(this.settleTimer);
        if (!this.activePointers.size) {
          this.settleTimer = setTimeout(() => {
            if (!this.activePointers.size) this.select(this.target);
          }, 170);
        }
      }

      geometry() {
        const bounds = this.track.getBoundingClientRect();
        const left = bounds.left + this.track.clientLeft;
        const right = left + this.track.clientWidth;
        const rects = this.stages.map(stage => stage.getBoundingClientRect());
        const first = rects[0];
        const last = rects[rects.length - 1];
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        return {
          left, right, rects, rtl,
          leftRoom: Math.max(0, left - Math.min(first.left, last.left)),
          rightRoom: Math.max(0, Math.max(first.right, last.right) - right)
        };
      }

      indexFromScroll() {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        return maximum > 1 ? (g.rtl ? g.rightRoom : g.leftRoom) / maximum * (this.stages.length - 1) : this.target || 0;
      }

      setScrollFraction(fraction) {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        const current = g.rtl ? g.rightRoom : g.leftRoom;
        const desired = Math.max(0, Math.min(1, fraction)) * maximum;
        this.track.scrollBy({ left: (desired - current) * (g.rtl ? -1 : 1), behavior: 'instant' });
      }

      move(direction) {
        this.select(this.target + direction);
      }

      select(index, animate = true) {
        this.stopLoop(true);
        this.stopMotion();
        const last = this.stages.length - 1;
        const next = Math.max(0, Math.min(last, index));
        const start = this.position;
        const scrollStart = last ? this.indexFromScroll() / last : 0;
        this.target = next;
        this.previous.disabled = next === 0;
        this.next.disabled = next === last;
        if (!animate || this.reduceMotion.matches || Math.abs(next - start) < .008) {
          this.position = next;
          this.ignoreScrollUntil = performance.now() + 100;
          this.setScrollFraction(last ? next / last : 0);
          this.update();
          this.arrive(next);
          return;
        }
        this.animating = true;
        const began = performance.now();
        const duration = Math.min(1100, 650 + Math.abs(next - start) * 70);
        const ease = value => value < .5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
        const frame = now => {
          if (!this.isConnected || !this.controller) return;
          const t = Math.min(1, (now - began) / duration);
          this.position = start + (next - start) * ease(t);
          const scrollEase = ease(t);
          this.setScrollFraction(scrollStart + ((last ? next / last : 0) - scrollStart) * scrollEase);
          this.update();
          if (t < 1) this.motionFrame = requestAnimationFrame(frame);
          else {
            this.animating = false;
            this.motionFrame = null;
            this.ignoreScrollUntil = performance.now() + 100;
            this.arrive(next);
          }
        };
        this.motionFrame = requestAnimationFrame(frame);
      }

      arrive(index) {
        this.stages.forEach((stage, i) => {
          stage.classList.toggle('is-current', i === index);
          if (i === index) this.nodes[i].setAttribute('aria-current', 'step');
          else this.nodes[i].removeAttribute('aria-current');
        });
        this.stages[index].classList.add('is-stitched');
        this.queueLoop(3000);
      }

      onKey(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target !== this.track && !this.nodes.includes(event.target)) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.loopFocus = true;
        if (event.key === 'Home') this.select(0);
        else if (event.key === 'End') this.select(this.stages.length - 1);
        else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.geometry().rtl ? -1 : 1));
      }

      needlePoint(position) {
        const last = this.stages.length - 1;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const viewport = this.viewport.getBoundingClientRect();
        if (!this.paths.length) {
          const node = this.nodes[0].getBoundingClientRect();
          return { x: node.left - viewport.left + node.width / 2 + (rtl ? -24 : 24), y: node.top - viewport.top + node.height / 2, angle: rtl ? 180 : 0 };
        }
        const visual = position + .085;
        if (visual > last && this.flourish) {
          const bounds = this.flourish.ownerSVGElement.getBoundingClientRect();
          const distance = Math.min(1, (visual - last) / .085) * this.flourishLength;
          const project = value => {
            const p = this.flourish.getPointAtLength(Math.max(0, Math.min(this.flourishLength, value)));
            return { x: (rtl ? bounds.right - p.x / 80 * bounds.width : bounds.left + p.x / 80 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
          };
          const point = project(distance);
          const before = project(distance - 1);
          const after = project(distance + 1);
          return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
        }
        const segment = Math.min(last - 1, Math.max(0, Math.floor(visual)));
        const progress = Math.min(1, visual - segment);
        const path = this.paths[segment];
        const length = this.lengths[segment];
        const bounds = path.ownerSVGElement.getBoundingClientRect();
        const project = distance => {
          const p = path.getPointAtLength(Math.max(0, Math.min(length, distance)));
          return { x: (rtl ? bounds.right - p.x / 240 * bounds.width : bounds.left + p.x / 240 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
        };
        const distance = progress * length;
        const point = project(distance);
        const before = project(distance - 1);
        const after = project(distance + 1);
        return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
      }

      stageFrontX(index, fraction) {
        const final = index === this.stages.length - 1;
        const width = final ? 80 : 240;
        const progress = Math.max(0, Math.min(1, fraction));
        if (progress === 0 || (!final && progress === 1)) return progress * width;
        const guide = final ? this.flourish : this.paths[index];
        const length = final ? this.flourishLength : this.lengths[index];
        return guide ? guide.getPointAtLength(progress * length).x : progress * width;
      }

      resetStitchDetails() {
        this.stitchTime = -1;
        this.stitchDetails?.forEach(strokes => strokes.forEach(stroke => {
          stroke.began = null;
          stroke.progress = -1;
          stroke.element.style.strokeDashoffset = '1';
          stroke.element.style.opacity = '0';
        }));
      }

      drawStitchDetails(index, front, from, time) {
        const scale = index === this.stages.length - 1 ? 1 : 2 / 3;
        const head = front / scale;
        const start = from / scale;
        const strokes = this.stitchDetails[index];
        strokes.forEach(stroke => {
          if (stroke.end <= start) return;
          const parent = strokes[stroke.parent];
          const outlineReady = !parent || parent.end <= start || parent.progress >= .8;
          if (stroke.began === null && head >= stroke.end + .35 && outlineReady) stroke.began = time + stroke.delay;
          const progress = stroke.began === null ? 0 : Math.max(0, Math.min(1, (time - stroke.began) / stroke.duration));
          if (Math.abs(progress - stroke.progress) < .0001) return;
          stroke.progress = progress;
          stroke.element.style.strokeDashoffset = String(1 - progress);
          stroke.element.style.opacity = progress > 0 ? '1' : '0';
        });
      }

      update() {
        const { left, right, rects } = this.geometry();
        if (!this.track.clientWidth) return;
        this.previous.disabled = this.target === 0;
        this.next.disabled = this.target === this.stages.length - 1;
        let visible = rects.reduce((indices, rect, index) => {
          const overlap = Math.max(0, Math.min(rect.right, right) - Math.max(rect.left, left));
          if (overlap >= Math.min(rect.width, right - left) * .5) indices.push(index);
          return indices;
        }, []);
        if (!visible.length) visible = [this.target];
        const start = String(visible[0] + 1).padStart(2, '0');
        const end = String(visible[visible.length - 1] + 1).padStart(2, '0');
        const count = String(this.stages.length).padStart(2, '0');
        const compact = start + '–' + end + ' / ' + count;
        if (this.counter.textContent !== compact) {
          this.counter.textContent = compact;
          this.status.textContent = this.dataset.visibleStages.replaceAll('[start]', start).replaceAll('[end]', end).replaceAll('[count]', count);
        }
        this.maxReached = Math.max(this.maxReached, this.position + .085);
        this.jamaCompleted.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const progress = Math.max(0, Math.min(1, (this.maxReached - index) / (final ? .085 : 1)));
          clip.setAttribute('width', String(this.stageFrontX(index, progress)));
        });
        this.progress.style.setProperty('--kk-sj-progress', String(Math.min(1, (this.maxReached + 1) / this.stages.length)));
        this.stages.forEach((stage, index) => {
          stage.style.setProperty('--kk-sj-stage-progress', String(Math.max(0, Math.min(1, this.maxReached - index))));
          if (this.maxReached >= index + .085) stage.classList.add('is-stitched');
        });
        this.renderNeedle(this.position, this.position >= this.stages.length - 1 ? 0 : 1);
      }

      renderNeedle(position, opacity = 1, time = 0) {
        if (this.reduceMotion.matches || opacity <= 0) {
          this.needle.hidden = true;
          return;
        }
        const point = this.needlePoint(position);
        this.needle.hidden = false;
        this.needle.style.opacity = String(opacity);
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const oscillation = Math.sin(time * Math.PI * 2 / 680) * 3;
        const tilt = direction * (18 + oscillation);
        this.needle.style.transform = 'translate(' + point.x + 'px,' + point.y + 'px) rotate(' + (point.angle + tilt) + 'deg)';
      }

      canLoop() {
        return this.loopButton && this.isConnected && this.controller && this.loopVisible && !this.loopPaused && !this.loopFocus && !this.reduceMotion.matches && !document.hidden && !this.animating && !this.activePointers.size && this.paths.length;
      }

      queueLoop(delay = 1200) {
        clearTimeout(this.loopTimer);
        if (!this.canLoop() || this.loopFrame) return;
        this.loopTimer = setTimeout(() => {
          if (!this.canLoop()) return;
          if (!this.loopRangeCache) this.loopRangeCache = this.makeLoopPlan(this.visibleLoopRange());
          if (this.loopRangeCache.end - this.loopRangeCache.start < .03) return;
          this.loopStamp = 0;
          this.loopFrame = requestAnimationFrame(now => this.drawLoop(now));
        }, delay);
      }

      visibleLoopRange() {
        const bounds = this.viewport.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const last = this.stages.length - 1;
        const margin = Math.min(46, bounds.width / 5);
        let start = null, end = null;
        this.paths.forEach((path, index) => {
          const rect = path.ownerSVGElement.getBoundingClientRect();
          if (rect.right < bounds.left || rect.left > bounds.right) return;
          const length = this.lengths[index];
          for (let sample = 0; sample <= 120; sample++) {
            const progress = sample / 120;
            const point = path.getPointAtLength(length * progress);
            const x = (rtl ? rect.right - point.x / 240 * rect.width : rect.left + point.x / 240 * rect.width) - bounds.left;
            const position = Math.max(0, Math.min(last, index + progress - .085));
            if (x >= margin && x <= bounds.width - margin) {
              if (start === null) start = position;
              end = position;
            }
          }
        });
        if (this.flourish) {
          const final = this.needlePoint(last);
          if (final.x >= margin && final.x <= bounds.width - margin) end = last;
        }
        return { start: start ?? 0, end: end ?? start ?? 0, duration: Math.max(7200, Math.min(16500, (bounds.width - 92) / .075)) };
      }

      makeLoopPlan(range) {
        const boundaries = this.nodes.map((node, index) => index - .085).filter(position => position > range.start && position < range.end);
        const positions = [range.start, ...boundaries, range.end];
        const points = positions.map(position => this.needlePoint(position));
        const total = Math.abs(points[points.length - 1].x - points[0].x) || 1;
        let elapsed = 0;
        const segments = positions.slice(1).map((position, index) => {
          const duration = range.duration * Math.abs(points[index + 1].x - points[index].x) / total;
          const segment = { from: positions[index], to: position, at: elapsed, duration };
          elapsed += duration;
          return segment;
        }).filter(segment => segment.duration > 0);
        return { ...range, duration: elapsed, segments };
      }

      loopPose(time, plan) {
        const segment = plan.segments.find(item => time < item.at + item.duration);
        if (!segment) return plan.end;
        const progress = Math.max(0, Math.min(1, (time - segment.at) / segment.duration));
        return segment.from + (segment.to - segment.from) * progress;
      }

      drawLoop(now) {
        this.loopFrame = null;
        if (!this.canLoop()) { this.loopStamp = 0; return; }
        if (this.loopStamp) this.loopElapsed += Math.min(64, now - this.loopStamp);
        this.loopStamp = now;
        const { start, duration } = this.loopRangeCache;
        const time = this.loopElapsed % (duration + 4200);
        if (time < this.stitchTime) this.resetStitchDetails();
        this.stitchTime = time;
        const position = this.loopPose(time, this.loopRangeCache);
        const opacity = Math.max(0, Math.min(1, time / 400, (duration + 4000 - time) / 1000));
        const needleOpacity = Math.max(0, Math.min(opacity, (duration - time) / 240));
        this.renderNeedle(position, needleOpacity, time);
        const visual = position + .085;
        const tail = start + .085;
        this.jamaMotion.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const span = final ? .085 : 1;
          const width = final ? 80 : 240;
          const from = Math.max(0, Math.min(1, (tail - index) / span));
          const rawFront = this.stageFrontX(index, (visual - index) / span);
          const fromX = this.stageFrontX(index, from);
          const completed = Math.max(0, Math.min(from, (this.maxReached - index) / span));
          this.jamaCompleted[index].setAttribute('width', String(this.stageFrontX(index, completed)));
          const front = Math.max(fromX, Math.min(width, rawFront));
          const edge = 'M' + fromX + ' 0H' + front + 'V48H' + fromX + 'Z';
          clip.setAttribute('d', edge);
          this.drawStitchDetails(index, rawFront, fromX, time);
          this.jamaLayers[index].style.opacity = String(rawFront > fromX ? opacity : 0);
        });
        this.loopFrame = requestAnimationFrame(next => this.drawLoop(next));
      }

      stopLoop(reset = false) {
        cancelAnimationFrame(this.loopFrame);
        clearTimeout(this.loopTimer);
        this.loopFrame = null;
        this.loopStamp = 0;
        if (reset) {
          this.resetStitchDetails();
          this.loopElapsed = 0;
          this.loopRangeCache = null;
          this.jamaLayers?.forEach(layer => { layer.style.opacity = '0'; });
          this.jamaMotion?.forEach(clip => { clip.setAttribute('d', 'M0 0'); });
        }
      }

      stopMotion() {
        cancelAnimationFrame(this.motionFrame);
        clearTimeout(this.settleTimer);
        this.motionFrame = null;
        this.animating = false;
      }

      disconnectedCallback() {
        this.stopLoop();
        this.loopObserver?.disconnect();
        this.stopMotion();
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-silk-carpet-craft"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-silk-craft')) {
    customElements.define('kk-silk-craft', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.toggle = this.querySelector('[data-toggle]');
        this.toggleLabel = this.querySelector('[data-toggle-label]');
        this.status = this.querySelector('[data-status]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.duration = 9500;
        this.index = 0;
        this.elapsed = 0;
        this.lastTime = 0;
        this.paused = false;
        this.inView = false;
        this.focusWithinPanel = false;
        this.parts = this.panels.map(panel => {
          const parts = {};
          panel.querySelectorAll('svg [data-design-reveal], svg [data-design-pencil], svg [data-talim-guide], svg [data-hank], svg [data-bath-wave], svg [data-spool], svg [data-wind-hand], svg [data-warp-guide], svg [data-knot-trace], svg [data-knot-back], svg [data-knot-front], svg [data-knot-cut], svg [data-knot-hand-left], svg [data-knot-hand-right], svg [data-weft-one], svg [data-weft-two], svg [data-weft-tool], svg [data-comb], svg [data-weft-caption], svg [data-comb-caption], svg [data-packed-row], svg [data-finish-sheen], svg [data-finish-shears], svg [data-finish-water], svg [data-finish-air], svg [data-finish-edge-hand]').forEach(element => {
            Object.keys(element.dataset).forEach(key => { parts[key] = element; });
          });
          parts.finishWashHand = panel.querySelector('[data-finish-wash-hand]');
          parts.warps = Array.from(panel.querySelectorAll('[data-warp]'));
          parts.pile = Array.from(panel.querySelectorAll('[data-pile]'));
          parts.drops = Array.from(panel.querySelectorAll('[data-drop]'));
          parts.dyeThreads = Array.from(panel.querySelectorAll('[data-dye-thread]'));
          return parts;
        });
        this.knotLength = this.parts[3].knotTrace.getTotalLength();
        this.panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[index].id);
          panel.tabIndex = 0;
        });
        this.querySelector('[data-tabs]').hidden = false;
        this.dataset.enhanced = '';
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.choose(index), options);
          tab.addEventListener('keydown', event => {
            let next = index;
            const count = this.tabs.length;
            const rtl = getComputedStyle(this).direction === 'rtl';
            if (event.key === 'ArrowRight') next = (index + (rtl ? count - 1 : 1)) % count;
            else if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : count - 1)) % count;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = count - 1;
            else return;
            event.preventDefault();
            this.choose(next);
            this.tabs[next].focus();
          }, options);
        });
        this.panels.forEach(panel => {
          panel.addEventListener('focusin', () => {
            this.focusWithinPanel = true;
            this.reconcile();
          }, options);
          panel.addEventListener('focusout', () => {
            queueMicrotask(() => {
              if (!this.controller) return;
              this.focusWithinPanel = this.panels.some(item => item.contains(document.activeElement));
              this.reconcile();
            });
          }, options);
        });
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.reconcile();
        }, options);
        this.querySelector('[data-replay]').addEventListener('click', () => {
          this.paused = false;
          this.select(0);
          this.reconcile();
        }, options);
        this.motion.addEventListener('change', () => {
          this.elapsed = 0;
          this.applyMotionPreference();
          this.render(this.motion.matches ? 1 : 0);
          this.reconcile();
        }, options);
        document.addEventListener('visibilitychange', () => this.reconcile(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[entries.length - 1].isIntersecting;
            this.reconcile();
          }, { threshold: 0.15 });
          this.observer.observe(this.querySelector('[data-panels]'));
        } else {
          this.inView = true;
        }
        this.applyMotionPreference();
        this.select(0);
        this.reconcile();
      }
      applyMotionPreference() {
        this.querySelector('[data-motion]').hidden = this.motion.matches;
        this.querySelector('[data-reduced]').hidden = !this.motion.matches;
      }
      choose(index) {
        this.select(index);
        this.reconcile();
      }
      select(index) {
        this.index = index;
        this.elapsed = 0;
        this.lastTime = 0;
        this.tabs.forEach((tab, n) => {
          tab.setAttribute('aria-selected', String(n === index));
          tab.tabIndex = n === index ? 0 : -1;
        });
        this.render(this.motion.matches ? 1 : 0);
      }
      canRun() {
        return this.isConnected && this.controller && this.inView && !document.hidden && !this.paused && !this.focusWithinPanel && !this.motion.matches;
      }
      reconcile() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.lastTime = 0;
        const playing = this.canRun();
        const requestedPlay = !this.paused && !this.motion.matches;
        this.dataset.playing = String(requestedPlay);
        this.dataset.running = String(Boolean(playing));
        this.toggleLabel.textContent = requestedPlay ? this.dataset.pause : this.dataset.play;
        this.toggle.setAttribute('aria-label', this.toggleLabel.textContent);
        if (playing) this.frame = requestAnimationFrame(now => this.tick(now));
      }
      tick(now) {
        this.frame = null;
        if (!this.canRun()) return;
        if (this.lastTime) this.elapsed += Math.max(0, now - this.lastTime);
        this.lastTime = now;
        if (this.elapsed >= this.duration) {
          const steps = Math.floor(this.elapsed / this.duration);
          const remainder = this.elapsed % this.duration;
          this.select((this.index + steps) % this.panels.length);
          this.elapsed = remainder;
          this.lastTime = now;
        }
        this.render(this.elapsed / this.duration);
        this.frame = requestAnimationFrame(next => this.tick(next));
      }
      render(p) {
        const blend = this.motion.matches ? 0 : Math.max(0, Math.min(1, (p - .89) / .11));
        const next = (this.index + 1) % this.panels.length;
        this.style.setProperty('--kk-sc-progress', String(p));
        this.panels.forEach((panel, n) => {
          const active = n === this.index;
          const opacity = active ? 1 - blend : n === next ? blend : 0;
          panel.hidden = opacity <= 0;
          panel.style.opacity = String(opacity);
          panel.style.pointerEvents = active ? '' : 'none';
          panel.inert = !active;
          panel.setAttribute('aria-hidden', String(!active));
          panel.tabIndex = active ? 0 : -1;
        });
        this.tabs.forEach((tab, n) => {
          tab.style.setProperty('--kk-sc-step-progress', String(n < this.index ? 1 : n === this.index ? p : 0));
        });
        this.pose(this.index, this.motion.matches ? [.45, .67, .62, .47, .77, .94][this.index] : Math.min(p / .89, 1));
        if (blend > 0) this.pose(next, 0);
      }
      pose(index, p) {
        const a = this.parts[index];
        const clamp = value => Math.max(0, Math.min(1, value));
        const phase = (start, end) => clamp((p - start) / (end - start));
        const move = (element, transform) => { if (element) element.setAttribute('transform', transform); };
        const opacity = (element, value) => { if (element) element.style.opacity = String(value); };
        const draw = (element, value) => { if (element) { element.style.strokeDasharray = '1'; element.style.strokeDashoffset = String(1 - value); } };
        if (index === 0) {
          const q = phase(.03, .81);
          a.designReveal.setAttribute('height', String(q * 232));
          move(a.designPencil, 'translate(' + (91 + 161 * (.5 + .5 * Math.sin(q * Math.PI * 12))) + ' ' + (77 + q * 232) + ') rotate(-33)');
          opacity(a.designPencil, 1 - phase(.84, .93));
          move(a.talimGuide, 'translate(0 ' + Math.min(6, Math.floor(q * 7)) * 24 + ')');
        } else if (index === 1) {
          const lower = phase(.02, .26) - phase(.45, .7);
          move(a.hank, 'translate(0 ' + lower * 93 + ')');
          const dye = phase(.22, .61);
          a.dyeThreads.forEach(thread => thread.setAttribute('stroke', 'rgb(' + Math.round(199 - dye * 27) + ' ' + Math.round(179 - dye * 54) + ' ' + Math.round(140 - dye * 37) + ')'));
          move(a.bathWave, 'translate(' + Math.sin(p * 45) * 3 * lower + ' 0)');
          const angle = phase(.55, .91) * 680;
          move(a.spool, 'translate(462 273) rotate(' + angle + ')');
          const radians = angle * Math.PI / 180;
          move(a.windHand, 'translate(' + (462 + 24 * Math.sin(radians)) + ' ' + (273 - 24 * Math.cos(radians)) + ') scale(-.63 .63)');
          opacity(a.windHand, phase(.5, .55));
        } else if (index === 2) {
          const q = phase(.02, .84);
          a.warps.forEach((warp, n) => draw(warp, clamp(q * 32 - n)));
          move(a.warpGuide, 'translate(' + (161 + q * 279) + ' ' + (200 + Math.sin(q * Math.PI * 4) * 12) + ')');
          opacity(a.warpGuide, 1 - phase(.84, .94));
        } else if (index === 3) {
          const knotProgress = phase(.02, .56);
          draw(a.knotTrace, knotProgress);
          const knotPoint = a.knotTrace.getPointAtLength(knotProgress * this.knotLength);
          move(a.knotHandRight, 'translate(' + knotPoint.x + ' ' + knotPoint.y + ') scale(-.72 .72)');
          opacity(a.knotHandLeft, 1 - phase(.53, .58));
          opacity(a.knotHandRight, phase(.09, .14) * (1 - phase(.53, .58)));
          draw(a.knotFront, phase(.2, .35));
          opacity(a.knotBack, phase(.38, .57));
          move(a.knotCut, 'translate(' + (283 + phase(.57, .72) * 142) + ' 116) rotate(' + Math.sin(phase(.57, .72) * Math.PI * 4) * 8 + ')');
          opacity(a.knotCut, phase(.55, .58) * (1 - phase(.74, .8)));
          a.pile.forEach((pile, n) => opacity(pile, clamp(phase(.68, .92) * 30 - n)));
        } else if (index === 4) {
          const one = phase(.03, .34);
          const two = phase(.36, .59);
          draw(a.weftOne, one);
          draw(a.weftTwo, two);
          move(a.weftTool, 'translate(' + (p < .36 ? 147 + one * 306 : 453 - two * 306) + ' ' + (p < .36 ? 273 : 280) + ')');
          opacity(a.weftTool, 1 - phase(.6, .65));
          const down = phase(.64, .77) - phase(.83, .96);
          move(a.comb, 'translate(0 ' + down * 70 + ')');
          opacity(a.weftCaption, p < .62 ? 1 : 0);
          opacity(a.combCaption, p >= .62 ? 1 : 0);
          opacity(a.packedRow, phase(.77, .81));
        } else {
          move(a.finishShears, 'translate(' + (211 + phase(.01, .25) * 178) + ' ' + (123 + Math.sin(p * 18) * 8) + ')');
          opacity(a.finishShears, 1 - phase(.26, .3));
          const washing = phase(.29, .34) * (1 - phase(.56, .6));
          opacity(a.finishWater, washing);
          opacity(a.finishWashHand, washing);
          const washStroke = phase(.3, .59) * Math.PI * 3;
          move(a.finishWashHand, 'translate(' + (244 + 122 * (.5 + .5 * Math.sin(washStroke))) + ' ' + (234 + 5 * Math.sin(washStroke)) + ') rotate(-10) scale(.72)');
          a.drops.forEach((drop, n) => move(drop, 'translate(0 ' + ((phase(.3, .6) * 320 + n * 23) % 185) + ')'));
          opacity(a.finishAir, phase(.61, .66) * (1 - phase(.83, .89)));
          move(a.finishAir, 'translate(' + Math.sin(p * 26) * 6 + ' 0)');
          move(a.finishSheen, 'translate(' + (-140 + phase(.8, 1) * 350) + ' 0)');
          opacity(a.finishSheen, phase(.8, .85));
          move(a.finishEdgeHand, 'translate(407 ' + (310 + phase(.85, 1) * 10) + ') rotate(-20) scale(-.68 .68)');
          opacity(a.finishEdgeHand, phase(.84, .88));
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-sozni-craft"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kk-sozni-craft')) {
    customElements.define('kk-sozni-craft', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-kk-sozni-toggle]');
        if (!this.video || !this.toggle || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.visible = false;
        this.userPaused = this.userPaused || false;
        this.manualPlay = false;
        this.blocked = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.video.muted = true;
        this.video.controls = false;
        this.toggle.hidden = false;
        this.updateToggle();
        this.toggle.addEventListener('click', () => {
          if (!this.video.paused) {
            this.userPaused = true;
            this.manualPlay = false;
            this.video.pause();
          } else {
            this.userPaused = false;
            this.manualPlay = true;
            this.blocked = false;
            this.visible = true;
            this.syncPlayback();
          }
        }, options);
        this.video.addEventListener('play', () => this.updateToggle(), options);
        this.video.addEventListener('pause', () => this.updateToggle(), options);
        this.video.addEventListener('error', () => {
          this.blocked = true;
          this.video.controls = true;
          this.toggle.hidden = true;
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.reducedMotion.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, options);
        this.connection?.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
            this.syncPlayback();
          }, { threshold: [0, .25] });
          this.observer.observe(this.video);
        }
      }

      canPlay() {
        return this.isConnected && this.visible && !document.hidden && !this.userPaused && !this.blocked &&
          (this.manualPlay || (!this.reducedMotion.matches && !this.connection?.saveData));
      }

      syncPlayback() {
        if (!this.canPlay()) {
          this.video.pause();
          return;
        }
        if (!this.video.paused || this.playPending) return;
        this.playPending = true;
        this.video.play().then(() => {
          if (!this.canPlay()) this.video.pause();
        }).catch(error => {
          if (error.name !== 'AbortError') this.blocked = true;
        }).finally(() => {
          this.playPending = false;
          this.updateToggle();
        });
      }

      updateToggle() {
        const playing = !this.video.paused;
        this.toggle.dataset.playing = String(playing);
        this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.abort?.abort();
        this.abort = null;
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-sozni-saree-making"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('kk-saree-journey')) {
    customElements.define('kk-saree-journey', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-journey-track]');
        this.viewport = this.querySelector('[data-journey-viewport]');
        this.needle = this.querySelector('[data-journey-needle]');
        this.stages = Array.from(this.querySelectorAll('[data-journey-stage]'));
        this.nodes = Array.from(this.querySelectorAll('[data-journey-choose]'));
        this.paths = Array.from(this.querySelectorAll('[data-journey-guide]'));
        this.flourish = this.querySelector('[data-journey-final-guide]');
        this.activePointers = new Set();
        this.loopButton = this.querySelector('[data-journey-loop]');
        this.jamaCompleted = Array.from(this.querySelectorAll('[data-jama-completed-clip]'));
        this.jamaMotion = Array.from(this.querySelectorAll('[data-jama-motion-clip]'));
        this.jamaLayers = Array.from(this.querySelectorAll('[data-jama-motion-layer]'));
        this.stitchDetails = this.jamaLayers.map(layer => Array.from(layer.querySelectorAll('[data-stitch-detail]'), element => ({
          element, end: Number(element.dataset.stitchEnd), duration: Number(element.dataset.stitchDuration), delay: Number(element.dataset.stitchDelay), parent: Number(element.dataset.stitchParent), began: null, progress: -1
        })));
        this.stitchTime = -1;
        this.loopElapsed = 0;
        this.loopVisible = false;
        this.loopFocus = false;
        this.previous = this.querySelector('[data-journey-previous]');
        this.next = this.querySelector('[data-journey-next]');
        this.counter = this.querySelector('[data-journey-counter]');
        this.status = this.querySelector('[data-journey-status]');
        this.progress = this.querySelector('[data-journey-progress]');
        if (!this.track || !this.stages.length || !this.needle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.lengths = this.paths.map(path => path.getTotalLength());
        this.flourishLength = this.flourish?.getTotalLength() || 0;
        this.position = 0;
        this.target = 0;
        this.maxReached = this.maxReached || 0;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.nodes.forEach((node, index) => {
          node.disabled = false;
          node.addEventListener('click', () => this.select(index), options);
        });
        this.track.addEventListener('scroll', () => {
          if (this.animating || performance.now() < (this.ignoreScrollUntil || 0)) return;
          this.stopLoop(true);
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.scheduleSettle();
        }, { ...options, passive: true });
        const interrupt = () => {
          this.stopLoop(true);
          this.stopMotion();
          this.ignoreScrollUntil = 0;
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.queueLoop(4000);
        };
        this.track.addEventListener('pointerdown', event => {
          this.activePointers.add(event.pointerId);
          this.loopFocus = false;
          interrupt();
        }, { ...options, passive: true });
        const release = event => {
          if (this.activePointers.delete(event.pointerId)) this.scheduleSettle();
        };
        document.addEventListener('pointerup', release, { ...options, passive: true });
        document.addEventListener('pointercancel', release, { ...options, passive: true });
        this.track.addEventListener('wheel', interrupt, { ...options, passive: true });
        this.track.addEventListener('keydown', event => this.onKey(event), options);
        this.reduceMotion.addEventListener('change', () => {
          this.select(this.target, false);
          this.loopButton.hidden = this.reduceMotion.matches;
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopLoop();
            if (this.animating) this.select(this.target, false);
          } else this.queueLoop();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.stages.findIndex(stage => stage.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.controller) this.select(this.target, false);
          });
        });
        this.resizeObserver.observe(this.track);
        this.stages.forEach(stage => this.resizeObserver.observe(stage));
        this.querySelector('[data-journey-controls]').hidden = false;
        this.querySelector('[data-journey-reading]').hidden = false;
        this.loopButton.hidden = this.reduceMotion.matches;
        this.loopButton.addEventListener('click', () => {
          this.loopPaused = !this.loopPaused;
          this.loopButton.setAttribute('aria-label', this.loopPaused ? this.loopButton.dataset.playLabel : this.loopButton.dataset.pauseLabel);
          this.loopButton.querySelector('[data-loop-pause]').hidden = this.loopPaused;
          this.loopButton.querySelector('[data-loop-play]').hidden = !this.loopPaused;
          if (this.loopPaused) this.stopLoop();
          else this.queueLoop(0);
        }, options);
        this.track.addEventListener('focusin', event => {
          this.loopFocus = event.target.matches(':focus-visible');
          if (this.loopFocus) this.stopLoop();
          else this.queueLoop();
        }, options);
        this.track.addEventListener('focusout', event => {
          if (!this.track.contains(event.relatedTarget)) { this.loopFocus = false; this.queueLoop(); }
        }, options);
        this.loopObserver = new IntersectionObserver(entries => {
          this.loopVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          if (this.loopVisible) this.queueLoop();
          else this.stopLoop();
        }, { threshold: [0, .3] });
        this.loopObserver.observe(this.viewport);
        this.classList.add('is-ready');
        this.select(Math.round(this.indexFromScroll()), false);
      }

      scheduleSettle() {
        clearTimeout(this.settleTimer);
        if (!this.activePointers.size) {
          this.settleTimer = setTimeout(() => {
            if (!this.activePointers.size) this.select(this.target);
          }, 170);
        }
      }

      geometry() {
        const bounds = this.track.getBoundingClientRect();
        const left = bounds.left + this.track.clientLeft;
        const right = left + this.track.clientWidth;
        const rects = this.stages.map(stage => stage.getBoundingClientRect());
        const first = rects[0];
        const last = rects[rects.length - 1];
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        return {
          left, right, rects, rtl,
          leftRoom: Math.max(0, left - Math.min(first.left, last.left)),
          rightRoom: Math.max(0, Math.max(first.right, last.right) - right)
        };
      }

      indexFromScroll() {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        return maximum > 1 ? (g.rtl ? g.rightRoom : g.leftRoom) / maximum * (this.stages.length - 1) : this.target || 0;
      }

      setScrollFraction(fraction) {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        const current = g.rtl ? g.rightRoom : g.leftRoom;
        const desired = Math.max(0, Math.min(1, fraction)) * maximum;
        this.track.scrollBy({ left: (desired - current) * (g.rtl ? -1 : 1), behavior: 'instant' });
      }

      move(direction) {
        this.select(this.target + direction);
      }

      select(index, animate = true) {
        this.stopLoop(true);
        this.stopMotion();
        const last = this.stages.length - 1;
        const next = Math.max(0, Math.min(last, index));
        const start = this.position;
        const scrollStart = last ? this.indexFromScroll() / last : 0;
        this.target = next;
        this.previous.disabled = next === 0;
        this.next.disabled = next === last;
        if (!animate || this.reduceMotion.matches || Math.abs(next - start) < .008) {
          this.position = next;
          this.ignoreScrollUntil = performance.now() + 100;
          this.setScrollFraction(last ? next / last : 0);
          this.update();
          this.arrive(next);
          return;
        }
        this.animating = true;
        const began = performance.now();
        const duration = Math.min(1100, 650 + Math.abs(next - start) * 70);
        const ease = value => value < .5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
        const frame = now => {
          if (!this.isConnected || !this.controller) return;
          const t = Math.min(1, (now - began) / duration);
          this.position = start + (next - start) * ease(t);
          const scrollEase = ease(t);
          this.setScrollFraction(scrollStart + ((last ? next / last : 0) - scrollStart) * scrollEase);
          this.update();
          if (t < 1) this.motionFrame = requestAnimationFrame(frame);
          else {
            this.animating = false;
            this.motionFrame = null;
            this.ignoreScrollUntil = performance.now() + 100;
            this.arrive(next);
          }
        };
        this.motionFrame = requestAnimationFrame(frame);
      }

      arrive(index) {
        this.stages.forEach((stage, i) => {
          stage.classList.toggle('is-current', i === index);
          if (i === index) this.nodes[i].setAttribute('aria-current', 'step');
          else this.nodes[i].removeAttribute('aria-current');
        });
        this.stages[index].classList.add('is-stitched');
        this.queueLoop(3000);
      }

      onKey(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target !== this.track && !this.nodes.includes(event.target)) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.loopFocus = true;
        if (event.key === 'Home') this.select(0);
        else if (event.key === 'End') this.select(this.stages.length - 1);
        else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.geometry().rtl ? -1 : 1));
      }

      needlePoint(position) {
        const last = this.stages.length - 1;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const viewport = this.viewport.getBoundingClientRect();
        if (!this.paths.length) {
          const node = this.nodes[0].getBoundingClientRect();
          return { x: node.left - viewport.left + node.width / 2 + (rtl ? -24 : 24), y: node.top - viewport.top + node.height / 2, angle: rtl ? 180 : 0 };
        }
        const visual = position + .085;
        if (visual > last && this.flourish) {
          const bounds = this.flourish.ownerSVGElement.getBoundingClientRect();
          const distance = Math.min(1, (visual - last) / .085) * this.flourishLength;
          const project = value => {
            const p = this.flourish.getPointAtLength(Math.max(0, Math.min(this.flourishLength, value)));
            return { x: (rtl ? bounds.right - p.x / 80 * bounds.width : bounds.left + p.x / 80 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
          };
          const point = project(distance);
          const before = project(distance - 1);
          const after = project(distance + 1);
          return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
        }
        const segment = Math.min(last - 1, Math.max(0, Math.floor(visual)));
        const progress = Math.min(1, visual - segment);
        const path = this.paths[segment];
        const length = this.lengths[segment];
        const bounds = path.ownerSVGElement.getBoundingClientRect();
        const project = distance => {
          const p = path.getPointAtLength(Math.max(0, Math.min(length, distance)));
          return { x: (rtl ? bounds.right - p.x / 240 * bounds.width : bounds.left + p.x / 240 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
        };
        const distance = progress * length;
        const point = project(distance);
        const before = project(distance - 1);
        const after = project(distance + 1);
        return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
      }

      stageFrontX(index, fraction) {
        const final = index === this.stages.length - 1;
        const width = final ? 80 : 240;
        const progress = Math.max(0, Math.min(1, fraction));
        if (progress === 0 || (!final && progress === 1)) return progress * width;
        const guide = final ? this.flourish : this.paths[index];
        const length = final ? this.flourishLength : this.lengths[index];
        return guide ? guide.getPointAtLength(progress * length).x : progress * width;
      }

      resetStitchDetails() {
        this.stitchTime = -1;
        this.stitchDetails?.forEach(strokes => strokes.forEach(stroke => {
          stroke.began = null;
          stroke.progress = -1;
          stroke.element.style.strokeDashoffset = '1';
          stroke.element.style.opacity = '0';
        }));
      }

      drawStitchDetails(index, front, from, time) {
        const scale = index === this.stages.length - 1 ? 1 : 2 / 3;
        const head = front / scale;
        const start = from / scale;
        const strokes = this.stitchDetails[index];
        strokes.forEach(stroke => {
          if (stroke.end <= start) return;
          const parent = strokes[stroke.parent];
          const outlineReady = !parent || parent.end <= start || parent.progress >= .8;
          if (stroke.began === null && head >= stroke.end + .35 && outlineReady) stroke.began = time + stroke.delay;
          const progress = stroke.began === null ? 0 : Math.max(0, Math.min(1, (time - stroke.began) / stroke.duration));
          if (Math.abs(progress - stroke.progress) < .0001) return;
          stroke.progress = progress;
          stroke.element.style.strokeDashoffset = String(1 - progress);
          stroke.element.style.opacity = progress > 0 ? '1' : '0';
        });
      }

      update() {
        const { left, right, rects } = this.geometry();
        if (!this.track.clientWidth) return;
        this.previous.disabled = this.target === 0;
        this.next.disabled = this.target === this.stages.length - 1;
        let visible = rects.reduce((indices, rect, index) => {
          const overlap = Math.max(0, Math.min(rect.right, right) - Math.max(rect.left, left));
          if (overlap >= Math.min(rect.width, right - left) * .5) indices.push(index);
          return indices;
        }, []);
        if (!visible.length) visible = [this.target];
        const start = String(visible[0] + 1).padStart(2, '0');
        const end = String(visible[visible.length - 1] + 1).padStart(2, '0');
        const count = String(this.stages.length).padStart(2, '0');
        const compact = start + '–' + end + ' / ' + count;
        if (this.counter.textContent !== compact) {
          this.counter.textContent = compact;
          this.status.textContent = this.dataset.visibleStages.replaceAll('[start]', start).replaceAll('[end]', end).replaceAll('[count]', count);
        }
        this.maxReached = Math.max(this.maxReached, this.position + .085);
        this.jamaCompleted.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const progress = Math.max(0, Math.min(1, (this.maxReached - index) / (final ? .085 : 1)));
          clip.setAttribute('width', String(this.stageFrontX(index, progress)));
        });
        this.progress.style.setProperty('--kk-sj-progress', String(Math.min(1, (this.maxReached + 1) / this.stages.length)));
        this.stages.forEach((stage, index) => {
          stage.style.setProperty('--kk-sj-stage-progress', String(Math.max(0, Math.min(1, this.maxReached - index))));
          if (this.maxReached >= index + .085) stage.classList.add('is-stitched');
        });
        this.renderNeedle(this.position, this.position >= this.stages.length - 1 ? 0 : 1);
      }

      renderNeedle(position, opacity = 1, time = 0) {
        if (this.reduceMotion.matches || opacity <= 0) {
          this.needle.hidden = true;
          return;
        }
        const point = this.needlePoint(position);
        this.needle.hidden = false;
        this.needle.style.opacity = String(opacity);
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const oscillation = Math.sin(time * Math.PI * 2 / 680) * 3;
        const tilt = direction * (18 + oscillation);
        this.needle.style.transform = 'translate(' + point.x + 'px,' + point.y + 'px) rotate(' + (point.angle + tilt) + 'deg)';
      }

      canLoop() {
        return this.loopButton && this.isConnected && this.controller && this.loopVisible && !this.loopPaused && !this.loopFocus && !this.reduceMotion.matches && !document.hidden && !this.animating && !this.activePointers.size && this.paths.length;
      }

      queueLoop(delay = 1200) {
        clearTimeout(this.loopTimer);
        if (!this.canLoop() || this.loopFrame) return;
        this.loopTimer = setTimeout(() => {
          if (!this.canLoop()) return;
          if (!this.loopRangeCache) this.loopRangeCache = this.makeLoopPlan(this.visibleLoopRange());
          if (this.loopRangeCache.end - this.loopRangeCache.start < .03) return;
          this.loopStamp = 0;
          this.loopFrame = requestAnimationFrame(now => this.drawLoop(now));
        }, delay);
      }

      visibleLoopRange() {
        const bounds = this.viewport.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const last = this.stages.length - 1;
        const margin = Math.min(46, bounds.width / 5);
        let start = null, end = null;
        this.paths.forEach((path, index) => {
          const rect = path.ownerSVGElement.getBoundingClientRect();
          if (rect.right < bounds.left || rect.left > bounds.right) return;
          const length = this.lengths[index];
          for (let sample = 0; sample <= 120; sample++) {
            const progress = sample / 120;
            const point = path.getPointAtLength(length * progress);
            const x = (rtl ? rect.right - point.x / 240 * rect.width : rect.left + point.x / 240 * rect.width) - bounds.left;
            const position = Math.max(0, Math.min(last, index + progress - .085));
            if (x >= margin && x <= bounds.width - margin) {
              if (start === null) start = position;
              end = position;
            }
          }
        });
        if (this.flourish) {
          const final = this.needlePoint(last);
          if (final.x >= margin && final.x <= bounds.width - margin) end = last;
        }
        return { start: start ?? 0, end: end ?? start ?? 0, duration: Math.max(7200, Math.min(16500, (bounds.width - 92) / .075)) };
      }

      makeLoopPlan(range) {
        const boundaries = this.nodes.map((node, index) => index - .085).filter(position => position > range.start && position < range.end);
        const positions = [range.start, ...boundaries, range.end];
        const points = positions.map(position => this.needlePoint(position));
        const total = Math.abs(points[points.length - 1].x - points[0].x) || 1;
        let elapsed = 0;
        const segments = positions.slice(1).map((position, index) => {
          const duration = range.duration * Math.abs(points[index + 1].x - points[index].x) / total;
          const segment = { from: positions[index], to: position, at: elapsed, duration };
          elapsed += duration;
          return segment;
        }).filter(segment => segment.duration > 0);
        return { ...range, duration: elapsed, segments };
      }

      loopPose(time, plan) {
        const segment = plan.segments.find(item => time < item.at + item.duration);
        if (!segment) return plan.end;
        const progress = Math.max(0, Math.min(1, (time - segment.at) / segment.duration));
        return segment.from + (segment.to - segment.from) * progress;
      }

      drawLoop(now) {
        this.loopFrame = null;
        if (!this.canLoop()) { this.loopStamp = 0; return; }
        if (this.loopStamp) this.loopElapsed += Math.min(64, now - this.loopStamp);
        this.loopStamp = now;
        const { start, duration } = this.loopRangeCache;
        const time = this.loopElapsed % (duration + 4200);
        if (time < this.stitchTime) this.resetStitchDetails();
        this.stitchTime = time;
        const position = this.loopPose(time, this.loopRangeCache);
        const opacity = Math.max(0, Math.min(1, time / 400, (duration + 4000 - time) / 1000));
        const needleOpacity = Math.max(0, Math.min(opacity, (duration - time) / 240));
        this.renderNeedle(position, needleOpacity, time);
        const visual = position + .085;
        const tail = start + .085;
        this.jamaMotion.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const span = final ? .085 : 1;
          const width = final ? 80 : 240;
          const from = Math.max(0, Math.min(1, (tail - index) / span));
          const rawFront = this.stageFrontX(index, (visual - index) / span);
          const fromX = this.stageFrontX(index, from);
          const completed = Math.max(0, Math.min(from, (this.maxReached - index) / span));
          this.jamaCompleted[index].setAttribute('width', String(this.stageFrontX(index, completed)));
          const front = Math.max(fromX, Math.min(width, rawFront));
          const edge = 'M' + fromX + ' 0H' + front + 'V48H' + fromX + 'Z';
          clip.setAttribute('d', edge);
          this.drawStitchDetails(index, rawFront, fromX, time);
          this.jamaLayers[index].style.opacity = String(rawFront > fromX ? opacity : 0);
        });
        this.loopFrame = requestAnimationFrame(next => this.drawLoop(next));
      }

      stopLoop(reset = false) {
        cancelAnimationFrame(this.loopFrame);
        clearTimeout(this.loopTimer);
        this.loopFrame = null;
        this.loopStamp = 0;
        if (reset) {
          this.resetStitchDetails();
          this.loopElapsed = 0;
          this.loopRangeCache = null;
          this.jamaLayers?.forEach(layer => { layer.style.opacity = '0'; });
          this.jamaMotion?.forEach(clip => { clip.setAttribute('d', 'M0 0'); });
        }
      }

      stopMotion() {
        cancelAnimationFrame(this.motionFrame);
        clearTimeout(this.settleTimer);
        this.motionFrame = null;
        this.animating = false;
      }

      disconnectedCallback() {
        this.stopLoop();
        this.loopObserver?.disconnect();
        this.stopMotion();
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-sozni-suit-making"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('kk-suit-journey')) {
    customElements.define('kk-suit-journey', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-journey-track]');
        this.viewport = this.querySelector('[data-journey-viewport]');
        this.needle = this.querySelector('[data-journey-needle]');
        this.stages = Array.from(this.querySelectorAll('[data-journey-stage]'));
        this.nodes = Array.from(this.querySelectorAll('[data-journey-choose]'));
        this.paths = Array.from(this.querySelectorAll('[data-journey-guide]'));
        this.flourish = this.querySelector('[data-journey-final-guide]');
        this.activePointers = new Set();
        this.loopButton = this.querySelector('[data-journey-loop]');
        this.jamaCompleted = Array.from(this.querySelectorAll('[data-jama-completed-clip]'));
        this.jamaMotion = Array.from(this.querySelectorAll('[data-jama-motion-clip]'));
        this.jamaLayers = Array.from(this.querySelectorAll('[data-jama-motion-layer]'));
        this.stitchDetails = this.jamaLayers.map(layer => Array.from(layer.querySelectorAll('[data-stitch-detail]'), element => ({
          element, end: Number(element.dataset.stitchEnd), duration: Number(element.dataset.stitchDuration), delay: Number(element.dataset.stitchDelay), parent: Number(element.dataset.stitchParent), began: null, progress: -1
        })));
        this.stitchTime = -1;
        this.loopElapsed = 0;
        this.loopVisible = false;
        this.loopFocus = false;
        this.previous = this.querySelector('[data-journey-previous]');
        this.next = this.querySelector('[data-journey-next]');
        this.counter = this.querySelector('[data-journey-counter]');
        this.status = this.querySelector('[data-journey-status]');
        this.progress = this.querySelector('[data-journey-progress]');
        if (!this.track || !this.stages.length || !this.needle) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.lengths = this.paths.map(path => path.getTotalLength());
        this.flourishLength = this.flourish?.getTotalLength() || 0;
        this.position = 0;
        this.target = 0;
        this.maxReached = this.maxReached || 0;
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.nodes.forEach((node, index) => {
          node.disabled = false;
          node.addEventListener('click', () => this.select(index), options);
        });
        this.track.addEventListener('scroll', () => {
          if (this.animating || performance.now() < (this.ignoreScrollUntil || 0)) return;
          this.stopLoop(true);
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.scheduleSettle();
        }, { ...options, passive: true });
        const interrupt = () => {
          this.stopLoop(true);
          this.stopMotion();
          this.ignoreScrollUntil = 0;
          this.position = this.indexFromScroll();
          this.target = Math.round(this.position);
          this.update();
          this.queueLoop(4000);
        };
        this.track.addEventListener('pointerdown', event => {
          this.activePointers.add(event.pointerId);
          this.loopFocus = false;
          interrupt();
        }, { ...options, passive: true });
        const release = event => {
          if (this.activePointers.delete(event.pointerId)) this.scheduleSettle();
        };
        document.addEventListener('pointerup', release, { ...options, passive: true });
        document.addEventListener('pointercancel', release, { ...options, passive: true });
        this.track.addEventListener('wheel', interrupt, { ...options, passive: true });
        this.track.addEventListener('keydown', event => this.onKey(event), options);
        this.reduceMotion.addEventListener('change', () => {
          this.select(this.target, false);
          this.loopButton.hidden = this.reduceMotion.matches;
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopLoop();
            if (this.animating) this.select(this.target, false);
          } else this.queueLoop();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.stages.findIndex(stage => stage.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.controller) this.select(this.target, false);
          });
        });
        this.resizeObserver.observe(this.track);
        this.stages.forEach(stage => this.resizeObserver.observe(stage));
        this.querySelector('[data-journey-controls]').hidden = false;
        this.querySelector('[data-journey-reading]').hidden = false;
        this.loopButton.hidden = this.reduceMotion.matches;
        this.loopButton.addEventListener('click', () => {
          this.loopPaused = !this.loopPaused;
          this.loopButton.setAttribute('aria-label', this.loopPaused ? this.loopButton.dataset.playLabel : this.loopButton.dataset.pauseLabel);
          this.loopButton.querySelector('[data-loop-pause]').hidden = this.loopPaused;
          this.loopButton.querySelector('[data-loop-play]').hidden = !this.loopPaused;
          if (this.loopPaused) this.stopLoop();
          else this.queueLoop(0);
        }, options);
        this.track.addEventListener('focusin', event => {
          this.loopFocus = event.target.matches(':focus-visible');
          if (this.loopFocus) this.stopLoop();
          else this.queueLoop();
        }, options);
        this.track.addEventListener('focusout', event => {
          if (!this.track.contains(event.relatedTarget)) { this.loopFocus = false; this.queueLoop(); }
        }, options);
        this.loopObserver = new IntersectionObserver(entries => {
          this.loopVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          if (this.loopVisible) this.queueLoop();
          else this.stopLoop();
        }, { threshold: [0, .3] });
        this.loopObserver.observe(this.viewport);
        this.classList.add('is-ready');
        this.select(Math.round(this.indexFromScroll()), false);
      }

      scheduleSettle() {
        clearTimeout(this.settleTimer);
        if (!this.activePointers.size) {
          this.settleTimer = setTimeout(() => {
            if (!this.activePointers.size) this.select(this.target);
          }, 170);
        }
      }

      geometry() {
        const bounds = this.track.getBoundingClientRect();
        const left = bounds.left + this.track.clientLeft;
        const right = left + this.track.clientWidth;
        const rects = this.stages.map(stage => stage.getBoundingClientRect());
        const first = rects[0];
        const last = rects[rects.length - 1];
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        return {
          left, right, rects, rtl,
          leftRoom: Math.max(0, left - Math.min(first.left, last.left)),
          rightRoom: Math.max(0, Math.max(first.right, last.right) - right)
        };
      }

      indexFromScroll() {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        return maximum > 1 ? (g.rtl ? g.rightRoom : g.leftRoom) / maximum * (this.stages.length - 1) : this.target || 0;
      }

      setScrollFraction(fraction) {
        const g = this.geometry();
        const maximum = g.leftRoom + g.rightRoom;
        const current = g.rtl ? g.rightRoom : g.leftRoom;
        const desired = Math.max(0, Math.min(1, fraction)) * maximum;
        this.track.scrollBy({ left: (desired - current) * (g.rtl ? -1 : 1), behavior: 'instant' });
      }

      move(direction) {
        this.select(this.target + direction);
      }

      select(index, animate = true) {
        this.stopLoop(true);
        this.stopMotion();
        const last = this.stages.length - 1;
        const next = Math.max(0, Math.min(last, index));
        const start = this.position;
        const scrollStart = last ? this.indexFromScroll() / last : 0;
        this.target = next;
        this.previous.disabled = next === 0;
        this.next.disabled = next === last;
        if (!animate || this.reduceMotion.matches || Math.abs(next - start) < .008) {
          this.position = next;
          this.ignoreScrollUntil = performance.now() + 100;
          this.setScrollFraction(last ? next / last : 0);
          this.update();
          this.arrive(next);
          return;
        }
        this.animating = true;
        const began = performance.now();
        const duration = Math.min(1100, 650 + Math.abs(next - start) * 70);
        const ease = value => value < .5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;
        const frame = now => {
          if (!this.isConnected || !this.controller) return;
          const t = Math.min(1, (now - began) / duration);
          this.position = start + (next - start) * ease(t);
          const scrollEase = ease(t);
          this.setScrollFraction(scrollStart + ((last ? next / last : 0) - scrollStart) * scrollEase);
          this.update();
          if (t < 1) this.motionFrame = requestAnimationFrame(frame);
          else {
            this.animating = false;
            this.motionFrame = null;
            this.ignoreScrollUntil = performance.now() + 100;
            this.arrive(next);
          }
        };
        this.motionFrame = requestAnimationFrame(frame);
      }

      arrive(index) {
        this.stages.forEach((stage, i) => {
          stage.classList.toggle('is-current', i === index);
          if (i === index) this.nodes[i].setAttribute('aria-current', 'step');
          else this.nodes[i].removeAttribute('aria-current');
        });
        this.stages[index].classList.add('is-stitched');
        this.queueLoop(3000);
      }

      onKey(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target !== this.track && !this.nodes.includes(event.target)) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.loopFocus = true;
        if (event.key === 'Home') this.select(0);
        else if (event.key === 'End') this.select(this.stages.length - 1);
        else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.geometry().rtl ? -1 : 1));
      }

      needlePoint(position) {
        const last = this.stages.length - 1;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const viewport = this.viewport.getBoundingClientRect();
        if (!this.paths.length) {
          const node = this.nodes[0].getBoundingClientRect();
          return { x: node.left - viewport.left + node.width / 2 + (rtl ? -24 : 24), y: node.top - viewport.top + node.height / 2, angle: rtl ? 180 : 0 };
        }
        const visual = position + .085;
        if (visual > last && this.flourish) {
          const bounds = this.flourish.ownerSVGElement.getBoundingClientRect();
          const distance = Math.min(1, (visual - last) / .085) * this.flourishLength;
          const project = value => {
            const p = this.flourish.getPointAtLength(Math.max(0, Math.min(this.flourishLength, value)));
            return { x: (rtl ? bounds.right - p.x / 80 * bounds.width : bounds.left + p.x / 80 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
          };
          const point = project(distance);
          const before = project(distance - 1);
          const after = project(distance + 1);
          return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
        }
        const segment = Math.min(last - 1, Math.max(0, Math.floor(visual)));
        const progress = Math.min(1, visual - segment);
        const path = this.paths[segment];
        const length = this.lengths[segment];
        const bounds = path.ownerSVGElement.getBoundingClientRect();
        const project = distance => {
          const p = path.getPointAtLength(Math.max(0, Math.min(length, distance)));
          return { x: (rtl ? bounds.right - p.x / 240 * bounds.width : bounds.left + p.x / 240 * bounds.width) - viewport.left, y: bounds.top + p.y / 48 * bounds.height - viewport.top };
        };
        const distance = progress * length;
        const point = project(distance);
        const before = project(distance - 1);
        const after = project(distance + 1);
        return { ...point, angle: Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI };
      }

      stageFrontX(index, fraction) {
        const final = index === this.stages.length - 1;
        const width = final ? 80 : 240;
        const progress = Math.max(0, Math.min(1, fraction));
        if (progress === 0 || (!final && progress === 1)) return progress * width;
        const guide = final ? this.flourish : this.paths[index];
        const length = final ? this.flourishLength : this.lengths[index];
        return guide ? guide.getPointAtLength(progress * length).x : progress * width;
      }

      resetStitchDetails() {
        this.stitchTime = -1;
        this.stitchDetails?.forEach(strokes => strokes.forEach(stroke => {
          stroke.began = null;
          stroke.progress = -1;
          stroke.element.style.strokeDashoffset = '1';
          stroke.element.style.opacity = '0';
        }));
      }

      drawStitchDetails(index, front, from, time) {
        const scale = index === this.stages.length - 1 ? 1 : 2 / 3;
        const head = front / scale;
        const start = from / scale;
        const strokes = this.stitchDetails[index];
        strokes.forEach(stroke => {
          if (stroke.end <= start) return;
          const parent = strokes[stroke.parent];
          const outlineReady = !parent || parent.end <= start || parent.progress >= .8;
          if (stroke.began === null && head >= stroke.end + .35 && outlineReady) stroke.began = time + stroke.delay;
          const progress = stroke.began === null ? 0 : Math.max(0, Math.min(1, (time - stroke.began) / stroke.duration));
          if (Math.abs(progress - stroke.progress) < .0001) return;
          stroke.progress = progress;
          stroke.element.style.strokeDashoffset = String(1 - progress);
          stroke.element.style.opacity = progress > 0 ? '1' : '0';
        });
      }

      update() {
        const { left, right, rects } = this.geometry();
        if (!this.track.clientWidth) return;
        this.previous.disabled = this.target === 0;
        this.next.disabled = this.target === this.stages.length - 1;
        let visible = rects.reduce((indices, rect, index) => {
          const overlap = Math.max(0, Math.min(rect.right, right) - Math.max(rect.left, left));
          if (overlap >= Math.min(rect.width, right - left) * .5) indices.push(index);
          return indices;
        }, []);
        if (!visible.length) visible = [this.target];
        const start = String(visible[0] + 1).padStart(2, '0');
        const end = String(visible[visible.length - 1] + 1).padStart(2, '0');
        const count = String(this.stages.length).padStart(2, '0');
        const compact = start + '–' + end + ' / ' + count;
        if (this.counter.textContent !== compact) {
          this.counter.textContent = compact;
          this.status.textContent = this.dataset.visibleStages.replaceAll('[start]', start).replaceAll('[end]', end).replaceAll('[count]', count);
        }
        this.maxReached = Math.max(this.maxReached, this.position + .085);
        this.jamaCompleted.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const progress = Math.max(0, Math.min(1, (this.maxReached - index) / (final ? .085 : 1)));
          clip.setAttribute('width', String(this.stageFrontX(index, progress)));
        });
        this.progress.style.setProperty('--kk-sj-progress', String(Math.min(1, (this.maxReached + 1) / this.stages.length)));
        this.stages.forEach((stage, index) => {
          stage.style.setProperty('--kk-sj-stage-progress', String(Math.max(0, Math.min(1, this.maxReached - index))));
          if (this.maxReached >= index + .085) stage.classList.add('is-stitched');
        });
        this.renderNeedle(this.position, this.position >= this.stages.length - 1 ? 0 : 1);
      }

      renderNeedle(position, opacity = 1, time = 0) {
        if (this.reduceMotion.matches || opacity <= 0) {
          this.needle.hidden = true;
          return;
        }
        const point = this.needlePoint(position);
        this.needle.hidden = false;
        this.needle.style.opacity = String(opacity);
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const oscillation = Math.sin(time * Math.PI * 2 / 680) * 3;
        const tilt = direction * (18 + oscillation);
        this.needle.style.transform = 'translate(' + point.x + 'px,' + point.y + 'px) rotate(' + (point.angle + tilt) + 'deg)';
      }

      canLoop() {
        return this.loopButton && this.isConnected && this.controller && this.loopVisible && !this.loopPaused && !this.loopFocus && !this.reduceMotion.matches && !document.hidden && !this.animating && !this.activePointers.size && this.paths.length;
      }

      queueLoop(delay = 1200) {
        clearTimeout(this.loopTimer);
        if (!this.canLoop() || this.loopFrame) return;
        this.loopTimer = setTimeout(() => {
          if (!this.canLoop()) return;
          if (!this.loopRangeCache) this.loopRangeCache = this.makeLoopPlan(this.visibleLoopRange());
          if (this.loopRangeCache.end - this.loopRangeCache.start < .03) return;
          this.loopStamp = 0;
          this.loopFrame = requestAnimationFrame(now => this.drawLoop(now));
        }, delay);
      }

      visibleLoopRange() {
        const bounds = this.viewport.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const last = this.stages.length - 1;
        const margin = Math.min(46, bounds.width / 5);
        let start = null, end = null;
        this.paths.forEach((path, index) => {
          const rect = path.ownerSVGElement.getBoundingClientRect();
          if (rect.right < bounds.left || rect.left > bounds.right) return;
          const length = this.lengths[index];
          for (let sample = 0; sample <= 120; sample++) {
            const progress = sample / 120;
            const point = path.getPointAtLength(length * progress);
            const x = (rtl ? rect.right - point.x / 240 * rect.width : rect.left + point.x / 240 * rect.width) - bounds.left;
            const position = Math.max(0, Math.min(last, index + progress - .085));
            if (x >= margin && x <= bounds.width - margin) {
              if (start === null) start = position;
              end = position;
            }
          }
        });
        if (this.flourish) {
          const final = this.needlePoint(last);
          if (final.x >= margin && final.x <= bounds.width - margin) end = last;
        }
        return { start: start ?? 0, end: end ?? start ?? 0, duration: Math.max(7200, Math.min(16500, (bounds.width - 92) / .075)) };
      }

      makeLoopPlan(range) {
        const boundaries = this.nodes.map((node, index) => index - .085).filter(position => position > range.start && position < range.end);
        const positions = [range.start, ...boundaries, range.end];
        const points = positions.map(position => this.needlePoint(position));
        const total = Math.abs(points[points.length - 1].x - points[0].x) || 1;
        let elapsed = 0;
        const segments = positions.slice(1).map((position, index) => {
          const duration = range.duration * Math.abs(points[index + 1].x - points[index].x) / total;
          const segment = { from: positions[index], to: position, at: elapsed, duration };
          elapsed += duration;
          return segment;
        }).filter(segment => segment.duration > 0);
        return { ...range, duration: elapsed, segments };
      }

      loopPose(time, plan) {
        const segment = plan.segments.find(item => time < item.at + item.duration);
        if (!segment) return plan.end;
        const progress = Math.max(0, Math.min(1, (time - segment.at) / segment.duration));
        return segment.from + (segment.to - segment.from) * progress;
      }

      drawLoop(now) {
        this.loopFrame = null;
        if (!this.canLoop()) { this.loopStamp = 0; return; }
        if (this.loopStamp) this.loopElapsed += Math.min(64, now - this.loopStamp);
        this.loopStamp = now;
        const { start, duration } = this.loopRangeCache;
        const time = this.loopElapsed % (duration + 4200);
        if (time < this.stitchTime) this.resetStitchDetails();
        this.stitchTime = time;
        const position = this.loopPose(time, this.loopRangeCache);
        const opacity = Math.max(0, Math.min(1, time / 400, (duration + 4000 - time) / 1000));
        const needleOpacity = Math.max(0, Math.min(opacity, (duration - time) / 240));
        this.renderNeedle(position, needleOpacity, time);
        const visual = position + .085;
        const tail = start + .085;
        this.jamaMotion.forEach((clip, index) => {
          const final = index === this.stages.length - 1;
          const span = final ? .085 : 1;
          const width = final ? 80 : 240;
          const from = Math.max(0, Math.min(1, (tail - index) / span));
          const rawFront = this.stageFrontX(index, (visual - index) / span);
          const fromX = this.stageFrontX(index, from);
          const completed = Math.max(0, Math.min(from, (this.maxReached - index) / span));
          this.jamaCompleted[index].setAttribute('width', String(this.stageFrontX(index, completed)));
          const front = Math.max(fromX, Math.min(width, rawFront));
          const edge = 'M' + fromX + ' 0H' + front + 'V48H' + fromX + 'Z';
          clip.setAttribute('d', edge);
          this.drawStitchDetails(index, rawFront, fromX, time);
          this.jamaLayers[index].style.opacity = String(rawFront > fromX ? opacity : 0);
        });
        this.loopFrame = requestAnimationFrame(next => this.drawLoop(next));
      }

      stopLoop(reset = false) {
        cancelAnimationFrame(this.loopFrame);
        clearTimeout(this.loopTimer);
        this.loopFrame = null;
        this.loopStamp = 0;
        if (reset) {
          this.resetStitchDetails();
          this.loopElapsed = 0;
          this.loopRangeCache = null;
          this.jamaLayers?.forEach(layer => { layer.style.opacity = '0'; });
          this.jamaMotion?.forEach(clip => { clip.setAttribute('d', 'M0 0'); });
        }
      }

      stopMotion() {
        cancelAnimationFrame(this.motionFrame);
        clearTimeout(this.settleTimer);
        this.motionFrame = null;
        this.animating = false;
      }

      disconnectedCallback() {
        this.stopLoop();
        this.loopObserver?.disconnect();
        this.stopMotion();
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-tilla-animation"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('kk-tilla-animation')) {
  class KKTillaAnimation extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.stage = 0;
      this.elapsed = 0;
      this.duration = Math.max(8, Number(this.dataset.duration) || 12) * 1000;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches || this.dataset.autoplay === 'false';
      this.visible = true;
      this.scenes = Array.from(this.querySelectorAll('[data-scene]'));
      this.steps = Array.from(this.querySelectorAll('[data-step]'));
      this.captions = Array.from(this.querySelectorAll('[data-caption]'));
      this.cues = Array.from(this.querySelectorAll('[data-cue]'));
      this.toggle = this.querySelector('[data-toggle]');
      this.abort = new AbortController();
      const opts = {signal: this.abort.signal};
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.syncButton();
        this.last = 0;
        this.schedule();
      }, opts);
      this.steps.forEach((button, index) => {
        button.addEventListener('click', () => this.select(index, true), opts);
        button.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % 8;
          if (event.key === 'ArrowLeft') next = (index + 7) % 8;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = 7;
          if (next !== undefined) {
            event.preventDefault();
            this.steps[next].focus();
            this.select(next, true);
          }
        }, opts);
      });
      this.onVisibility = () => {this.last = 0; this.schedule();};
      document.addEventListener('visibilitychange', this.onVisibility, opts);
      this.onMotion = () => {
        if (this.motion.matches) {
          this.paused = true;
          this.elapsed = this.duration * .84;
          this.syncButton();
          this.render(.84);
        }
      };
      this.motion.addEventListener('change', this.onMotion, opts);
      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.last = 0;
        this.schedule();
      }, {threshold: .04});
      this.observer.observe(this);
      this.prepare();
      this.select(0, false);
      this.syncButton();
      this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.last = 0;
      this.ready = false;
    }
    schedule() {
      if (this.raf || this.paused || !this.visible || document.hidden || !this.isConnected) return;
      this.raf = requestAnimationFrame((now) => this.tick(now));
    }
    tick(now) {
      this.raf = 0;
      if (this.paused || !this.visible || document.hidden || !this.isConnected) {this.last = 0; return;}
      if (this.last && now - this.last < 32) {this.schedule(); return;}
      if (this.last) this.elapsed += Math.min(80, now - this.last);
      this.last = now;
      if (this.elapsed >= this.duration) this.select((this.stage + 1) % 8, false);
      this.render(this.elapsed / this.duration);
      this.schedule();
    }
    select(index, manual) {
      this.stage = index;
      this.elapsed = this.paused ? this.duration * .84 : 0;
      this.last = 0;
      this.scenes.forEach((scene, i) => {scene.hidden = i !== index; scene.toggleAttribute('hidden', i !== index);});
      this.captions.forEach((caption, i) => caption.hidden = i !== index);
      this.cues.forEach((cue, i) => cue.hidden = i !== index);
      this.steps.forEach((button, i) => {
        button.setAttribute('aria-pressed', String(i === index));
        button.querySelector('.kk-ta-step-track>span').style.transform = 'scaleX(0)';
      });
      this.querySelector('[data-stage-number]').textContent = String(index + 1).padStart(2, '0');
      if (manual) this.querySelector('.kk-ta-story').setAttribute('aria-live', 'polite');
      else this.querySelector('.kk-ta-story').setAttribute('aria-live', 'off');
      this.render(this.elapsed / this.duration);
      this.schedule();
    }
    syncButton() {
      this.classList.toggle('is-paused', this.paused);
      const label = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.toggle.setAttribute('aria-label', label);
      this.querySelector('[data-toggle-text]').textContent = label;
    }
    element(name, scene = this.scenes[this.stage]) {return scene.querySelector('[' + name + ']');}
    node(tag, attrs) {
      const n = document.createElementNS('http://www.w3.org/2000/svg', tag);
      Object.entries(attrs).forEach(([key,value]) => n.setAttribute(key, value));
      return n;
    }
    prepare() {
      this.drawPaths = Array.from(this.querySelectorAll('[data-draw], [data-laid-gold], [data-laid-highlight], [data-building]'));
      this.drawPaths.forEach(path => {path._length = path.getTotalLength();path.style.strokeDasharray = path._length;});
      this.outline = this.element('data-draw="main"', this.scenes[0]);
      this.outlineLength = this.outline.getTotalLength();
      this.tracePaths = Array.from(this.scenes[0].querySelectorAll('[data-draw]'));
      this.traceLength = this.tracePaths.reduce((n,path) => n + path._length, 0);
      const holes = this.element('data-holes', this.scenes[1]);
      holes.replaceChildren();
      this.holes = [];
      for (let i=0;i<170;i++) {
        const point = this.tracePoint(i / 169);
        const circle = this.node('circle',{cx:point.x,cy:point.y,r:1.35,fill:'#6b6050'});
        holes.append(circle);
        this.holes.push(circle);
      }
      this.powder = this.element('data-powder', this.scenes[2]);
      this.powder.replaceChildren();
      for (let i=0;i<75;i++) {
        const x = 292 + (i*71%287), y = 123 + (i*47%283);
        this.powder.append(this.node('circle',{cx:x,cy:y,r:.75+(i%3)*.35,fill:'#e9dfce',opacity:.7}));
      }
      const wraps = this.element('data-metal-wraps', this.scenes[5]);
      wraps.replaceChildren();
      for (let x=220;x<786;x+=7) wraps.append(this.node('path',{d:`M${x} ${this.goldY(x)-5}l-2 9`,stroke:'#926c32','stroke-width':.7,opacity:.6}));
      const motifTacks = this.element('data-motif-tacks', this.scenes[6]);
      motifTacks.replaceChildren();
      for (let i=0;i<55;i++) {
        const l = this.outlineLength*i/55;
        const p = this.outline.getPointAtLength(l), q = this.outline.getPointAtLength(Math.min(l+1,this.outlineLength));
        const a = Math.atan2(q.y-p.y,q.x-p.x)+Math.PI/2;
        motifTacks.append(this.node('path',{d:`M${p.x-Math.cos(a)*2.6} ${p.y-Math.sin(a)*2.6}l${Math.cos(a)*5.2} ${Math.sin(a)*5.2}`,stroke:'#f0dcb0','stroke-width':.7,opacity:.8}));
      }
      this.tacks = this.element('data-tacks', this.scenes[5]);
      this.tacks.replaceChildren();
      for(let i=0;i<6;i++) {
        const x=315+i*70, y=this.goldY(x);
        this.tacks.append(this.node('path',{d:`M${x-2} ${y-17}Q${x+1} ${y-3} ${x+3} ${y+18}`,stroke:'#efdbb4','stroke-width':2.2,fill:'none','stroke-linecap':'round'}));
      }
    }
    tracePoint(amount) {
      let distance = this.clamp(amount) * this.traceLength;
      for (const path of this.tracePaths) {
        if (distance <= path._length) return path.getPointAtLength(distance);
        distance -= path._length;
      }
      const last = this.tracePaths[this.tracePaths.length - 1];
      return last.getPointAtLength(last._length);
    }
    goldY(x) {return 280 - Math.sin((x-211)/581*Math.PI*2)*4 - (x-211)/581*6;}
    clamp(value) {return Math.max(0,Math.min(1,value));}
    draw(path, amount) {path.style.strokeDashoffset = path._length * (1-this.clamp(amount));}
    render(progress) {
      const p = this.clamp(progress), s = this.scenes[this.stage], get = name => this.element(name,s);
      this.steps[this.stage].querySelector('.kk-ta-step-track>span').style.transform = `scaleX(${p})`;
      if (this.stage === 0) {
        const paths = Array.from(s.querySelectorAll('[data-draw]'));
        const total = paths.reduce((n,path)=>n+path._length,0), done = this.clamp(p/.87)*total;
        let at = 0, active=paths[0], local=0;
        paths.forEach(path=>{const a=(done-at)/path._length;this.draw(path,a);if(a>=0){active=path;local=this.clamp(a);}at+=path._length;});
        const point=active.getPointAtLength(active._length*local);
        get('data-pencil').setAttribute('transform',`translate(${point.x} ${point.y}) rotate(32)`);
        get('data-pencil').style.opacity = p>.94 ? String((1-p)/.06) : '1';
      }
      if (this.stage === 1) {
        const amount = this.clamp(p/.9), count = Math.floor(amount * 169), point=this.tracePoint(count/169);
        this.holes.forEach((circle,i)=>circle.style.opacity=i<=count?'1':'0');
        const lift=Math.sin((amount*169%1)*Math.PI)*12;
        get('data-pricker').setAttribute('transform',`translate(${point.x} ${point.y-lift}) rotate(16)`);
      }
      if (this.stage === 2) {
        const lift=this.clamp((p-.62)/.23), track=this.clamp(p/.62), point=this.outline.getPointAtLength(this.outlineLength*track);
        get('data-transfer-paper').setAttribute('transform',`translate(${lift*120} ${-lift*160}) rotate(${lift*11} 643 35)`);
        get('data-transfer-paper').style.opacity=String(1-lift);
        get('data-transfer-dots').style.opacity=String(this.clamp(p/.44));
        get('data-duster').setAttribute('transform',`translate(${point.x} ${point.y-12-Math.abs(Math.sin(p*62))*11}) rotate(${Math.sin(p*28)*5})`);
        get('data-duster').style.opacity=String(1-this.clamp((p-.55)/.12));
        this.powder.style.opacity=String(this.clamp(p/.4));
      }
      if (this.stage === 3) {
        const wave=Math.sin(p*Math.PI*2)*8;
        get('data-thread-gold').setAttribute('d',`M294 257C395 ${292+wave} 255 ${319-wave} 274 357C287 ${387+wave/2} 387 335 437 367`);
        get('data-thread-fine').setAttribute('d',`M689 214C619 ${250+wave} 599 ${294-wave} 639 309C677 ${323+wave} 747 245 777 247C814 250 825 279 800 280`);
      }
      if (this.stage === 4) {
        const amount=this.clamp(p/.88), path=get('data-laid-gold'), point=path.getPointAtLength(path._length*amount);
        this.draw(path,amount);this.draw(get('data-laid-highlight'),amount);
        get('data-feed-line').setAttribute('d',`M855 104C${820-amount*80} ${135+amount*40} ${point.x+120} ${point.y-70} ${point.x} ${point.y}`);
        get('data-laying-point').setAttribute('cx',point.x);get('data-laying-point').setAttribute('cy',point.y);
      }
      if (this.stage === 5) {
        const cycle=this.clamp(p/.95)*6, done=Math.min(5,Math.floor(cycle)), q=cycle-done, x=315+done*70, y=this.goldY(x);
        Array.from(this.tacks.children).forEach((tack,i)=>tack.style.opacity=i<done || (i===done && q>.84)?'1':'0');
        get('data-couch-holes').setAttribute('transform',`translate(${x-320} ${y-278})`);
        const needle=get('data-couch-needle'), loop=get('data-couch-loop');
        const sweep=this.clamp((q-.22)/.42), drop=this.clamp((q-.66)/.18), tipX=x-1+sweep*5, tipY=y-17+sweep*36+drop*27;
        const tilt=20-sweep*36, lift=Math.sin(this.clamp(q/.25)*Math.PI/2)*22*(1-sweep);
        needle.setAttribute('transform',`translate(${tipX} ${tipY-lift}) rotate(${tilt}) scale(.65)`);
        needle.style.opacity=q>.86?'0':String(Math.min(1,q/.10)*(1-drop));
        get('data-under-thread').setAttribute('d',`M${x-70+3} ${this.goldY(x-70)+18}C${x-48} ${y+41} ${x-28} ${y-30} ${x-2} ${y-17}`);
        get('data-under-thread').style.opacity=done>0?'.34':'0';
        const eyeX=tipX+Math.sin(tilt*Math.PI/180)*56, eyeY=tipY-lift-Math.cos(tilt*Math.PI/180)*56;
        const tighten=this.clamp((q-.68)/.2);
        const endX=eyeX*(1-tighten)+(x+3)*tighten, endY=eyeY*(1-tighten)+(y+18)*tighten;
        const arch=(1-tighten)*55;
        loop.setAttribute('d',`M${x-2} ${y-17}C${x-50*(1-tighten)} ${y-65-arch} ${endX+65*(1-tighten)} ${endY-40*(1-tighten)} ${endX} ${endY}`);
        loop.style.opacity=q>.87?'0':'1';
      }
      if (this.stage === 6) {
        const paths=Array.from(s.querySelectorAll('[data-building]')), total=paths.reduce((n,path)=>n+path._length,0), done=this.clamp(p/.77)*total;
        let at=0,active=paths[0],local=0;
        paths.forEach(path=>{const a=(done-at)/path._length;this.draw(path,a);if(a>=0){active=path;local=this.clamp(a);}at+=path._length;});
        const point=active.getPointAtLength(active._length*local);
        get('data-working-thread').setAttribute('d',`M854 388C760 457 ${point.x+150} ${point.y-80} ${point.x} ${point.y}`);
        const fineLift=Math.abs(Math.sin(p*95))*7;
        get('data-embroidery-needle').setAttribute('transform',`translate(${point.x+5} ${point.y+6-fineLift}) rotate(27) scale(.62)`);
        get('data-embroidery-fine').setAttribute('d',`M${point.x-4} ${point.y-4}C${point.x-30} ${point.y-60} ${point.x+54} ${point.y-72} ${point.x+29.5} ${point.y-42-fineLift}`);
        get('data-embroidery-fine').style.opacity=p>.79?'0':'1';
        get('data-working-thread').style.opacity=p>.79?'0':'1';
        get('data-embroidery-needle').style.opacity=p>.79?'0':'1';
        get('data-motif-border').style.opacity=String(this.clamp((p-.77)/.16));
      }
      if (this.stage === 7) {
        const drift=Math.sin(p*Math.PI*2)*1.5;
        get('data-finished-shawl').setAttribute('transform',`rotate(${drift*.24} 500 250)`);
        get('data-inspection').setAttribute('transform',`translate(${-p*235} ${Math.sin(p*Math.PI)*-30})`);
        get('data-inspection').style.opacity=String(this.clamp((.87-p)/.12));
        get('data-shawl-glow').setAttribute('transform',`translate(${p*260} 0)`);
        get('data-shawl-glow').style.opacity=String(.025+Math.sin(p*Math.PI)*.035);
      }
    }
  }
  customElements.define('kk-tilla-animation', KKTillaAnimation);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    let refreshTimer;

    // The gift app updates the cart after this page's normal quantity-change reload.
    const refreshEmptyCart = () => {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(async () => {
        const cartPage = document.querySelector('[data-kk-cart-page]');
        const lineItems = cartPage?.querySelectorAll('line-item');
        if (!lineItems?.length || Array.from(lineItems).some(item => !item.hasAttribute('data-kk-complimentary'))) return;

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' });
          if (response.ok && (await response.json()).item_count === 0) window.location.reload();
        } catch {
          // Keep the current cart usable if the refresh check cannot reach Shopify.
        }
      }, 150);
    };
    document.addEventListener('cart:refresh', refreshEmptyCart, true);
    refreshEmptyCart();
  })();

  } catch(e) { console.error(e); }
})();
})();
